/* Admin → Tableros personales: motor de la pantalla (lo monta Tableros.vue).
   Sale de la demo aprobada (OneDrive\Desktop\crm-equipo/app.js): mismo HTML y
   mismas reglas; lo que cambió es la capa de datos, que ahora es la API
   (TablerosController, admin/tableros…). Cada cambio se ve al instante y se
   manda a la API; si la API lo rechaza, se avisa y se vuelve a cargar el
   tablero tal como está en el servidor. Los permisos los decide la API (rol
   dueno | editar | ver | super); acá solo se esconden los botones que no corresponden.

   montar(raiz, { api, navegar }) → { ir(id, tarjeta), destruir() }
     api.get/post/put/del(ruta, body) → data   (lanza { status, data } si falla)
     api.subir(ruta, FormData) → data          api.blob(ruta) → Blob
     navegar(id | 0)                           cambia la URL (/admin/tableros/:id) */
export function montar(raiz, opciones) {
'use strict';
const api = opciones.api;

const COLORES = [['gray', 'Gris'], ['blue', 'Azul'], ['violet', 'Violeta'], ['orange', 'Naranjo'], ['teal', 'Turquesa'], ['green', 'Verde'], ['red', 'Rojo'], ['pink', 'Magenta'], ['amber', 'Ámbar']];
const COLOR_NOMBRE = Object.fromEntries(COLORES);
const TIPOS = [['texto', 'Texto'], ['largo', 'Texto largo'], ['numero', 'Número'], ['fecha', 'Fecha'], ['lista', 'Lista (una opción)'], ['multi', 'Etiquetas (varias)'], ['persona', 'Persona'], ['correo', 'Correo'], ['telefono', 'Teléfono'], ['enlace', 'Enlace'], ['casilla', 'Casilla (sí / no)']];
const TEXTOS = new Set(['texto', 'largo', 'correo', 'telefono', 'enlace']);
// Admins del panel (GET admin/tableros → admins). El color sale del id.
let ADMINS = [];
const GRADS = ['#d0358f,#9c1767', '#4a7bd6,#2f5fb8', '#17a39a,#0d837c', '#8b5cf6,#6d3ce0', '#f5a524,#c27b06', '#1fa971,#1a8a5e', '#e2574c,#c23a2d', '#5b6b7f,#3d4a5c'];
function ponerAdmins(lista, yoId) {
    ADMINS = (lista || []).map(a => ({ ...a, av: a.id === yoId ? 'linear-gradient(135deg,#ff8414,#e8640a)' : `linear-gradient(135deg,${GRADS[a.id % GRADS.length]})` }));
}
const PRESETS = [['Por hacer', 'gray'], ['En curso', 'blue'], ['Hecho', 'green']];

const ic = p => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${p}</svg>`;
const I = {
    plus: ic('<path d="M12 5v14M5 12h14"/>'), x: ic('<path d="M6 6l12 12M18 6 6 18"/>'),
    back: ic('<path d="M19 12H5m6-6-6 6 6 6"/>'), arrow: ic('<path d="M5 12h14m-6-6 6 6-6 6"/>'),
    chev: ic('<path d="m9 6 6 6-6 6"/>'), down: ic('<path d="m6 9 6 6 6-6"/>'), up: ic('<path d="m6 15 6-6 6 6"/>'),
    left: ic('<path d="m15 6-6 6 6 6"/>'), right: ic('<path d="m9 6 6 6-6 6"/>'),
    more: ic('<circle cx="5" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.6" fill="currentColor" stroke="none"/>'),
    trash: ic('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>'), edit: ic('<path d="M4 20h4L19 9l-4-4L4 16v4Z"/>'),
    search: ic('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'), check: ic('<path d="m5 12 5 5 9-10"/>'),
    clock: ic('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'), cal: ic('<rect x="3.5" y="5" width="17" height="15" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/>'),
    user: ic('<circle cx="12" cy="8" r="4"/><path d="M4 20c1.5-4 4.5-6 8-6s6.5 2 8 6"/>'), mail: ic('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m3.5 7 8.5 6 8.5-6"/>'),
    phone: ic('<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1Z"/>'),
    link: ic('<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>'),
    text: ic('<path d="M5 6h14M12 6v13"/>'), para: ic('<path d="M4 6h16M4 11h16M4 16h10"/>'), hash: ic('<path d="M9 4 7 20M17 4l-2 16M4 9h16M3 15h16"/>'),
    sel: ic('<circle cx="12" cy="12" r="9"/><path d="m8.5 10.5 3.5 3.5 3.5-3.5"/>'), tags: ic('<path d="M3 12V4h8l9 9-8 8-9-9Z"/><circle cx="7.5" cy="8.5" r="1.3"/>'),
    box: ic('<rect x="4" y="4" width="16" height="16" rx="4"/><path d="m8 12 3 3 5-6"/>'),
    star: ic('<path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9Z"/>'),
    layout: ic('<rect x="4" y="3.5" width="16" height="17" rx="2.5"/><path d="M8 8h8M8 12h8M8 16h5"/>'),
    note: ic('<path d="M5 4h14v11l-5 5H5Z"/><path d="M14 20v-5h5"/>'),
    board: ic('<rect x="3" y="4" width="5" height="16" rx="1.5"/><rect x="10" y="4" width="5" height="11" rx="1.5"/><rect x="17" y="4" width="4" height="7" rx="1.5"/>'),
    fold: ic('<path d="m9 7-5 5 5 5M15 7l5 5-5 5"/>'),
    copy: ic('<rect x="8" y="8" width="12" height="12" rx="2.5"/><path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8"/>'),
    undo: ic('<path d="M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3"/>'), hist: ic('<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/>'),
    lock: ic('<rect x="5" y="11" width="14" height="10" rx="2.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'),
    clip: ic('<path d="m20 11.5-8.2 8.2a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.5 8.5a1.7 1.7 0 0 1-2.4-2.4l7.8-7.8"/>'),
    upload: ic('<path d="M12 16V4m-5 5 5-5 5 5M4 16v2.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V16"/>'),
    download: ic('<path d="M12 4v12m-5-5 5 5 5-5M4 16v2.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V16"/>'),
    eye: ic('<path d="M2.5 12S6 5 12 5s9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z"/><circle cx="12" cy="12" r="3"/>'),
    flag: ic('<path d="M5 21V4m0 0h11l-2 4 2 4H5"/>'),
    summary: ic('<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8 9h8M8 13h5"/>'),
    filter: ic('<path d="M4 5h16l-6 7.5V19l-4 1.5v-8Z"/>'),
    sort: ic('<path d="M7 4v16m0 0-3-3m3 3 3-3M17 20V4m0 0-3 3m3-3 3 3"/>'),
    views: ic('<path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 13 9 5 9-5"/>'),
    users: ic('<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c1-3.6 3.5-5.5 6.5-5.5s5.5 1.9 6.5 5.5"/><path d="M16 4.7a3.5 3.5 0 0 1 0 6.6M18 14.8c1.8.8 3 2.5 3.5 5.2"/>'),
    bell: ic('<path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15Z"/><path d="M10 20.5a2 2 0 0 0 4 0"/>'),
    file: ic('<path d="M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8Z"/><path d="M14 3v5h5"/>'),
    mover: ic('<path d="M3 7.5A1.5 1.5 0 0 1 4.5 6H9l2 2h8.5A1.5 1.5 0 0 1 21 9.5v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5Z"/><path d="M9.5 13.5h6m-2.5-2.5 2.5 2.5-2.5 2.5"/>'),
    sheet: ic('<rect x="3.5" y="4" width="17" height="16" rx="2.5"/><path d="M3.5 9.5h17M3.5 15h17M9.5 4v16"/>'),
    excel: ic('<path d="M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8Z"/><path d="M14 3v5h5M9 12l4 5M13 12l-4 5"/>'),
    ext: ic('<path d="M14 4h6v6M20 4l-9 9"/><path d="M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10"/>'),
    info: ic('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    open: ic('<path d="M15 3h6v6M21 3l-8 8"/><path d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6"/>'),
};
const TIPO_IC = { texto: I.text, largo: I.para, numero: I.hash, fecha: I.cal, lista: I.sel, multi: I.tags, persona: I.user, correo: I.mail, telefono: I.phone, enlace: I.link, casilla: I.box };
const HIST_IC = { new: I.plus, mov: I.arrow, edit: I.edit, nota: I.note, ej: I.star, arch: I.clip, asig: I.user, seg: I.flag };

// ── Archivos adjuntos ──
// Privados en el servidor: se piden a la API (con el token) y se muestran como blob.
const MAX_ARCHIVO = 10 * 1024 * 1024, MAX_POR_TARJETA = 20;
const urls = new Map();   // id → object URL (miniaturas y portadas)
async function urlDe(id) {
    if (urls.has(id)) return urls.get(id);
    const b = await api.blob(`/archivos/${id}`);
    const u = URL.createObjectURL(b); urls.set(id, u); return u;
}
const esImagen = a => /^image\/(png|jpe?g|gif|webp|svg\+xml|bmp|avif)$/.test(a.tipo);
function tamTxt(b) {
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${Math.round(b / 1024)} KB`;
    return `${(b / 1024 / 1024).toLocaleString('es-CL', { maximumFractionDigits: 1 })} MB`;
}
const extDe = n => { const m = /\.([a-z0-9]{1,5})$/i.exec(n); return m ? m[1].toUpperCase() : ''; };
/** Pone las imágenes en los [data-th] que haya dentro de root. */
function cargarMiniaturas(root) {
    root.querySelectorAll('[data-th]:not([data-th-ok])').forEach(async el => {
        el.setAttribute('data-th-ok', '');
        try { const u = await urlDe(el.dataset.th); if (u && el.isConnected) { el.style.backgroundImage = `url("${u}")`; el.classList.add('is-img'); } } catch (e) { /* sin miniatura */ }
    });
}
// ── Estado ──
// S.lista = tableros del inicio (resumen); S.t = tablero abierto (completo).
let S = { yo: 0, super: false, lista: null, t: null, ruta: { v: 'inicio' }, seq: 1 };
let cargando = false, errorCarga = '';
const nid = () => S.seq++;
const ahora = () => Date.now();
const yo = () => ADMINS.find(a => a.id === S.yo) || { id: S.yo, nombre: 'Yo' };
/** Filtros que vuelven de la API: {} vacíos llegan como [] desde PHP. */
function normF(F) {
    if (!F || typeof F !== 'object' || Array.isArray(F)) return F0();
    const o = { ...F0(), ...F };
    ['seg', 'campos'].forEach(k => { if (!o[k] || Array.isArray(o[k])) o[k] = {}; });
    ['asig', 'ocultas'].forEach(k => { if (!Array.isArray(o[k])) o[k] = []; });
    return o;
}
/** Tablero de la API → forma que usa la pantalla (la misma de la demo). */
function adaptar(d) {
    ponerAdmins(d.admins, d.yo); S.yo = d.yo;
    const t = {
        id: d.id, nombre: d.nombre, desc: d.desc, dueno: d.dueno, visib: d.visib, rolEquipo: d.rolEquipo, etapa: d.etapa, listo: d.listo,
        molde: d.molde || 0, creado: d.creado, editado: d.editado, rol: d.rol, columnas: d.columnas, campos: d.campos,
        tarjetas: d.tarjetas.map(adaptarTarjeta), miembros: d.miembros, accesos: d.accesos || {}, notion: d.notion || null,
        vistas: (d.vistas || []).map(v => ({ ...v, F: normF(v.F) })),
        pref: { F: normF(d.pref && d.pref.F), vista: (d.pref && d.pref.vista) || 0, plegadas: (d.pref && d.pref.plegadas) || [] },
    };
    // Los ids nuevos del molde (campos/opciones) se arman en el navegador: que no choquen.
    let max = 0;
    t.campos.forEach(f => { max = Math.max(max, f.id); (f.opciones || []).forEach(o => { max = Math.max(max, o.id); }); });
    S.seq = Math.max(S.seq, max + 1000);
    return t;
}
function adaptarTarjeta(x, previa) {
    const p = previa || {};
    return {
        id: x.id, col: x.col, orden: x.orden, titulo: x.titulo, datos: Array.isArray(x.datos) ? {} : (x.datos || {}),
        asignado: x.asignado, seguimiento: x.seguimiento, por: x.por, creada: x.creada, editada: x.editada, colDesde: x.colDesde,
        nNotas: x.nNotas || 0, ultimaNota: x.ultimaNota || null, archivos: x.archivos || [],
        // Copia de Notion: enlace a la página y archivos (se abren en Notion).
        nUrl: x.notion ? x.notion.url : null, nIcono: x.notion ? x.notion.icono || null : null, nArch: x.notion ? (x.notion.archivos || []) : [], contenido: p.contenido != null ? p.contenido : null,
        // Notas e historial completos se piden al abrir la tarjeta.
        notas: p.notas || null, hist: p.hist || null,
    };
}
/** Reemplaza una tarjeta con lo que devolvió la API (conserva notas/historial cargados). */
function ponerTarjeta(t, x) {
    const i = t.tarjetas.findIndex(c => c.id === x.id), nueva = adaptarTarjeta(x, i >= 0 ? t.tarjetas[i] : null);
    if (i >= 0) t.tarjetas[i] = nueva; else t.tarjetas.push(nueva);
    return nueva;
}
// ── Llamadas a la API ──
const msgErr = e => (e && e.data && e.data.message) || (e && e.status === 403 ? 'No tienes permiso para hacer esto.' : e && e.status === 404 ? 'Ese tablero o tarjeta ya no existe.' : 'No se pudo guardar. Revisa tu conexión.');
/** Llama a la API; si falla avisa y vuelve a cargar el tablero desde el servidor. */
async function llamar(fn, { silencioso, sinRecarga } = {}) {
    try { return await fn(); }
    catch (e) {
        if (!silencioso) toast(msgErr(e));
        if (!sinRecarga) recargar();
        throw e;
    }
}
/** Pone en pantalla el tablero que devolvió la API (misma referencia, conserva notas/historial cargados). */
function aplicarTablero(d) {
    const nuevo = adaptar(d);
    if (S.t && S.t.id === nuevo.id) {
        const prev = new Map(S.t.tarjetas.map(x => [x.id, x]));
        nuevo.tarjetas.forEach(x => { const o = prev.get(x.id); if (o) { x.notas = o.notas; x.hist = o.hist; x.contenido = o.contenido; } });
        Object.assign(S.t, nuevo);
        return S.t;
    }
    S.t = nuevo;
    return S.t;
}
async function recargar() {
    const r = S.ruta;
    try {
        if (r.v === 'tablero') {
            const d = await api.get(`/${r.id}`);
            if (S.ruta !== r) return;
            aplicarTablero(d);
            if (DR && !S.t.tarjetas.some(x => x.id === DR.cid)) cerrarDrawer(true);
            if (!M) { if (DR) pintarDrawer(); render(); }
        } else await cargarLista();
    } catch (e) {
        if (r.v === 'tablero' && e && (e.status === 404 || e.status === 403)) { S.t = null; cerrarTodo(); render(); }
    }
}
async function cargarLista() {
    const d = await api.get('');
    ponerAdmins(d.admins, d.yo); S.yo = d.yo; S.super = d.super; S.lista = d.tableros;
    if (S.ruta.v === 'inicio' && !M) render();
}
// Preferencias (filtros, vista, columnas plegadas): se guardan medio segundo después del último cambio.
let prefTm = 0, prefPend = {};
function guardarPref(t, campos) {
    campos.forEach(k => { prefPend[k] = k === 'F' ? copia(t.pref.F) : t.pref[k]; });
    clearTimeout(prefTm);
    const id = t.id;
    prefTm = setTimeout(() => { const b = prefPend; prefPend = {}; api.put(`/${id}/preferencias`, b).catch(() => {}); }, 500);
}

// ── Acceso: dueño / puede editar / solo ver (+ todo el equipo y supervisión del súper admin) ──
// En hyf-api: tablero.visibilidad + tablero_miembro(tablero, usuario, permiso); cada ruta lo comprueba (403).
const ROL_TXT = { dueno: 'Dueño', editar: 'Puede editar', ver: 'Solo ver', super: 'Supervisión' };
const esSuper = (uid = S.yo) => !!(ADMINS.find(a => a.id === uid) || {}).super;
function rolEn(t, uid = S.yo) {
    if (!t) return null;
    if (uid === S.yo) return t.rol;
    if (t.dueno === uid) return 'dueno';
    return (t.accesos || {})[uid] || null;
}
const puedeEditar = (t, uid) => !!t && !t.notion && ['dueno', 'editar'].includes(rolEn(t, uid));
const esDueno = (t, uid) => !!t && rolEn(t, uid) === 'dueno';
/** Columnas, molde y armado: solo el dueño y nunca en una copia de Notion (solo lectura). */
const puedeArmar = (t, uid) => esDueno(t, uid) && !t.notion;
const esNotion = t => !!(t && (t.notion || t.origen === 'notion'));
const asignables = t => ADMINS.filter(a => puedeEditar(t, a.id));
/** Quiénes tienen acceso real (sin contar la supervisión): { uid: rol } */
const accesos = t => t.accesos || {};
const puedeSalir = t => t.dueno !== S.yo && t.visib === 'personas' && (t.miembro || (t.miembros || []).some(m => m.id === S.yo));
/** Preferencias de la persona en el tablero: filtros, vista elegida, columnas plegadas. */
function PF(t) {
    const p = t.pref || (t.pref = {});
    if (!p.F) p.F = F0(); if (p.vista == null) p.vista = 0; if (!p.plegadas) p.plegadas = [];
    return p;
}
const misTableros = () => (S.lista || []).filter(t => t.rol === 'dueno');
const compartidos = () => (S.lista || []).filter(t => t.rol === 'editar' || t.rol === 'ver');
const supervisados = () => (S.lista || []).filter(t => t.rol === 'super');
const tablero = id => (S.t && S.t.id === id ? S.t : null);
const ruta = () => S.ruta;
const actual = () => (S.ruta.v === 'tablero' ? tablero(S.ruta.id) : null);
const tarjetasCol = (t, col) => t.tarjetas.filter(x => x.col === col).sort((a, b) => a.orden - b.orden);
const colDe = (t, id) => t.columnas.find(c => c.id === id);
const etapaLista = it => (!it.nColumnas || it.etapa === 'columnas') ? 'columnas' : it.etapa === 'listo' ? 'listo' : 'ejemplo';
const etapaDe = t => (!t.columnas.length || t.etapa === 'columnas') ? 'columnas' : (!t.listo ? 'ejemplo' : 'listo');
function tocar(t, x) { const n = ahora(); if (x) x.editada = n; t.editado = n; }
function hist(x, ty, txt) { if (!x.hist) return; x.hist.unshift({ t: ahora(), q: S.yo, ty, txt }); if (x.hist.length > 200) x.hist.length = 200; }

// ── Utilidades ──
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
const limpio = s => String(s || '').replace(/\s+/g, ' ').trim();
const plural = (n, s, p) => `${n} ${n === 1 ? s : p}`;
const nombreDe = id => (ADMINS.find(a => a.id === id) || { nombre: 'Admin' }).nombre;
const iniciales = n => n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase();
function rel(t) {
    const d = (ahora() - t) / 1000;
    if (d < 45) return 'recién';
    if (d < 3600) return `hace ${Math.round(d / 60)} min`;
    if (d < 86400) return `hace ${Math.round(d / 3600)} h`;
    const n = Math.round(d / 86400); return n === 1 ? 'ayer' : `hace ${n} días`;
}
const fechaHora = t => new Date(t).toLocaleString('es-CL', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
function fechaCorta(iso) {
    const [y, m, d] = String(iso).split('-').map(Number); if (!y || !m || !d) return String(iso);
    return new Date(y, m - 1, d).toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: y !== new Date().getFullYear() ? 'numeric' : undefined });
}
function av(id, cls = '') { const a = ADMINS.find(x => x.id === id); return a ? `<span class="tp-av ${cls}" style="--av:${a.av}" title="${esc(a.nombre)}" aria-hidden="true">${esc(iniciales(a.nombre))}</span>` : ''; }
const urlFix = v => /^https?:\/\//i.test(v) ? v : 'https://' + v;
function urlValida(v) { try { const u = new URL(urlFix(v)); return /^https?:$/.test(u.protocol) && /\.[a-z]{2,}$/i.test(u.hostname); } catch (e) { return false; } }
const dominio = v => { try { return new URL(urlFix(v)).hostname.replace(/^www\./, ''); } catch (e) { return v; } };
const vacio = v => v == null || v === '' || v === false || (Array.isArray(v) && !v.length) || (typeof v === 'number' && isNaN(v));
const igual = (a, b) => JSON.stringify(vacio(a) ? null : a) === JSON.stringify(vacio(b) ? null : b);
const copia = o => JSON.parse(JSON.stringify(o));
function colorLibre(t, lista) {
    const usados = (lista || t.columnas).map(c => c.color);
    const libre = COLORES.find(([k]) => !usados.includes(k));
    return libre ? libre[0] : COLORES[usados.length % COLORES.length][0];
}
const foco = sel => requestAnimationFrame(() => { const el = typeof sel === 'string' ? raiz.querySelector(sel) : sel; if (el) el.focus(); });
const anunciar = msg => { const s = raiz.querySelector('.tp-sr-live'); if (!s) return; s.textContent = ''; setTimeout(() => { s.textContent = msg; }, 30); };

// ── Asignada a / seguimiento (fijos en todas las tarjetas) ──
const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const segVencido = x => !!x.seguimiento && x.seguimiento <= hoyISO();
function segTxt(x) {
    if (!x.seguimiento) return '';
    const h = hoyISO();
    if (x.seguimiento === h) return 'Hoy';
    const [y, m, d] = x.seguimiento.split('-').map(Number), dif = Math.round((new Date(y, m - 1, d) - new Date(h + 'T00:00')) / 864e5);
    if (dif === 1) return 'Mañana';
    if (dif === -1) return 'Ayer';
    return fechaCorta(x.seguimiento);
}
// ── Filtros, orden y vistas (guardados en cada tablero) ──
const FILTRA = new Set(['lista', 'multi', 'persona', 'fecha', 'numero', 'casilla']);
const usaFiltro = f => f.filtro == null ? FILTRA.has(f.tipo) : !!f.filtro;
const F0 = () => ({ asig: [], seg: {}, arch: '', quieto: 0, ocultas: [], campos: {}, orden: '' });
const isoMas = n => { const d = new Date(); d.setDate(d.getDate() + n); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const vacioN = v => v === '' || v == null;
/** Quita del filtro lo que ya no existe (campos, opciones, columnas borradas). */
function limpiarF(t, F) {
    F.asig = (F.asig || []).filter(id => id === 0 || ADMINS.some(a => a.id === id));
    F.seg = F.seg || {}; F.campos = F.campos || {};
    F.ocultas = (F.ocultas || []).filter(id => t.columnas.some(c => c.id === id && !c.oculta));
    if (F.ocultas.length >= t.columnas.filter(c => !c.oculta).length) F.ocultas = [];
    Object.keys(F.campos).forEach(k => {
        const f = t.campos.find(c => String(c.id) === k);
        if (!f || !usaFiltro(f)) { delete F.campos[k]; return; }
        const c = F.campos[k];
        if (c.ops) c.ops = c.ops.filter(id => id === 0 || (f.tipo === 'persona' ? ADMINS.some(a => a.id === id) : f.opciones.some(o => o.id === id)));
        if (!activoCampo(f, c)) delete F.campos[k];
    });
    if (F.orden && F.orden.startsWith('f:') && !t.campos.some(f => 'f:' + f.id === F.orden)) F.orden = '';
    return F;
}
const Fde = t => limpiarF(t, PF(t).F || (PF(t).F = F0()));
function activoCampo(f, c) {
    if (!c) return false;
    switch (f.tipo) {
        case 'lista': case 'persona': case 'multi': return !!(c.ops && c.ops.length);
        case 'fecha': return !!c.m;
        case 'numero': return !vacioN(c.min) || !vacioN(c.max);
        default: return !!c.v;
    }
}
function pasaFecha(v, c, esSeg) {
    const m = c && c.m, h = hoyISO();
    if (!m) return true;
    if (m === 'sin') return !v;
    if (m === 'con') return !!v;
    if (!v) return false;
    if (m === 'vencida') return esSeg ? v <= h : v < h;
    if (m === 'hoy') return v === h;
    if (m === 'semana') return v >= h && v <= isoMas(6);
    if (m === 'rango') return (!c.desde || v >= c.desde) && (!c.hasta || v <= c.hasta);
    return true;
}
function pasaCampo(f, v, c) {
    switch (f.tipo) {
        case 'lista': case 'persona': return !c.ops.length || c.ops.includes(vacio(v) ? 0 : v);
        case 'multi': { const a = v || []; return c.modo === 'todas' ? c.ops.every(o => a.includes(o)) : c.ops.some(o => a.includes(o)); }
        case 'fecha': return pasaFecha(v || null, c);
        case 'numero': if (vacio(v)) return false; return (vacioN(c.min) || v >= +c.min) && (vacioN(c.max) || v <= +c.max);
        case 'casilla': return (c.v === 'si') === !!v;
        default: return (c.v === 'con') === !vacio(v);
    }
}
function pasaFiltros(t, x) {
    const F = Fde(t);
    if (F.asig.length && !F.asig.includes(x.asignado || 0)) return false;
    if (!pasaFecha(x.seguimiento, F.seg, true)) return false;
    const na = (x.archivos || []).length + (x.nArch || []).length;
    if ((F.arch === 'con' && !na) || (F.arch === 'sin' && na)) return false;
    if (F.quieto > 0 && ahora() - x.editada < F.quieto * 864e5) return false;
    return t.campos.every(f => { const c = F.campos[f.id]; return !c || !usaFiltro(f) || !activoCampo(f, c) || pasaCampo(f, x.datos[f.id], c); });
}
function nActivos(t) {
    const F = Fde(t);
    return (F.asig.length ? 1 : 0) + (F.seg.m ? 1 : 0) + (F.arch ? 1 : 0) + (F.quieto ? 1 : 0) + (F.ocultas.length ? 1 : 0)
        + t.campos.filter(f => activoCampo(f, F.campos[f.id])).length;
}
const visible = (t, x, q) => (!q || coincide(t, x, q)) && pasaFiltros(t, x);
const hayFiltro = () => { const t = actual(); return !!(norm(busqueda) || (t && nActivos(t))); };
// Orden de las tarjetas dentro de cada columna
function opcionesOrden(t) {
    return [['', 'Orden manual (arrastrar)'], ['seg', 'Seguimiento más cercano'], ['editada', 'Último cambio primero'], ['creada', 'Más nuevas primero'], ['titulo', 'Título (A → Z)'],
        ...t.campos.filter(f => ['lista', 'numero', 'fecha', 'persona', 'texto'].includes(f.tipo)).map(f => ['f:' + f.id, f.nombre])];
}
function ordenar(t, lista) {
    const o = Fde(t).orden; if (!o) return lista;
    const ult = (a, b, cmp) => (a == null && b == null) ? 0 : a == null ? 1 : b == null ? -1 : cmp(a, b);
    const txt = (a, b) => String(a).localeCompare(String(b), 'es', { sensitivity: 'base' });
    let key, cmp = (a, b) => a < b ? -1 : a > b ? 1 : 0;
    if (o === 'seg') key = x => x.seguimiento || null;
    else if (o === 'editada') { key = x => -x.editada; }
    else if (o === 'creada') { key = x => -x.creada; }
    else if (o === 'titulo') { key = x => x.titulo; cmp = txt; }
    else {
        const f = t.campos.find(c => 'f:' + c.id === o); if (!f) return lista;
        if (f.tipo === 'lista') key = x => { const i = f.opciones.findIndex(op => op.id === x.datos[f.id]); return i < 0 ? null : i; };
        else if (f.tipo === 'persona') { key = x => vacio(x.datos[f.id]) ? null : nombreDe(x.datos[f.id]); cmp = txt; }
        else if (f.tipo === 'texto') { key = x => vacio(x.datos[f.id]) ? null : x.datos[f.id]; cmp = txt; }
        else key = x => vacio(x.datos[f.id]) ? null : x.datos[f.id];
    }
    return [...lista].sort((a, b) => ult(key(a), key(b), cmp) || a.orden - b.orden);
}

// ── Valores de los campos ──
function textoValor(f, v) {
    if (vacio(v)) return f.tipo === 'casilla' ? 'No' : '(vacío)';
    switch (f.tipo) {
        case 'lista': { const o = f.opciones.find(o => o.id === v); return o ? o.nombre : '(vacío)'; }
        case 'multi': return v.map(id => (f.opciones.find(o => o.id === id) || {}).nombre).filter(Boolean).join(', ') || '(vacío)';
        case 'persona': return nombreDe(v);
        case 'casilla': return 'Sí';
        case 'fecha': return fechaCorta(v);
        case 'numero': return String(v); // tal cual se escribió (sin puntos de miles: puede ser un teléfono, un código…)
        default: { const s = String(v); return s.length > 60 ? s.slice(0, 57) + '…' : s; }
    }
}
const pill = o => `<span class="tp-pill tn-${o.color}">${esc(o.nombre || '—')}</span>`;
function valorHTML(f, v) {
    switch (f.tipo) {
        case 'lista': { const o = f.opciones.find(o => o.id === v); return o ? pill(o) : ''; }
        case 'multi': return (v || []).map(id => f.opciones.find(o => o.id === id)).filter(Boolean).map(pill).join('');
        case 'persona': return ADMINS.some(a => a.id === v) ? `${av(v, 'tp-av--s')}<span>${esc(nombreDe(v))}</span>` : '';
        case 'fecha': return `${I.cal}<span>${esc(fechaCorta(v))}</span>`;
        case 'casilla': return `<span class="tp-chk">${I.check}Sí</span>`;
        case 'numero': return `<span>${esc(String(v))}</span>`;
        case 'correo': return `<a class="tp-lnk" href="mailto:${esc(v)}">${esc(v)}</a>`;
        case 'telefono': return `<a class="tp-lnk" href="tel:${esc(String(v).replace(/[^\d+]/g, ''))}">${esc(v)}</a>`;
        case 'enlace': return `<a class="tp-lnk" href="${esc(urlFix(v))}" target="_blank" rel="noopener noreferrer">${esc(dominio(v))}</a>`;
        default: return `<span>${esc(v)}</span>`;
    }
}
function inputCampo(f, v, id) {
    const a = `id="${id}" data-campo="${f.id}"`;
    switch (f.tipo) {
        case 'largo': return `<textarea ${a} class="tp-in" rows="3" maxlength="4000">${esc(v || '')}</textarea>`;
        case 'numero': return `<input ${a} class="tp-in" type="number" step="any" inputmode="decimal" value="${esc(vacio(v) ? '' : v)}">`;
        case 'fecha': return `<input ${a} class="tp-in" type="date" value="${esc(v || '')}">`;
        case 'correo': return `<input ${a} class="tp-in" type="email" maxlength="160" autocomplete="off" placeholder="nombre@empresa.com" value="${esc(v || '')}">`;
        case 'telefono': return `<input ${a} class="tp-in" type="tel" maxlength="30" autocomplete="off" placeholder="+56 9 1234 5678" value="${esc(v || '')}">`;
        case 'enlace': return `<input ${a} class="tp-in" type="url" maxlength="300" autocomplete="off" placeholder="https://" value="${esc(v || '')}">`;
        case 'lista': return `<select ${a} class="tp-in"><option value="">Sin elegir</option>${f.opciones.map(o => `<option value="${o.id}" data-tn="${o.color}" ${o.id === v ? 'selected' : ''}>${esc(o.nombre || '(sin nombre)')}</option>`).join('')}</select>`;
        case 'persona': return `<select ${a} class="tp-in"><option value="">Sin asignar</option>${ADMINS.map(p => `<option value="${p.id}" data-uid="${p.id}" ${p.id === v ? 'selected' : ''}>${esc(p.nombre)}${p.id === S.yo ? ' (yo)' : ''}</option>`).join('')}</select>`;
        case 'multi': return `<div class="tp-multi" id="${id}" role="group" aria-labelledby="${id}-l">${f.opciones.length ? f.opciones.map(o => `<label class="tp-mo tn-${o.color}"><input type="checkbox" data-campo="${f.id}" value="${o.id}" ${(v || []).includes(o.id) ? 'checked' : ''}><span>${esc(o.nombre || '(sin nombre)')}</span></label>`).join('') : '<span class="tp-help">Agrega opciones arriba.</span>'}</div>`;
        case 'casilla': return `<label class="tp-switch"><input ${a} type="checkbox" ${v ? 'checked' : ''}><span>Sí</span></label>`;
        default: return `<input ${a} class="tp-in" type="text" maxlength="300" autocomplete="off" value="${esc(v || '')}">`;
    }
}
function leerCampo(f, root) {
    const els = [...root.querySelectorAll(`[data-campo="${f.id}"]`)];
    if (f.tipo === 'multi') return els.filter(e => e.checked).map(e => +e.value);
    const e = els[0]; if (!e) return undefined;
    if (f.tipo === 'casilla') return e.checked;
    if (f.tipo === 'numero' && e.validity && e.validity.badInput) return NaN;
    const s = e.value.trim();
    if (f.tipo === 'numero' || f.tipo === 'lista' || f.tipo === 'persona') return s === '' ? '' : Number(s);
    return s;
}
function validar(f, v) {
    if (f.tipo === 'numero' && typeof v === 'number' && isNaN(v)) return 'Escribe un número válido.';
    if (vacio(v)) return '';
    if (f.tipo === 'correo' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return 'Escribe un correo válido (nombre@empresa.com).';
    if (f.tipo === 'enlace' && !urlValida(v)) return 'Escribe un enlace válido (ej.: www.sitio.cl).';
    if (f.tipo === 'telefono' && !/^\+?[\d\s().-]{6,}$/.test(v)) return 'Escribe un teléfono válido.';
    if (f.tipo === 'fecha' && !/^\d{4}-\d{2}-\d{2}$/.test(v)) return 'Elige una fecha válida.';
    return '';
}
function normalizar(f, v) {
    if (vacio(v)) return null;
    if (f.tipo === 'enlace') return urlFix(v);
    if (f.tipo === 'texto') return limpio(v);
    return v;
}
function setDato(x, f, v) { if (vacio(v)) delete x.datos[f.id]; else x.datos[f.id] = v; }
function coincide(t, x, q) {
    if (norm(x.titulo).includes(q)) return true;
    if ((x.archivos || []).some(a => norm(a.nombre).includes(q))) return true;
    if (x.asignado && norm(nombreDe(x.asignado)).includes(q)) return true;
    return t.campos.some(f => !vacio(x.datos[f.id]) && norm(textoValor(f, x.datos[f.id])).includes(q));
}

// ── Pantallas ──
raiz.innerHTML = '<div class="tp-app"></div><div class="tp-capas"></div><div class="tp-toasts" aria-live="polite"></div><div class="tp-sr tp-sr-live" aria-live="polite"></div>';
const app = raiz.querySelector('.tp-app');
const capas = raiz.querySelector('.tp-capas');
let busqueda = '';
let focoTras = null;

/** Migas: Panel admin › Tableros personales › tablero */
function topbar(t) {
    return `<nav class="tp-crumbs" aria-label="Ruta"><a href="/admin" data-nav="admin">Panel admin</a>${I.chev}${t ? `<a href="/admin/tableros" data-nav="0">Tableros personales</a>${I.chev}<span aria-current="page">${esc(t.nombre)}</span>` : '<span aria-current="page">Tableros personales</span>'}</nav>`;
}
let abrirTras = 0, compartirTras = false;
const cargandoHTML = () => `<main class="tp-main"><div class="tp-loading" role="status"><span class="tp-spin" aria-hidden="true"></span>Cargando…</div></main>`;
function render() {
    const r = ruta(), t = actual();
    cerrarPop(true);
    if ((r.v === 'tablero' && !t && cargando) || (r.v === 'inicio' && !S.lista)) {
        app.innerHTML = topbar(null) + (errorCarga && r.v === 'inicio' ? `<main class="tp-main"><section class="tp-empty"><span class="tp-empty-ic">${I.lock}</span><h2>No se pudieron cargar los tableros</h2><p>${esc(errorCarga)}</p><button type="button" class="tp-btn tp-btn-main" data-act="reintentar">Reintentar</button></section></main>` : cargandoHTML());
        return;
    }
    if (r.v === 'tablero' && !t) {
        app.innerHTML = topbar(null) + `<main class="tp-main"><section class="tp-empty"><span class="tp-empty-ic">${I.lock}</span><h2>Este tablero no existe o no tienes acceso</h2><p>${esc(errorCarga || 'Puede que lo hayan eliminado o que ya no te lo compartan.')}</p><a class="tp-btn tp-btn-main" href="/admin/tableros" data-nav="0">${I.back}Volver a los tableros</a></section></main>`;
        document.title = 'Tableros personales · House & Flats';
        return;
    }
    // Dentro de un tablero no hay migas: volver a la lista está en el menú «…».
    app.innerHTML = t ? vistaTablero(t) : topbar(null) + vistaInicio();
    document.title = (t ? t.nombre + ' · ' : '') + 'Tableros personales · House & Flats';
    cargarMiniaturas(app);
    barraH(); rovingXL();
    if (focoTras) { foco(focoTras); focoTras = null; }
    if (compartirTras && t) { compartirTras = false; if (esDueno(t)) requestAnimationFrame(() => abrirCompartir(t)); }
    if (abrirTras && t) { const id = abrirTras; abrirTras = 0; if (t.tarjetas.some(x => x.id === id)) requestAnimationFrame(() => { flash(id); abrirTarjeta(id); }); else toast('Esa tarjeta ya no existe.'); }
}

function vistaInicio() {
    const ord = l => l.sort((a, b) => b.editado - a.editado);
    const mios = ord(misTableros()), comp = ord(compartidos()), sup = ord(supervisados()), nada = !mios.length && !comp.length;
    return `<main class="tp-main" id="main">
      <div class="tp-hero"><div><h1 class="tp-h1">Tableros <span class="tp-grad">personales</span></h1>
        <p class="tp-sub">Arma tus propios tableros: columnas con nombre y color, una tarjeta de ejemplo con los datos que necesitas y, desde ahí, todas las demás. Tú decides quién más los ve.</p></div>
        ${nada ? '' : `<div class="tp-hero-act"><button type="button" class="tp-btn tp-btn-ghost" data-act="notion-nuevo">${LOGO_NOTION}Nuevo tablero de Notion</button><button type="button" class="tp-btn tp-btn-main" data-act="nuevo-tablero">${I.plus}Nuevo tablero</button></div>`}</div>
      ${nada ? vacioInicio() : `<section aria-labelledby="h-mios"><h2 class="tp-h2" id="h-mios">Mis tableros <span>${mios.length}</span></h2><ul class="tp-grid">${mios.map(bcard).join('')}<li><button type="button" class="tp-bnew" data-act="nuevo-tablero">${I.plus}<span>Nuevo tablero</span></button></li></ul></section>
        ${comp.length ? `<section class="tp-sec" aria-labelledby="h-comp"><h2 class="tp-h2" id="h-comp">Compartidos conmigo <span>${comp.length}</span></h2><ul class="tp-grid">${comp.map(bcard).join('')}</ul></section>` : ''}`}
      ${sup.length ? `<section class="tp-sec" aria-labelledby="h-sup"><h2 class="tp-h2" id="h-sup">Supervisión <span>${sup.length}</span></h2><p class="tp-sec-help">${I.eye}Como súper admin ves los tableros del equipo que no te compartieron, solo para mirar.</p><ul class="tp-grid">${sup.map(bcard).join('')}</ul></section>` : ''}
    </main>`;
}
function vacioInicio() {
    return `<section class="tp-empty"><span class="tp-empty-ic">${I.board}</span>
      <h2>Todavía no tienes tableros</h2>
      <p>Crea uno para ordenar lo que quieras: tareas, proveedores, propiedades por revisar, ideas… Tú decides las columnas, los datos de cada tarjeta y con quién compartirlo.</p>
      <ol class="tp-howto">
        <li><i>1</i><b>Nombre y descripción</b>Dale un nombre al tablero y una breve descripción de para qué es.</li>
        <li><i>2</i><b>Columnas</b>Crea las etapas o estados, cada una con su color.</li>
        <li><i>3</i><b>Tarjeta de ejemplo</b>Elige qué datos tendrá cada tarjeta. Será la base para todas las demás.</li>
      </ol>
      <div class="tp-hero-act"><button type="button" class="tp-btn tp-btn-main" data-act="nuevo-tablero">${I.plus}Crear mi primer tablero</button><button type="button" class="tp-btn tp-btn-ghost" data-act="notion-nuevo">${LOGO_NOTION}Traer un tablero de Notion</button></div></section>`;
}
function visibTxt(t) {
    if (t.visib === 'equipo') return `${I.users}Todo el equipo`;
    return t.visib === 'personas' && t.nMiembros > 0 ? `${I.users}Compartido con ${t.nMiembros}` : `${I.lock}Solo yo`;
}
function bcard(t, i) {
    const e = etapaLista(t), rol = t.rol, own = rol === 'dueno';
    const estado = !own || t.origen === 'notion' ? '' : e === 'columnas' ? '<span class="tp-tag tp-tag--warn">Faltan las columnas</span>' : e === 'ejemplo' ? '<span class="tp-tag tp-tag--warn">Falta la tarjeta de ejemplo</span>' : '';
    const deNotion = t.origen === 'notion' ? `<span class="tp-tag tp-tag--notion">${LOGO_NOTION}Notion · solo lectura</span>` : '';
    const strip = t.colores.length ? t.colores.slice(0, 10).map(c => `<span class="tn-${c}"></span>`).join('') : '<span></span><span></span><span></span>';
    return `<li class="tp-bcard" style="animation-delay:${i * 40}ms">
      <div class="tp-bcard-strip" aria-hidden="true">${strip}</div>
      <h3><a href="/admin/tableros/${t.id}" data-nav="${t.id}">${esc(t.nombre)}</a></h3>
      ${t.desc ? `<p>${esc(t.desc)}</p>` : ''}
      ${own ? '' : `<div class="tp-bcard-own">${av(t.dueno, 'tp-av--s')}<span>De ${esc(nombreDe(t.dueno))}</span><span class="tp-tag tp-tag--rol tp-tag--${rol}">${ROL_TXT[rol]}</span></div>`}
      <div class="tp-bcard-meta">${deNotion}${estado}${own ? `<span class="tp-tag">${visibTxt(t)}</span>` : ''}<span>${plural(t.nColumnas, 'columna', 'columnas')} · ${plural(t.nTarjetas, 'tarjeta', 'tarjetas')}</span><span title="${fechaHora(t.editado)}">Actualizado ${rel(t.editado)}</span></div>
      <button type="button" class="tp-ib tp-bcard-menu" data-act="menu-tablero" data-id="${t.id}" aria-haspopup="menu" aria-expanded="false" aria-label="Opciones de ${esc(t.nombre)}">${I.more}</button>
    </li>`;
}
function vistaTablero(t) {
    const e = etapaDe(t), rol = rolEn(t), OW = rol === 'dueno', ED = puedeEditar(t), NT = esNotion(t);
    let acc = '';
    if (NT) acc += notionChip(t);
    if (e === 'listo') acc += (ED ? `<button type="button" class="tp-btn tp-btn-main" data-act="tarjeta-nueva">${I.plus}Nueva tarjeta</button>` : '') + (puedeArmar(t) ? `<button type="button" class="tp-btn tp-btn-ghost" data-act="molde">${I.layout}Molde de tarjeta</button>` : '');
    // Compartir y volver a Tableros van en el menú «…» (siempre está: al menos tiene «Tableros»).
    if (!OW) acc += `<span class="tp-rolchip">${av(t.dueno, 'tp-av--s')}<span>De ${esc(nombreDe(t.dueno))} · <b>${ROL_TXT[rol]}</b></span></span>`;
    const menu = `<button type="button" class="tp-ib tp-ib--box" data-act="menu-board" aria-haspopup="menu" aria-expanded="false" aria-label="Opciones del tablero (Tableros, Compartir…)">${I.more}</button>`;
    const ro = NT ? `<p class="tp-ro tp-ro--notion" id="tp-ro">${notionAviso(t)}</p>`
        : ED ? '' : `<p class="tp-ro">${I.eye}<span>${rol === 'super' ? 'Estás mirando como súper admin: no puedes cambiar nada.' : `Solo puedes ver este tablero. Para editar, pídele permiso a ${esc(nombreDe(t.dueno))}.`}</span></p>`;
    return `<main class="tp-main tp-main--board" id="main">
      <div class="tp-bhead">
        <div class="tp-bhead-row">
          <div class="tp-bhead-tx"><h1 class="tp-h1 tp-h1--b">${esc(t.nombre)}</h1>${t.desc ? `<p class="tp-sub">${esc(t.desc)}</p>` : ''}</div>
          <div class="tp-bhead-act">${acc}${menu}</div>
        </div>
        ${ro}
        ${e === 'listo' ? toolbar(t) : OW ? pasos(e) : ''}
      </div>
      <div class="tp-zone">${zona(t)}</div>
    </main>`;
}
// ── Tableros copiados de Notion (solo lectura; la API los actualiza) ──
const LOGO_NOTION = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.5" y="3" width="17" height="18" rx="3.2" fill="#fff" stroke="currentColor" stroke-width="1.6"/><path d="M8.6 16.6V7.6l6.8 9V7.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const notionChip = t => `<a class="tp-notion-chip" href="${esc((t.notion && t.notion.url) || 'https://www.notion.so')}" target="_blank" rel="noopener noreferrer" title="Abrir el tablero original en Notion">${LOGO_NOTION}<span>Abrir en Notion</span></a>`;
let syncando = false;
function notionAviso(t) {
    const n = t.notion || {};
    const cuando = syncando ? '<span class="tp-spin tp-spin--s" aria-hidden="true"></span>Actualizando desde Notion…' : n.sync ? `Actualizado ${rel(n.sync)}` : 'Todavía no se actualizó';
    return `${LOGO_NOTION}<span><b>Copia de Notion · solo lectura.</b> Se ve igual que en Notion y se actualiza sola; los cambios se hacen allá. Puedes filtrar, guardar vistas, verla como planilla, exportarla y compartirla.</span>
      <span class="tp-ro-sync">${moverColsNotion(t) && !n.manual ? `<button type="button" class="tp-btn tp-btn-soft tp-btn-sm" data-act="notion-cols">${I.board}Ordenar columnas como en Notion</button>` : ''}${n.error ? `<span class="tp-ro-err">${I.info}${esc(n.error)}</span>` : `<span title="${n.sync ? fechaHora(n.sync) : ''}">${cuando}</span>`}<button type="button" class="tp-btn-link" data-act="notion-sync" ${syncando ? 'disabled' : ''}>${I.undo}Actualizar ahora</button></span>`;
}
/** Pide a la API que traiga lo nuevo de Notion (con `detalle` también comentarios y contenido). */
async function syncNotion(t, avisar, detalle) {
    if (syncando || !t) return;
    syncando = true;
    const p = app.querySelector('#tp-ro'); if (p) p.innerHTML = notionAviso(t);
    try {
        const d = await api.post(`/${t.id}/notion-sync`, detalle ? { detalle: 1 } : {});
        syncando = false;
        if (S.t && S.t.id === t.id) {
            aplicarTablero(d);
            if (!M && !XE && !SD) { if (DR) pintarDrawer(); pintarZona(); }
            const p2 = app.querySelector('#tp-ro'); if (p2) p2.innerHTML = notionAviso(S.t);
        }
        if (avisar) toast(d.notion && d.notion.error ? d.notion.error : 'Listo: el tablero está igual que en Notion.');
    } catch (e) {
        syncando = false;
        const p2 = app.querySelector('#tp-ro'); if (p2 && S.t) p2.innerHTML = notionAviso(S.t);
        if (avisar) toast(msgErr(e));
    }
}
function toolbar(t) {
    // Una sola fila: vistas + búsqueda + filtros (más alto libre para las columnas).
    return `<div class="tp-toolbar">
      <div class="tp-modo" role="group" aria-label="Cómo ver las tarjetas">${[['tablero', 'Tablero', I.board], ['planilla', 'Planilla', I.sheet]].map(([m, n, ic]) => `<button type="button" class="tp-modo-b" data-act="modo" data-m="${m}" aria-pressed="${modoDe(t) === m}">${ic}<span>${n}</span></button>`).join('')}</div>
      <div class="tp-vistas" id="tp-vistas">${vistasHTML(t)}</div>
      <div class="tp-search" role="search">${I.search}<label class="tp-sr" for="tp-q">Buscar en el tablero</label><input id="tp-q" type="search" placeholder="Buscar tarjetas…" value="${esc(busqueda)}" autocomplete="off"><kbd aria-hidden="true">/</kbd></div>
      <button type="button" class="tp-chip tp-chip--f" id="tp-fbtn" data-act="filtros" aria-haspopup="dialog">${I.filter}Filtros<span class="tp-badge" id="tp-fbadge">${nActivos(t) || ''}</span></button>
      <div class="tp-seg" role="group" aria-label="Filtros rápidos" id="tp-quick">${esNotion(t) ? '' : rapidosHTML(t)}</div>
      <span class="tp-total" aria-live="polite">${totalTxt(t)}</span>
      ${modoDe(t) === 'planilla' ? `<button type="button" class="tp-chip tp-chip--xl" data-act="exportar" title="Descarga las filas que se ven (con filtros y orden)">${I.excel}Exportar a Excel</button>` : ''}
    </div>
    <div class="tp-fchips" id="tp-fchips">${chipsHTML(t)}</div>`;
}
function rapidosHTML(t) {
    const F = Fde(t), mias = F.asig.length === 1 && F.asig[0] === S.yo, venc = F.seg.m === 'vencida';
    return `<button type="button" class="tp-chip" data-act="rapido" data-f="mias" aria-pressed="${mias}">${av(S.yo, 'tp-av--s')}Asignadas a mí <span class="tp-n">${t.tarjetas.filter(x => x.asignado === S.yo).length}</span></button>
      <button type="button" class="tp-chip" data-act="rapido" data-f="vencidas" aria-pressed="${venc}">${I.flag}Seguimiento vencido <span class="tp-n">${t.tarjetas.filter(segVencido).length}</span></button>`;
}
const SEG_TXT = { vencida: 'vencido', hoy: 'hoy', semana: 'próximos 7 días', sin: 'sin fecha', con: 'con fecha' };
function fechaFiltroTxt(c, esSeg) {
    if (c.m === 'rango') return [c.desde && 'desde ' + fechaCorta(c.desde), c.hasta && 'hasta ' + fechaCorta(c.hasta)].filter(Boolean).join(' ') || 'cualquier fecha';
    return c.m === 'vencida' && !esSeg ? 'vencida' : SEG_TXT[c.m];
}
/** Lista de filtros activos: [clave, texto]. */
function filtrosActivos(t) {
    const F = Fde(t), out = [];
    if (F.asig.length) out.push(['asig', 'Asignada a: ' + F.asig.map(id => id ? nombreDe(id) : 'Sin asignar').join(', ')]);
    if (F.seg.m) out.push(['seg', 'Seguimiento: ' + fechaFiltroTxt(F.seg, true)]);
    if (F.arch) out.push(['arch', F.arch === 'con' ? 'Con archivos' : 'Sin archivos']);
    if (F.quieto) out.push(['quieto', `Sin cambios hace +${F.quieto} días`]);
    if (F.ocultas.length) out.push(['ocultas', plural(F.ocultas.length, 'columna oculta', 'columnas ocultas')]);
    t.campos.forEach(f => {
        const c = F.campos[f.id]; if (!activoCampo(f, c)) return;
        let v;
        if (f.tipo === 'lista' || f.tipo === 'multi') v = c.ops.map(id => id ? (f.opciones.find(o => o.id === id) || {}).nombre : 'Vacío').join(', ') + (f.tipo === 'multi' && c.modo === 'todas' && c.ops.length > 1 ? ' (todas)' : '');
        else if (f.tipo === 'persona') v = c.ops.map(id => id ? nombreDe(id) : 'Sin elegir').join(', ');
        else if (f.tipo === 'fecha') v = fechaFiltroTxt(c);
        else if (f.tipo === 'numero') v = !vacioN(c.min) && !vacioN(c.max) ? `${c.min} a ${c.max}` : !vacioN(c.min) ? `≥ ${c.min}` : `≤ ${c.max}`;
        else if (f.tipo === 'casilla') v = c.v === 'si' ? 'Sí' : 'No';
        else v = c.v === 'con' ? 'con dato' : 'vacío';
        out.push(['c:' + f.id, `${f.nombre}: ${v}`]);
    });
    return out;
}
function chipsHTML(t) {
    const act = filtrosActivos(t), o = Fde(t).orden;
    if (!act.length && !o) return '';
    const ord = o ? (opcionesOrden(t).find(x => x[0] === o) || [, ''])[1] : '';
    return `<ul class="tp-fchips-l" aria-label="Filtros activos">${act.map(([k, txt]) => `<li><button type="button" class="tp-fchip" data-act="fquitar" data-k="${k}" aria-label="Quitar filtro: ${esc(txt)}"><span>${esc(txt)}</span>${I.x}</button></li>`).join('')}
      ${o ? `<li><button type="button" class="tp-fchip tp-fchip--o" data-act="fquitar" data-k="orden" aria-label="Quitar orden: ${esc(ord)}">${I.sort}<span>Orden: ${esc(ord)}</span>${I.x}</button></li>` : ''}</ul>
      ${act.length ? '<button type="button" class="tp-btn-link" data-act="flimpiar">Limpiar filtros</button>' : ''}`;
}
/** Re-dibuja todo lo que depende de los filtros (sin tocar el buscador). */
function pintarFiltrosUI(t) {
    const q = id => app.querySelector(id);
    if (q('#tp-fbadge')) q('#tp-fbadge').textContent = nActivos(t) || '';
    if (q('#tp-quick')) q('#tp-quick').innerHTML = esNotion(t) ? '' : rapidosHTML(t);
    if (q('#tp-fchips')) q('#tp-fchips').innerHTML = chipsHTML(t);
    if (q('#tp-vistas')) q('#tp-vistas').innerHTML = vistasHTML(t);
    if (q('.tp-total')) q('.tp-total').textContent = totalTxt(t);
}
// Vistas guardadas: una combinación de filtros + orden con nombre.
const vistasVisibles = t => (t.vistas || []).filter(v => v.de === S.yo || (v.todos && v.de === t.dueno));
const vistaDe = t => vistasVisibles(t).find(v => v.id === PF(t).vista) || null;
const esMia = v => !!v && v.de === S.yo;
const vistaSucia = t => { const v = vistaDe(t); return !!v && JSON.stringify(limpiarF(t, copia(v.F))) !== JSON.stringify(Fde(t)); };
function vistasHTML(t) {
    const vs = vistasVisibles(t), v = vistaDe(t), act = v ? v.id : 0, sucia = vistaSucia(t), algo = nActivos(t) || Fde(t).orden;
    return `<span class="tp-vistas-ic" aria-hidden="true">${I.views}</span>
      <div class="tp-vistas-l" role="group" aria-label="Vistas guardadas">
        <button type="button" class="tp-vista" data-act="vista" data-v="0" aria-pressed="${act === 0}">Todas</button>
        ${vs.map(x => `<span class="tp-vista-w${act === x.id ? ' is-on' : ''}"><button type="button" class="tp-vista" data-act="vista" data-v="${x.id}" aria-pressed="${act === x.id}">${x.todos ? `<span class="tp-vista-sh" title="${x.de === S.yo ? 'La ven todos los miembros' : 'Vista de ' + esc(nombreDe(x.de)) + ' para todos'}">${I.users}</span>` : ''}${esc(x.nombre)}${act === x.id && sucia ? '<i class="tp-vista-dot" aria-label="(modificada)"></i>' : ''}</button>${act === x.id && esMia(x) ? `<button type="button" class="tp-ib tp-vista-m" data-act="vista-menu" aria-haspopup="menu" aria-expanded="false" aria-label="Opciones de la vista «${esc(x.nombre)}»">${I.more}</button>` : ''}</span>`).join('')}
        <button type="button" class="tp-vista tp-vista--new" data-act="vista-nueva" ${algo ? '' : 'disabled title="Primero elige algún filtro u orden"'}>${I.plus}Guardar como vista</button>
      </div>
      ${sucia ? `<span class="tp-vista-mod">Cambiaste los filtros de esta vista · ${esMia(v) ? '<button type="button" class="tp-btn-link" data-act="vista-actualizar">Guardar en la vista</button>' : '<button type="button" class="tp-btn-link" data-act="vista-nueva">Guardar como vista mía</button>'} · <button type="button" class="tp-btn-link" data-act="vista-revertir">Volver a como estaba</button></span>` : ''}`;
}
function elegirVista(t, id) {
    const v = vistasVisibles(t).find(x => x.id === id);
    PF(t).vista = v ? v.id : 0; PF(t).F = v ? limpiarF(t, copia(v.F)) : F0();
    guardarPref(t, ['F', 'vista']); pintarZona(); foco(`#tp-vistas [data-act="vista"][data-v="${PF(t).vista}"]`);
    anunciar(v ? `Vista «${v.nombre}»` : 'Todas las tarjetas');
}
function modalVista(t, v) {
    abrirModal(modalHTML({
        titulo: v ? 'Cambiar nombre de la vista' : 'Guardar como vista', form: 'vista',
        sub: v ? '' : 'Guarda los filtros y el orden de ahora para volver a ellos con un clic.',
        cuerpo: `<input type="hidden" name="id" value="${v ? v.id : ''}">
          <div class="tp-f"><label for="v-nom">Nombre de la vista</label><input id="v-nom" name="nombre" class="tp-in" maxlength="40" value="${esc(v ? v.nombre : '')}" placeholder="Ej.: Mis urgentes" autocomplete="off" autofocus><p class="tp-err" id="v-nom-e" role="alert"></p></div>
          ${v ? '' : `<div class="tp-info">${I.filter}<span>${esc(filtrosActivos(t).map(a => a[1]).join(' · ') || 'Sin filtros')}${Fde(t).orden ? ' · Orden: ' + esc((opcionesOrden(t).find(o => o[0] === Fde(t).orden) || [, ''])[1]) : ''}</span></div>`}`,
        pie: pieBtns(v ? 'Guardar' : 'Guardar vista'),
    }), { tid: t.id });
}
// Ventana de filtros: se arma con los campos del molde de cada tablero y se aplica al instante.
function abrirFiltros(t) {
    abrirModal(modalHTML({ titulo: 'Filtros', sub: esc(t.nombre), form: 'filtros', l: true, cuerpo: filtrosHTML(t),
        pie: `<p class="tp-fcount" id="f-count" aria-live="polite">${totalTxt(t)}</p><button type="button" class="tp-btn tp-btn-ghost" data-act="f-limpiar">Limpiar todo</button><button type="button" class="tp-btn tp-btn-main" data-act="cerrar">Listo</button>` }),
        { kind: 'filtros', tid: t.id });
}
function filtrosHTML(t) {
    const F = Fde(t);
    const chk = (name, val, on, label, cls = '') => `<label class="tp-mo ${cls}"><input type="checkbox" name="${name}" value="${val}" ${on ? 'checked' : ''}><span>${label}</span></label>`;
    const rad = (name, val, on, label) => `<label class="tp-mo"><input type="radio" name="${name}" value="${val}" ${on ? 'checked' : ''}><span>${label}</span></label>`;
    const grupo = (titulo, cuerpo, ic = '') => `<fieldset class="tp-fg"><legend>${ic}${titulo}</legend>${cuerpo}</fieldset>`;
    const fechaCtl = (pre, c, esSeg) => `<div class="tp-multi">${[['', 'Cualquiera'], ['vencida', esSeg ? 'Vencido' : 'Ya pasó'], ['hoy', 'Hoy'], ['semana', 'Próximos 7 días'], ['sin', 'Sin fecha'], ['con', 'Con fecha'], ['rango', 'Entre fechas']].map(([v, l]) => rad(pre + '_m', v, (c.m || '') === v, l)).join('')}</div>
        <div class="tp-frango" data-rango="${pre}" ${c.m === 'rango' ? '' : 'hidden'}><label>Desde<input type="date" class="tp-in tp-in--s" name="${pre}_desde" value="${esc(c.desde || '')}"></label><label>Hasta<input type="date" class="tp-in tp-in--s" name="${pre}_hasta" value="${esc(c.hasta || '')}"></label></div>`;
    const personas = (name, ops, vacioTxt) => chk(name, 0, ops.includes(0), vacioTxt) + ADMINS.filter(a => accesos(t)[a.id] || ops.includes(a.id)).map(a => chk(name, a.id, ops.includes(a.id), `${esc(a.nombre)}${a.id === S.yo ? ' (yo)' : ''}`)).join('');
    const campos = t.campos.filter(usaFiltro);
    const campo = f => {
        const k = 'c' + f.id, c = F.campos[f.id] || {}, ops = c.ops || [];
        switch (f.tipo) {
            case 'lista': return `<div class="tp-multi">${f.opciones.map(o => chk(k, o.id, ops.includes(o.id), esc(o.nombre), 'tn-' + o.color)).join('')}${chk(k, 0, ops.includes(0), 'Vacío')}</div>`;
            case 'multi': return `<div class="tp-multi">${f.opciones.map(o => chk(k, o.id, ops.includes(o.id), esc(o.nombre), 'tn-' + o.color)).join('')}</div><div class="tp-multi tp-fmodo"><span>Que tenga</span>${rad(k + '_modo', 'alguna', c.modo !== 'todas', 'alguna')}${rad(k + '_modo', 'todas', c.modo === 'todas', 'todas')}</div>`;
            case 'persona': return `<div class="tp-multi">${personas(k, ops, 'Sin elegir')}</div>`;
            case 'fecha': return fechaCtl(k, c);
            case 'numero': return `<div class="tp-frango"><label>Desde<input type="number" step="any" class="tp-in tp-in--s" name="${k}_min" value="${esc(vacioN(c.min) ? '' : c.min)}"></label><label>Hasta<input type="number" step="any" class="tp-in tp-in--s" name="${k}_max" value="${esc(vacioN(c.max) ? '' : c.max)}"></label></div>`;
            case 'casilla': return `<div class="tp-multi">${rad(k + '_v', '', !c.v, 'Cualquiera')}${rad(k + '_v', 'si', c.v === 'si', 'Sí')}${rad(k + '_v', 'no', c.v === 'no', 'No')}</div>`;
            default: return `<div class="tp-multi">${rad(k + '_v', '', !c.v, 'Cualquiera')}${rad(k + '_v', 'con', c.v === 'con', 'Con dato')}${rad(k + '_v', 'vacio', c.v === 'vacio', 'Vacío')}</div>`;
        }
    };
    return `<div class="tp-fcols">
      <section class="tp-fsec" aria-labelledby="fs-gen"><h3 id="fs-gen">Generales</h3>
        ${esNotion(t) ? '' : grupo('Asignada a', `<div class="tp-multi">${personas('asig', F.asig, 'Sin asignar')}</div>`, I.user)}
        ${esNotion(t) ? '' : grupo('Seguimiento', fechaCtl('seg', F.seg, true), I.flag)}
        ${grupo('Archivos', `<div class="tp-multi">${rad('arch', '', !F.arch, 'Cualquiera')}${rad('arch', 'con', F.arch === 'con', 'Con archivos')}${rad('arch', 'sin', F.arch === 'sin', 'Sin archivos')}</div>`, I.clip)}
        ${grupo('Sin cambios hace más de', `<select class="tp-in tp-in--s" name="quieto" aria-label="Sin cambios hace más de">${[[0, 'Cualquier fecha'], [3, '3 días'], [7, '7 días'], [14, '14 días'], [30, '30 días']].map(([v, l]) => `<option value="${v}" ${F.quieto === v ? 'selected' : ''}>${l}</option>`).join('')}</select>`, I.clock)}
        ${grupo('Columnas visibles', `<div class="tp-multi">${t.columnas.filter(c => !c.oculta).map(c => chk('col', c.id, !F.ocultas.includes(c.id), esc(c.nombre), 'tn-' + c.color)).join('')}</div><p class="tp-err" id="f-col-e" role="alert"></p>`, I.board)}
      </section>
      <section class="tp-fsec" aria-labelledby="fs-campos"><h3 id="fs-campos">Datos de las tarjetas</h3>
        ${campos.length ? campos.map(f => grupo(esc(f.nombre), campo(f), TIPO_IC[f.tipo])).join('') : '<p class="tp-help">Ningún campo se usa como filtro. En «Molde de tarjeta» marca «Usar como filtro» en los campos que quieras.</p>'}
        ${grupo('Ordenar las tarjetas por', `<select class="tp-in tp-in--s" name="orden" aria-label="Ordenar las tarjetas por">${opcionesOrden(t).map(([v, l]) => `<option value="${v}" ${F.orden === v ? 'selected' : ''}>${esc(l)}</option>`).join('')}</select>`, I.sort)}
      </section></div>`;
}
function leerFiltros(form, t) {
    const els = n => [...form.querySelectorAll(`[name="${n}"]`)];
    const marc = n => els(n).filter(e => e.checked).map(e => +e.value);
    const radio = n => (els(n).find(e => e.checked) || {}).value || '';
    const val = n => (els(n)[0] || {}).value || '';
    const fecha = pre => { const m = radio(pre + '_m'); if (!m) return {}; const c = { m }; if (m === 'rango') { c.desde = val(pre + '_desde'); c.hasta = val(pre + '_hasta'); } return c; };
    const F = F0();
    F.asig = marc('asig'); F.seg = fecha('seg'); F.arch = radio('arch'); F.quieto = +val('quieto') || 0;
    const vis = marc('col'); F.ocultas = t.columnas.filter(c => !c.oculta && !vis.includes(c.id)).map(c => c.id);
    t.campos.filter(usaFiltro).forEach(f => {
        const k = 'c' + f.id; let c;
        if (['lista', 'persona', 'multi'].includes(f.tipo)) { c = { ops: marc(k) }; if (f.tipo === 'multi') c.modo = radio(k + '_modo') || 'alguna'; }
        else if (f.tipo === 'fecha') c = fecha(k);
        else if (f.tipo === 'numero') c = { min: val(k + '_min'), max: val(k + '_max') };
        else c = { v: radio(k + '_v') };
        if (activoCampo(f, c)) F.campos[f.id] = c;
    });
    F.orden = val('orden');
    return F;
}
function filtrosInput(el) {
    const t = tablero(M.tid), form = M.el.querySelector('form');
    if (el.name === 'col' && !el.checked && !form.querySelector('[name="col"]:checked')) {
        el.checked = true; M.el.querySelector('#f-col-e').textContent = 'Tiene que quedar al menos una columna a la vista.'; return;
    }
    M.el.querySelector('#f-col-e').textContent = '';
    M.el.querySelectorAll('[data-rango]').forEach(r => { r.hidden = (form.querySelector(`[name="${r.dataset.rango}_m"]:checked`) || {}).value !== 'rango'; });
    PF(t).F = leerFiltros(form, t); aplicarF(t);
    M.el.querySelector('#f-count').textContent = totalTxt(t);
}
function aplicarF(t) { tocarF(t); guardarPref(t, ['F']); pintarZona(); }
function tocarF(t) { limpiarF(t, PF(t).F); }
function totalTxt(t) {
    const n = t.tarjetas.length, q = norm(busqueda);
    return hayFiltro() ? `${t.tarjetas.filter(x => visible(t, x, q)).length} de ${plural(n, 'tarjeta', 'tarjetas')}` : plural(n, 'tarjeta', 'tarjetas');
}
function pasos(e) {
    const uno = e === 'columnas';
    return `<div class="tp-steps"><ol aria-label="Pasos para armar el tablero">
        <li class="tp-step ${uno ? 'is-now' : 'is-done'}" ${uno ? 'aria-current="step"' : ''}><i>${uno ? '1' : I.check}</i><span><b>Columnas</b><small>Nombre y color de cada etapa</small></span></li>
        <li class="tp-steps-sep" role="presentation"></li>
        <li class="tp-step ${uno ? '' : 'is-now'}" ${uno ? '' : 'aria-current="step"'}><i>2</i><span><b>Tarjeta de ejemplo</b><small>Los datos que tendrá cada tarjeta</small></span></li>
      </ol>
      ${uno ? '' : `<div class="tp-steps-act"><button type="button" class="tp-btn tp-btn-ghost tp-btn-sm" data-act="volver-cols">${I.back}Volver a las columnas</button><button type="button" class="tp-btn tp-btn-main tp-btn-sm" data-act="molde">${I.star}Crear la tarjeta de ejemplo</button></div>`}
    </div>`;
}
const zona = t => etapaDe(t) !== 'listo' && !esDueno(t) ? esperaHTML(t) : etapaDe(t) === 'columnas' ? setupCols(t) : t.listo && modoDe(t) === 'planilla' ? planillaHTML(t) : boardHTML(t);
const esperaHTML = t => `<section class="tp-empty"><span class="tp-empty-ic">${I.board}</span><h2>Este tablero todavía se está armando</h2><p>${esc(nombreDe(t.dueno))} está creando las columnas y la tarjeta de ejemplo. Cuando termine, verás las tarjetas aquí.</p></section>`;

function swatches(name, sel) {
    return `<div class="tp-sws">${COLORES.map(([k, n]) => `<label class="tp-sw tn-${k}" title="${n}"><input type="radio" name="${name}" value="${k}" ${k === sel ? 'checked' : ''}><span class="tp-sw-c"></span><span class="tp-sr">${n}</span></label>`).join('')}</div>`;
}
function setupCols(t) {
    const n = t.columnas.length;
    return `<section class="tp-setup">
      <div class="tp-setup-card">
        <h2>Crea las columnas</h2>
        <p>Cada columna es una etapa o un estado de tus tarjetas (por ejemplo: Por hacer, En curso, Hecho). Puedes cambiarlas cuando quieras.</p>
        <form class="tp-colform" data-form="col-add" novalidate>
          <div class="tp-f"><label for="cn">Nombre de la columna</label><input id="cn" name="nombre" class="tp-in" maxlength="40" placeholder="Ej.: Por hacer" autocomplete="off"><p class="tp-err" id="cn-e" role="alert"></p></div>
          <fieldset class="tp-f"><legend>Color</legend>${swatches('color', colorLibre(t))}</fieldset>
          <div><button type="submit" class="tp-btn tp-btn-soft">${I.plus}Agregar columna</button></div>
        </form>
        ${n ? '' : `<div class="tp-ideas"><span>¿Sin ideas? Agrega estas tres:</span><button type="button" class="tp-chip" data-act="preset">${PRESETS.map(p => p[0]).join(' · ')}</button></div>`}
        ${n ? `<div><h3 class="tp-molde-h">Tus columnas <span>${n}</span></h3><ol class="tp-collist">${t.columnas.map((c, i) => `<li class="tn-${c.color}"><span class="tp-collist-n">${i + 1}</span><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span><span class="tp-collist-tools">
            <button type="button" class="tp-ib" id="cu-${c.id}" data-act="col-up" data-col="${c.id}" aria-label="Subir «${esc(c.nombre)}»" ${i === 0 ? 'disabled' : ''}>${I.up}</button>
            <button type="button" class="tp-ib" id="cd-${c.id}" data-act="col-down" data-col="${c.id}" aria-label="Bajar «${esc(c.nombre)}»" ${i === n - 1 ? 'disabled' : ''}>${I.down}</button>
            <button type="button" class="tp-ib" data-act="col-edit" data-col="${c.id}" aria-label="Editar «${esc(c.nombre)}»">${I.edit}</button>
            <button type="button" class="tp-ib" data-act="col-del" data-col="${c.id}" aria-label="Eliminar «${esc(c.nombre)}»">${I.trash}</button></span></li>`).join('')}</ol></div>` : ''}
        <div class="tp-setup-foot"><button type="button" class="tp-btn tp-btn-main" data-act="a-ejemplo" ${n ? '' : 'disabled'}>Siguiente: tarjeta de ejemplo${I.arrow}</button></div>
      </div>
      <aside class="tp-setup-prev" aria-label="Vista previa del tablero"><h3>Así va quedando tu tablero</h3>
        <div class="tp-mini">${n ? t.columnas.map(c => `<div class="tp-mini-col tn-${c.color}"><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span><span class="tp-mini-cd"></span><span class="tp-mini-cd"></span></div>`).join('') : '<p class="tp-help">Aquí verás las columnas que vayas creando.</p>'}</div></aside>
    </section>`;
}

function boardHTML(t) {
    const q = norm(busqueda);
    const oc = t.listo ? Fde(t).ocultas : [];
    return `<div class="tp-board${puedeArmar(t) || moverColsNotion(t) ? ' can-move-cols' : ''}" aria-label="Columnas de ${esc(t.nombre)}">${t.columnas.filter(c => !oc.includes(c.id) && !c.oculta).map((c, i) => colHTML(t, c, q, i)).join('')}
      ${puedeArmar(t) ? `<button type="button" class="tp-col-new" data-act="col-nueva">${I.plus}Agregar columna</button>` : ''}</div>
      <div class="tp-hbar" aria-hidden="true"><div></div></div>`;
}
function colHTML(t, c, q, i) {
    const todas = ordenar(t, tarjetasCol(t, c.id)), vis = hayFiltro() ? todas.filter(x => visible(t, x, q)) : todas;
    const plegada = PF(t).plegadas.includes(c.id);
    let vacia = '';
    if (!vis.length) {
        vacia = (!t.listo && i === 0 && esDueno(t))
            ? `<button type="button" class="tp-ej-cta" data-act="molde">${I.star}<b>Crea la tarjeta de ejemplo</b><span>Define los datos que tendrán todas las tarjetas</span></button>`
            : `<p class="tp-col-empty">${hayFiltro() ? 'Sin resultados' : 'Sin tarjetas'}</p>`;
    }
    return `<section class="tp-col tn-${c.color}${plegada ? ' is-folded' : ''}" data-col="${c.id}" ${plegada ? `data-act="desplegar" title="Desplegar «${esc(c.nombre)}»"` : ''} style="animation-delay:${i * 30}ms" aria-label="${esc(c.nombre)}, ${plural(vis.length, 'tarjeta', 'tarjetas')}">
      <header class="tp-col-head"><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span><span class="tp-col-n">${hayFiltro() ? `${vis.length}/${todas.length}` : todas.length}</span>
        <span class="tp-col-tools">${t.listo && puedeEditar(t) ? `<button type="button" class="tp-ib" data-act="tarjeta-nueva" data-col="${c.id}" aria-label="Nueva tarjeta en «${esc(c.nombre)}»">${I.plus}</button>` : ''}${puedeArmar(t) ? `<button type="button" class="tp-ib" data-act="menu-col" data-col="${c.id}" aria-haspopup="menu" aria-expanded="false" aria-label="Opciones de la columna «${esc(c.nombre)}»">${I.more}</button>` : ''}</span></header>
      <div class="tp-col-body" data-col="${c.id}">${vis.map(x => cardHTML(t, x)).join('')}${vacia}</div>
      ${t.listo && !plegada && puedeEditar(t) ? `<button type="button" class="tp-col-add" data-act="tarjeta-nueva" data-col="${c.id}">${I.plus}Nueva tarjeta</button>` : ''}
    </section>`;
}
function cardHTML(t, x, o = {}) {
    const campos = (o.campos || t.campos).filter(f => f.enTarjeta && !vacio(x.datos[f.id]) && valorHTML(f, x.datos[f.id]));
    const ej = o.preview ? o.ej : x.id === t.molde;
    const abierta = DR && DR.cid === x.id;
    const arch = x.archivos || [], portada = arch.find(esImagen), nArch = arch.length + (x.nArch || []).length;
    // «…» en cada tarjeta: abrir, nueva aquí, duplicar, eliminar sin entrar a la tarjeta.
    const menu = !o.preview && puedeEditar(t) ? `<button type="button" class="tp-ib tp-cd-menu" data-act="menu-card" data-id="${x.id}" aria-haspopup="menu" aria-expanded="false" aria-label="Opciones de «${esc(x.titulo)}»">${I.more}</button>` : '';
    return `<article class="tp-cd${ej ? ' is-ej' : ''}${abierta ? ' is-open' : ''}${o.preview ? ' tp-cd--prev' : ''}${menu ? ' has-menu' : ''}" ${o.preview ? '' : `data-id="${x.id}" tabindex="0"`} aria-label="${esc(x.titulo)}${ej ? ' (tarjeta de ejemplo)' : ''}">
      ${menu}
      ${portada ? `<div class="tp-cd-cover" data-th="${portada.id}" role="img" aria-label="${esc(portada.nombre)}"></div>` : ''}
      ${ej || x.seguimiento || x.asignado ? `<div class="tp-cd-top">${ej ? `<span class="tp-ej-tag">${I.star}Ejemplo</span>` : ''}${x.seguimiento ? `<span class="tp-cd-follow${segVencido(x) ? ' is-due' : ''}" title="Seguimiento: ${esc(fechaCorta(x.seguimiento))}${segVencido(x) ? ' (vencido)' : ''}">${I.flag}${esc(segTxt(x))}</span>` : ''}<span class="tp-sp"></span>${x.asignado ? `<span title="Asignada a ${esc(nombreDe(x.asignado))}">${av(x.asignado, 'tp-av--s')}</span>` : ''}</div>` : ''}
      <h3 class="tp-cd-name${o.ph ? ' is-ph' : ''}">${x.nIcono ? `<span class="tp-cd-ico" aria-hidden="true">${esc(x.nIcono)}</span>` : ''}${esc(x.titulo)}</h3>
      ${esNotion(t) ? cuerpoNotion(t, x, campos) : campos.length ? `<dl class="tp-cd-fields">${campos.map(f => `<div class="tp-cd-f${f.tipo === 'largo' ? ' tp-cd-f--largo' : ''}"><dt>${esc(f.nombre)}</dt><dd>${valorHTML(f, x.datos[f.id])}</dd></div>`).join('')}</dl>` : ''}
      ${esNotion(t) ? `<footer class="tp-cd-foot tp-cd-foot--n">${nArch ? `<span title="${plural(nArch, 'archivo', 'archivos')}">${I.clip}${nArch}</span>` : ''}${x.nNotas ? `<span title="${plural(x.nNotas, 'comentario', 'comentarios')}">${I.note}${x.nNotas}</span>` : ''}</footer>`
        : `<footer class="tp-cd-foot">${I.clock}<span title="${fechaHora(x.editada)}">${x.editada - x.creada > 1500 ? 'Editada' : 'Creada'} ${rel(x.editada)}</span><span class="tp-cd-n">${nArch ? `<span title="${plural(nArch, 'archivo', 'archivos')}">${I.clip}${nArch}</span>` : ''}${x.nNotas ? `<span title="${plural(x.nNotas, 'nota', 'notas')}">${I.note}${x.nNotas}</span>` : ''}</span></footer>`}
    </article>`;
}
/** Tarjeta como en el tablero de Notion: valores uno debajo del otro, sin el nombre del campo,
 *  personas con inicial + nombre y el estado como píldora (si la vista de Notion lo muestra). */
function cuerpoNotion(t, x, campos) {
    const fechaLarga = v => { const [y, m, d] = String(v).split('-').map(Number); return y ? new Date(y, m - 1, d).toLocaleDateString('es-CL', { day: 'numeric', month: 'long', year: 'numeric' }) : v; };
    const filas = [];
    const c = colDe(t, x.col);
    campos.forEach(f => {
        const v = x.datos[f.id];
        let h;
        if (f.tipo === 'multi' && f.opciones.some(o => o.persona)) h = `<span class="tp-nc-gente">${(v || []).map(id => f.opciones.find(o => o.id === id)).filter(Boolean).map(o => `<span class="tp-nc-per">${avNotion(o.nombre)}${esc(o.nombre)}</span>`).join('')}</span>`;
        else if (f.tipo === 'fecha') h = `<span class="tp-nc-fecha">${esc(fechaLarga(v))}</span>`;
        else h = valorHTML(f, v);
        filas.push({ f, h });
    });
    // El estado va donde Notion lo pone en la tarjeta: después de las personas.
    const est = t.notion && t.notion.verEstado && c ? `<div class="tp-nc"><span class="tp-pill tp-pill--est tn-${c.color}"><span class="tp-dot"></span>${esc(c.nombre)}</span></div>` : '';
    let html = '', puesto = !est;
    filas.forEach(({ f, h }) => {
        if (!puesto && !(f.tipo === 'multi' && f.opciones.some(o => o.persona))) { html += est; puesto = true; }
        html += `<div class="tp-nc${f.tipo === 'largo' ? ' tp-nc--largo' : ''}" title="${esc(f.nombre)}">${h}</div>`;
    });
    if (!puesto) html += est;
    return html ? `<div class="tp-nc-l">${html}</div>` : '';
}

function pintarZona() {
    const t = actual(), z = app.querySelector('.tp-zone');
    if (!t || !z) { render(); return; }
    if (XE) quitarEditor();
    const b = z.querySelector('.tp-board'), sl = b ? b.scrollLeft : 0, tops = {};
    const w = z.querySelector('.tp-xl-wrap'), wl = w ? w.scrollLeft : 0, wt = w ? w.scrollTop : 0;
    z.querySelectorAll('.tp-col-body').forEach(c => { tops[c.dataset.col] = c.scrollTop; });
    z.innerHTML = zona(t);
    const b2 = z.querySelector('.tp-board'); if (b2) b2.scrollLeft = sl;
    const w2 = z.querySelector('.tp-xl-wrap'); if (w2) { w2.scrollLeft = wl; w2.scrollTop = wt; }
    z.querySelectorAll('.tp-col-body').forEach(c => { if (tops[c.dataset.col] != null) c.scrollTop = tops[c.dataset.col]; });
    const tot = app.querySelector('.tp-total'); if (tot) tot.textContent = totalTxt(t);
    if (t.listo) pintarFiltrosUI(t);
    cargarMiniaturas(z);
    barraH(); rovingXL();
}
/** Barra horizontal fija abajo de la pantalla (la del tablero queda al final de la página,
 *  porque ahora se desplaza la página y no las columnas). Mismo ancho que el tablero. */
function barraH() {
    const b = app.querySelector('.tp-board'), h = app.querySelector('.tp-hbar');
    if (!b || !h) return;
    medirCookies(); // la barra y el final del tablero quedan arriba del aviso de cookies
    const sobra = b.scrollWidth - b.clientWidth;
    h.classList.toggle('is-on', sobra > 1);
    h.firstElementChild.style.width = b.scrollWidth + 'px';
    if (Math.abs(h.scrollLeft - b.scrollLeft) > 1) h.scrollLeft = b.scrollLeft;
}
function flash(id) {
    const el = app.querySelector(`.tp-cd[data-id="${id}"], .tp-xl tr[data-id="${id}"]`); if (!el) return;
    el.classList.add('is-flash');
    el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    setTimeout(() => el.classList.remove('is-flash'), 1400);
}

// ── Vista planilla (como Excel): mismas tarjetas, filtros, búsqueda y vistas que el tablero ──
// Cada persona elige cómo verlo (se recuerda en este navegador). Las celdas se editan en el
// lugar y se guardan con los mismos pedidos que el panel de la tarjeta.
const MODO_KEY = 'hyf-tableros-modo';
const modos = () => { try { return JSON.parse(localStorage.getItem(MODO_KEY)) || {}; } catch (e) { return {}; } };
const modoDe = t => (t && modos()[t.id] === 'planilla' ? 'planilla' : 'tablero');
function ponerModo(t, m) {
    const o = modos(); if (m === 'planilla') o[t.id] = 'planilla'; else delete o[t.id];
    try { localStorage.setItem(MODO_KEY, JSON.stringify(o)); } catch (e) { /* sin almacenamiento */ }
}
let XO = null;   // orden de la planilla { tid, k, dir }
let XE = null;   // celda en edición { el, td, tid, id, k, f }
let XC = null;   // celda activa { id, k } (la que tiene tabindex 0)
const ANCHO_TIPO = { texto: 200, largo: 280, numero: 120, fecha: 150, lista: 160, multi: 220, persona: 180, correo: 220, telefono: 160, enlace: 180, casilla: 110 };
function colsPlanilla(t) {
    const NT = esNotion(t);
    return [
        { k: 'titulo', n: 'Título', w: 260, ed: true, ic: I.text },
        { k: 'col', n: 'Columna', w: 170, ed: true, ic: I.board },
        ...(NT ? [] : [{ k: 'asig', n: 'Asignada a', w: 190, ed: true, ic: I.user }, { k: 'seg', n: 'Seguimiento', w: 150, ed: true, ic: I.flag }]),
        ...t.campos.map(f => ({ k: 'c' + f.id, f, n: f.nombre, w: ANCHO_TIPO[f.tipo] || 180, ed: true, ic: TIPO_IC[f.tipo], tipo: f.tipo })),
        { k: 'arch', n: 'Archivos', w: 104, ic: I.clip },
        { k: 'notas', n: NT ? 'Comentarios' : 'Notas', w: NT ? 130 : 96, ic: I.note },
        { k: 'editada', n: 'Último cambio', w: 150, ic: I.clock },
    ];
}
/** Valor para ordenar una columna de la planilla (null = va al final). */
function claveXL(t, k) {
    const txt = s => (vacio(s) ? null : norm(s));
    if (k === 'titulo') return x => norm(x.titulo);
    if (k === 'col') return x => t.columnas.findIndex(c => c.id === x.col);
    if (k === 'asig') return x => (x.asignado ? norm(nombreDe(x.asignado)) : null);
    if (k === 'seg') return x => x.seguimiento || null;
    if (k === 'arch') return x => (x.archivos || []).length + (x.nArch || []).length;
    if (k === 'notas') return x => x.nNotas || 0;
    if (k === 'editada') return x => x.editada;
    const f = t.campos.find(c => 'c' + c.id === k); if (!f) return () => null;
    return x => {
        const v = x.datos[f.id]; if (f.tipo !== 'casilla' && vacio(v)) return null;
        if (f.tipo === 'lista') { const i = f.opciones.findIndex(o => o.id === v); return i < 0 ? null : i; }
        if (f.tipo === 'casilla') return v ? 0 : 1;
        if (f.tipo === 'numero') return +v;
        if (f.tipo === 'fecha') return v;
        return txt(textoValor(f, v));
    };
}
/** Filas que se ven (filtros + búsqueda + columnas visibles), en orden de columnas o por la columna elegida. */
function filasPlanilla(t) {
    const q = norm(busqueda), oc = t.listo ? Fde(t).ocultas : [];
    let filas = [];
    t.columnas.filter(c => !oc.includes(c.id) && !c.oculta).forEach(c => {
        const l = ordenar(t, tarjetasCol(t, c.id));
        filas.push(...(hayFiltro() ? l.filter(x => visible(t, x, q)) : l));
    });
    const o = XO && XO.tid === t.id && XO.k ? XO : null;
    if (o) {
        const key = claveXL(t, o.k);
        filas = filas.map((x, i) => [x, key(x), i]).sort((a, b) => {
            if (a[1] == null && b[1] == null) return a[2] - b[2];
            if (a[1] == null) return 1; if (b[1] == null) return -1;
            const c = typeof a[1] === 'string' ? a[1].localeCompare(b[1], 'es') : a[1] - b[1];
            return c * o.dir || a[2] - b[2];
        }).map(p => p[0]);
    }
    return filas;
}
function celdaInner(t, x, c, ED) {
    switch (c.k) {
        case 'titulo': return `<span class="tp-xl-tt">${x.id === t.molde ? `<span class="tp-xl-star" title="Tarjeta de ejemplo">${I.star}</span>` : ''}<span>${esc(x.titulo)}</span></span><button type="button" class="tp-xl-open" data-act="xl-abrir" tabindex="-1" aria-label="Abrir «${esc(x.titulo)}»">${I.open}<span>Abrir</span></button>`;
        case 'col': { const cc = colDe(t, x.col); return cc ? `<span class="tp-colpill tn-${cc.color}"><span class="tp-dot"></span><span>${esc(cc.nombre)}</span></span>` : ''; }
        case 'asig': return x.asignado ? `<span class="tp-xl-who">${av(x.asignado, 'tp-av--s')}<span>${esc(nombreDe(x.asignado))}</span></span>` : '';
        case 'seg': return x.seguimiento ? `<span class="tp-cd-follow${segVencido(x) ? ' is-due' : ''}" title="${esc(fechaCorta(x.seguimiento))}">${I.flag}${esc(segTxt(x))}</span>` : '';
        case 'arch': { const n = (x.archivos || []).length + (x.nArch || []).length; return n ? `<span class="tp-xl-num-ic">${I.clip}${n}</span>` : ''; }
        case 'notas': return x.nNotas ? `<span class="tp-xl-num-ic">${I.note}${x.nNotas}</span>` : '';
        case 'editada': return `<span class="tp-xl-faint" title="${fechaHora(x.editada)}">${rel(x.editada)}</span>`;
        default: {
            const f = c.f, v = x.datos[f.id];
            if (f.tipo === 'casilla') return `<label class="tp-xl-chk"><input type="checkbox" data-xchk="${f.id}" ${v ? 'checked' : ''} ${ED ? '' : 'disabled'} tabindex="-1" aria-label="${esc(f.nombre)} de «${esc(x.titulo)}»"></label>`;
            if (vacio(v)) return '';
            if (f.tipo === 'largo') return `<span class="tp-xl-txt" title="${esc(String(v).slice(0, 400))}">${esc(String(v).replace(/\s+/g, ' ').slice(0, 160))}</span>`;
            return `<span class="tp-xl-v">${valorHTML(f, v)}</span>`;
        }
    }
}
function planillaHTML(t) {
    const ED = puedeEditar(t), cols = colsPlanilla(t), filas = filasPlanilla(t), o = XO && XO.tid === t.id ? XO : {};
    if (!filas.length) {
        return `<section class="tp-empty tp-xl-empty"><span class="tp-empty-ic">${I.sheet}</span><h2>${hayFiltro() ? 'Ninguna tarjeta coincide' : 'Todavía no hay tarjetas'}</h2>
          <p>${hayFiltro() ? 'Prueba con otra búsqueda o quita algún filtro.' : 'Cuando crees tarjetas, aquí las verás como filas de una planilla.'}</p>
          ${hayFiltro() ? '<button type="button" class="tp-btn tp-btn-ghost" data-act="xl-limpiar">Quitar filtros y búsqueda</button>' : ED ? `<button type="button" class="tp-btn tp-btn-main" data-act="tarjeta-nueva">${I.plus}Nueva tarjeta</button>` : ''}</section>`;
    }
    const ancho = 52 + cols.reduce((s, c) => s + c.w, 0);
    return `<div class="tp-xl-wrap"><table class="tp-xl" style="width:${ancho}px" aria-label="Planilla de ${esc(t.nombre)}" aria-rowcount="${filas.length + 1}">
      <colgroup><col style="width:52px">${cols.map(c => `<col style="width:${c.w}px">`).join('')}</colgroup>
      <thead><tr><th class="tp-xl-n tp-xl-fix0" scope="col"><span class="tp-sr">Fila</span></th>${cols.map(c => `<th scope="col" class="${c.k === 'titulo' ? 'tp-xl-fix1' : ''}${c.f ? ' is-campo' : ''}" ${o.k === c.k ? `aria-sort="${o.dir > 0 ? 'ascending' : 'descending'}"` : ''}><button type="button" data-act="xl-orden" data-k="${c.k}" title="Ordenar por «${esc(c.n)}»"><span class="tp-xl-hic" aria-hidden="true">${c.ic || ''}</span><span class="tp-xl-hn">${esc(c.n)}</span>${I.sort}</button></th>`).join('')}</tr></thead>
      <tbody>${filas.map((x, i) => `<tr data-id="${x.id}" class="${DR && DR.cid === x.id ? 'is-sel' : ''}"><td class="tp-xl-n tp-xl-fix0"><button type="button" class="tp-xl-rn" data-act="xl-abrir" tabindex="-1" aria-label="Abrir «${esc(x.titulo)}»">${i + 1}</button></td>${cols.map(c => `<td class="${c.k === 'titulo' ? 'tp-xl-fix1 ' : ''}tp-xl-c-${c.tipo || c.k}" data-k="${c.k}"${ED && c.ed ? ' data-ed="1"' : ''} tabindex="-1">${celdaInner(t, x, c, ED)}</td>`).join('')}</tr>`).join('')}</tbody>
    </table></div>
    <p class="tp-xl-foot"><span>${plural(filas.length, 'fila', 'filas')}${hayFiltro() ? ` de ${t.tarjetas.length}` : ''}</span><span class="tp-xl-tip">${ED ? 'Clic en una celda para editarla · Enter edita · Esc cancela · flechas para moverte' : 'Solo lectura · clic en una fila para abrir la tarjeta'}</span>${ED ? `<button type="button" class="tp-btn-link" data-act="tarjeta-nueva">${I.plus}Nueva tarjeta</button>` : ''}</p>`;
}
/** Una sola celda de la planilla está en el orden del Tab (las demás se recorren con las flechas). */
function rovingXL(foco0) {
    const tb = app.querySelector('.tp-xl tbody'); if (!tb) return;
    let td = XC && tb.querySelector(`tr[data-id="${XC.id}"] td[data-k="${XC.k}"]`);
    if (!td) { td = tb.querySelector('td[data-k]'); XC = td ? { id: +td.parentElement.dataset.id, k: td.dataset.k } : null; }
    tb.querySelectorAll('td[tabindex="0"]').forEach(c => { if (c !== td) c.tabIndex = -1; });
    if (td) { td.tabIndex = 0; if (foco0) td.focus(); }
}
function activarCelda(td, enfocar) {
    XC = { id: +td.parentElement.dataset.id, k: td.dataset.k };
    rovingXL(false);
    if (enfocar) { td.focus(); td.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
}
/** Mueve la celda activa dx columnas / dy filas. */
function moverCelda(td, dx, dy) {
    const tr = td.parentElement, celdas = [...tr.querySelectorAll('td[data-k]')], i = celdas.indexOf(td);
    let destino = td;
    if (dx) destino = celdas[Math.max(0, Math.min(celdas.length - 1, i + dx))];
    if (dy) { const otra = dy > 0 ? tr.nextElementSibling : tr.previousElementSibling; if (otra) destino = otra.querySelectorAll('td[data-k]')[i] || destino; }
    activarCelda(destino, true);
}
const filaDe = td => { const t = actual(); return t && t.tarjetas.find(c => c.id === +td.parentElement.dataset.id); };
function editarCelda(td, inicial) {
    const t = actual(), x = filaDe(td); if (!x || !puedeEditar(t) || !td.dataset.ed) return;
    if (XE && !guardarCelda(0, 0, false, true)) return;   // la otra celda tiene un valor inválido
    const k = td.dataset.k, f = k[0] === 'c' ? t.campos.find(c => 'c' + c.id === k) : null;
    activarCelda(td, false);
    if (f && f.tipo === 'casilla') { const c = td.querySelector('[data-xchk]'); if (c) c.click(); return; }
    const conIni = inicial != null && (k === 'titulo' || (f && (TEXTOS.has(f.tipo) || f.tipo === 'numero')));
    let html;
    if (k === 'titulo') html = `<input id="xe-in" class="tp-in tp-xl-in" maxlength="120" value="${esc(conIni ? inicial : x.titulo)}" autocomplete="off" aria-label="Título de la tarjeta">`;
    else if (k === 'col') html = `<select id="xe-in" class="tp-in tp-xl-in" aria-label="Columna">${opcionesCol(t, x.col)}</select>`;
    else if (k === 'asig') {
        const ps = asignables(t);
        html = `<select id="xe-in" class="tp-in tp-xl-in" aria-label="Asignada a"><option value="">Sin asignar</option>${ps.map(a => `<option value="${a.id}" data-uid="${a.id}" ${a.id === x.asignado ? 'selected' : ''}>${esc(a.nombre)}${a.id === S.yo ? ' (yo)' : ''}</option>`).join('')}${x.asignado && !ps.some(a => a.id === x.asignado) ? `<option value="${x.asignado}" selected>${esc(nombreDe(x.asignado))} (sin acceso)</option>` : ''}</select>`;
    } else if (k === 'seg') html = `<input type="date" id="xe-in" class="tp-in tp-xl-in" value="${esc(x.seguimiento || '')}" aria-label="Seguimiento">`;
    else if (f) html = inputCampo(f, conIni ? inicial : x.datos[f.id], 'xe-in');
    else return;
    const pop = !!f && (f.tipo === 'largo' || f.tipo === 'multi');
    const el = document.createElement('div');
    el.className = 'tp-xl-ed' + (pop ? ' is-pop' : '') + (f ? ' is-' + f.tipo : ' is-' + k);
    el.innerHTML = `${pop ? `<span class="tp-xl-ed-h">${esc(f.nombre)}</span>` : ''}${html}<p class="tp-xl-ed-err" role="alert"></p>${pop ? `<div class="tp-xl-ed-foot"><span class="tp-help">${f.tipo === 'largo' ? 'Ctrl + Enter guarda' : ''}</span><button type="button" class="tp-btn tp-btn-ghost tp-btn-sm" data-xe="no">Cancelar</button><button type="button" class="tp-btn tp-btn-main tp-btn-sm" data-xe="ok">Guardar</button></div>` : ''}`;
    if (f && f.tipo === 'multi') { const g = el.querySelector('.tp-multi'); if (g) g.setAttribute('aria-label', f.nombre); }
    capas.appendChild(el);
    const r = td.getBoundingClientRect(), w = Math.min(innerWidth - 16, Math.max(r.width, pop ? 320 : r.width));
    el.style.width = w + 'px'; el.style.left = Math.max(8, Math.min(r.left, innerWidth - w - 8)) + 'px';
    if (pop) { const h = el.offsetHeight; el.style.top = Math.max(8, Math.min(r.top, innerHeight - h - 8)) + 'px'; }
    else { el.style.top = r.top + 'px'; el.style.minHeight = r.height + 'px'; }
    XE = { el, td, tid: t.id, id: x.id, k, f };
    td.classList.add('is-editing');
    el.addEventListener('click', e => { const b = e.target.closest('[data-xe]'); if (!b) return; if (b.dataset.xe === 'ok') guardarCelda(0, 0, true); else cerrarCelda(true); });
    const inp = el.querySelector('input#xe-in, select#xe-in, textarea#xe-in') || el.querySelector('input, textarea, select');
    if (inp && inp.tagName === 'SELECT') { if (mejorable(inp)) abrirSel(inp); else { inp.focus(); try { if (inp.showPicker) inp.showPicker(); } catch (e) { /* lo abre la persona */ } } }
    else if (inp) { inp.focus(); if (inp.select && !conIni && inp.type !== 'date') inp.select(); }
    if (inp && inp.tagName === 'TEXTAREA') autoAlto(inp);
}
function quitarEditor() {
    if (!XE) return;
    const { el, td } = XE; XE = null;
    if (SD && el.contains(SD.sel)) cerrarSel(false);
    el.remove(); td.classList.remove('is-editing');
}
function cerrarCelda(devolverFoco) {
    if (!XE) return;
    const td = XE.td; quitarEditor();
    if (devolverFoco && td.isConnected) td.focus(); else if (devolverFoco) rovingXL(true);
}
/** Vuelve a dibujar solo la fila (para no cambiar las celdas mientras se hace clic en otra). */
function pintarFila(t, x) {
    const tr = app.querySelector(`.tp-xl tr[data-id="${x.id}"]`); if (!tr) return;
    const cols = colsPlanilla(t), ED = puedeEditar(t);
    tr.querySelectorAll('td[data-k]').forEach(td => { const c = cols.find(o => o.k === td.dataset.k); if (c) td.innerHTML = celdaInner(t, x, c, ED); });
}
/** Guarda la celda en edición. `enLugar` = sin re-dibujar la planilla (clic afuera). */
function guardarCelda(dx = 0, dy = 0, enfocar, enLugar) {
    if (!XE) return true;
    const { el, tid, id, k, f } = XE, t = tablero(tid), x = t && t.tarjetas.find(c => c.id === id);
    if (!x) { quitarEditor(); return true; }
    const inp = el.querySelector('#xe-in');
    const error = m => { el.querySelector('.tp-xl-ed-err').textContent = m; const c = el.querySelector('[data-campo], #xe-in'); if (c) { c.setAttribute('aria-invalid', 'true'); c.focus(); } return false; };
    let accion = null, reordena = false;
    const fila = () => pintarFila(t, x);
    if (k === 'titulo') {
        const v = limpio(inp.value); if (!v) return error('El título no puede quedar vacío.');
        if (v !== x.titulo) {
            x.titulo = v; hist(x, 'edit', 'Editó «Título»'); tocar(t, x); reordena = true;
            accion = () => llamar(() => api.put(`/tarjetas/${x.id}`, { titulo: v })).then(d => { ponerTarjeta(t, d.tarjeta); if (DR && DR.cid === x.id) pintarDrawer(); }).catch(() => {});
        }
    } else if (k === 'col') {
        const c = +inp.value;
        if (c !== x.col && moverTarjeta(t, x.id, c, null)) { reordena = true; accion = () => { guardarMov(t, x.id); anunciar(`Movida a «${colDe(t, c).nombre}»`); }; }
    } else if (k === 'asig') {
        const v = inp.value ? +inp.value : null;
        if ((x.asignado || null) !== v) accion = () => setAsignado(t, x, v, false, fila);
    } else if (k === 'seg') {
        const v = inp.value, y = +v.slice(0, 4);
        if (v && (!/^\d{4}-\d{2}-\d{2}$/.test(v) || y < 2000 || y > 2100)) return error('Elige una fecha válida.');
        if ((x.seguimiento || null) !== (v || null)) accion = () => setSeguimiento(t, x, v || null, fila);
    } else if (f) {
        const v = leerCampo(f, el), m = validar(f, v); if (m) return error(m);
        const nv = normalizar(f, v);
        if (!igual(x.datos[f.id], nv)) {
            setDato(x, f, nv); hist(x, 'edit', `«${f.nombre}»: ${textoValor(f, nv)}`); tocar(t, x);
            reordena = !!Fde(t).orden || !!(XO && XO.k === k) || hayFiltro();
            accion = () => llamar(() => api.put(`/tarjetas/${x.id}`, { datos: { [f.id]: vacio(nv) ? null : nv } })).then(d => { ponerTarjeta(t, d.tarjeta); if (DR && DR.cid === x.id) pintarDrawer(); }).catch(() => {});
        }
    }
    quitarEditor();
    if (accion) accion();
    if (enLugar) { fila(); if (reordena) setTimeout(() => { if (!XE && !SD && actual() === t) pintarZona(); }, 400); return true; }
    pintarZona();
    const td2 = app.querySelector(`.tp-xl tr[data-id="${id}"] td[data-k="${k}"]`);
    if (td2) { if (dx || dy) moverCelda(td2, dx, dy); else activarCelda(td2, enfocar !== false); }
    else rovingXL(true);
    return true;
}
/** Teclas sobre una celda (sin editar): flechas, Enter/F2, Espacio, Supr, escribir. */
function teclaCelda(td, e) {
    const k = e.key, x = filaDe(td), t = actual();
    const mov = { ArrowRight: [1, 0], ArrowLeft: [-1, 0], ArrowDown: [0, 1], ArrowUp: [0, -1] }[k];
    if (mov) { e.preventDefault(); moverCelda(td, mov[0], mov[1]); return; }
    if (k === 'Home' || k === 'End') { e.preventDefault(); const cs = [...td.parentElement.querySelectorAll('td[data-k]')]; activarCelda(k === 'Home' ? cs[0] : cs[cs.length - 1], true); return; }
    if (k === 'Tab') return;
    if (!x) return;
    if (k === 'Enter' || k === 'F2') { e.preventDefault(); if (td.dataset.ed) editarCelda(td); else abrirTarjeta(x.id); return; }
    if (k === ' ' && td.dataset.ed) { e.preventDefault(); editarCelda(td); return; }
    if ((k === 'Delete' || k === 'Backspace') && td.dataset.ed && td.dataset.k[0] === 'c') {
        e.preventDefault();
        const f = t.campos.find(c => 'c' + c.id === td.dataset.k);
        if (!f || vacio(x.datos[f.id])) return;
        setDato(x, f, null); hist(x, 'edit', `«${f.nombre}»: ${textoValor(f, null)}`); tocar(t, x); pintarFila(t, x);
        llamar(() => api.put(`/tarjetas/${x.id}`, { datos: { [f.id]: null } })).then(d => { ponerTarjeta(t, d.tarjeta); }).catch(() => {});
        anunciar(`«${f.nombre}» vaciado`); return;
    }
    if (td.dataset.ed && k.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        const f = t.campos.find(c => 'c' + c.id === td.dataset.k);
        if (td.dataset.k === 'titulo' || (f && (TEXTOS.has(f.tipo) || f.tipo === 'numero'))) { e.preventDefault(); editarCelda(td, k); }
    }
}
/** Casilla (sí / no) en la planilla: se guarda al instante. */
function casillaXL(el) {
    const t = actual(), td = el.closest('td'), x = td && filaDe(td), f = t && t.campos.find(c => c.id === +el.dataset.xchk);
    if (!x || !f || !puedeEditar(t)) { el.checked = !el.checked; return; }
    const v = el.checked ? true : null;
    setDato(x, f, v); hist(x, 'edit', `«${f.nombre}»: ${textoValor(f, v)}`); tocar(t, x);
    activarCelda(td, false);
    llamar(() => api.put(`/tarjetas/${x.id}`, { datos: { [f.id]: v } })).then(d => { ponerTarjeta(t, d.tarjeta); if (DR && DR.cid === x.id) pintarDrawer(); }).catch(() => {});
    anunciar(`«${f.nombre}»: ${v ? 'Sí' : 'No'}`);
}
// ── Exportar a Excel (lo que se ve: filtros, búsqueda y orden) ──
function valorExcel(f, v) {
    if (f.tipo === 'casilla') return v ? 'Sí' : 'No';
    if (vacio(v)) return '';
    switch (f.tipo) {
        case 'lista': { const o = f.opciones.find(o => o.id === v); return o ? o.nombre : ''; }
        case 'multi': return v.map(id => (f.opciones.find(o => o.id === id) || {}).nombre).filter(Boolean).join(', ');
        case 'persona': return nombreDe(v);
        case 'numero': return typeof v === 'number' ? v : String(v);
        default: return String(v);
    }
}
async function exportarExcel(t) {
    let XLSX;
    try { XLSX = await import(/* webpackChunkName: "xlsx" */ 'xlsx'); } catch (e) { toast('No se pudo preparar el Excel. Recarga la página e intenta de nuevo.'); return; }
    const filas = filasPlanilla(t);
    if (!filas.length) { toast('No hay filas para exportar con estos filtros.'); return; }
    const fh = ms => (ms ? new Date(ms).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
    const datos = filas.map(x => {
        const o = esNotion(t) ? { 'Título': x.titulo, 'Columna': (colDe(t, x.col) || {}).nombre || '' } : { 'Título': x.titulo, 'Columna': (colDe(t, x.col) || {}).nombre || '', 'Asignada a': x.asignado ? nombreDe(x.asignado) : '', 'Seguimiento': x.seguimiento || '' };
        t.campos.forEach(f => { o[f.nombre] = valorExcel(f, x.datos[f.id]); });
        o['Archivos'] = (x.archivos || []).length + (x.nArch || []).length; o[esNotion(t) ? 'Comentarios' : 'Notas'] = x.nNotas || 0;
        o['Creada'] = fh(x.creada); o['Creada por'] = x.por ? nombreDe(x.por) : (x.nUrl ? 'Notion' : ''); o['Último cambio'] = fh(x.editada);
        if (x.nUrl) o['Enlace a Notion'] = x.nUrl;
        return o;
    });
    const ws = XLSX.utils.json_to_sheet(datos);
    const cab = Object.keys(datos[0]);
    ws['!cols'] = cab.map(h => ({ wch: Math.min(60, Math.max(10, h.length + 2, ...datos.slice(0, 200).map(d => String(d[h] == null ? '' : d[h]).length + 1))) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, (t.nombre.replace(/[\][:*?/\\]/g, ' ').trim() || 'Tablero').slice(0, 31));
    const archivo = (norm(t.nombre).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'tablero') + '-' + hoyISO() + '.xlsx';
    XLSX.writeFile(wb, archivo);
    toast(`Se descargó «${archivo}» con ${plural(filas.length, 'fila', 'filas')}.`);
}

// ── Capas: menú, ventanas, panel ──
let P = null, M = null, DR = null;
function bloquear() { document.documentElement.classList.toggle('tp-locked', !!(M || DR || VW)); medirCookies(); }
/** El aviso de cookies del sitio (fijo abajo) no debe tapar los botones: se deja su alto libre
 *  (como en Reservas y Usuarios). */
function medirCookies() {
    const c = document.querySelector('.cookie-footer'), r = c && c.getBoundingClientRect();
    const alto = r && r.height > 0 && r.top < innerHeight && getComputedStyle(c).display !== 'none' && getComputedStyle(c).visibility !== 'hidden' ? Math.round(r.height) : 0;
    raiz.style.setProperty('--tp-cookies', alto + 'px');
}
function cerrarTodo() { cerrarSel(false); if (XE) quitarEditor(); cerrarPop(true); if (M) cerrarModal(true); if (VW) cerrarVisor(true); if (DR) cerrarDrawer(true); }

function abrirPop(anchor, items, label) {
    if (P && P.anchor === anchor) { cerrarPop(); return; }
    cerrarPop(true);
    const el = document.createElement('div');
    el.className = 'tp-pop'; el.setAttribute('role', 'menu'); el.setAttribute('aria-label', label || 'Opciones');
    el.innerHTML = items.map((it, i) => it.sep ? '<div class="tp-pop-sep" role="separator"></div>'
        : it.head ? `<h4>${esc(it.head)}</h4>`
        : `<button type="button" role="menuitem" class="tp-pop-item${it.danger ? ' is-danger' : ''}" data-i="${i}" ${it.disabled ? 'disabled' : ''} ${it.current ? 'aria-current="true"' : ''}>${it.ic || ''}<span>${esc(it.txt)}</span>${it.current ? I.check : ''}</button>`).join('');
    capas.appendChild(el);
    const r = anchor.getBoundingClientRect(), w = el.offsetWidth, h = el.offsetHeight;
    let top = r.bottom + 6; if (top + h > innerHeight - 8) top = Math.max(8, r.top - h - 6);
    el.style.left = Math.max(8, Math.min(r.right - w, innerWidth - w - 8)) + 'px';
    el.style.top = top + 'px';
    anchor.setAttribute('aria-expanded', 'true');
    P = { el, anchor };
    el.addEventListener('click', e => {
        const b = e.target.closest('[data-i]'); if (!b || b.disabled) return;
        const it = items[+b.dataset.i]; cerrarPop(); it.fn();
    });
    const prim = el.querySelector('.tp-pop-item:not(:disabled)'); if (prim) prim.focus();
}
function cerrarPop(sinFoco) {
    if (!P) return;
    const { el, anchor } = P; P = null; el.remove();
    anchor.setAttribute('aria-expanded', 'false');
    if (!sinFoco && anchor.isConnected) anchor.focus();
}

// ── Desplegables con diseño propio ──
// Se dibujan encima del <select> de siempre: al elegir se cambia su valor y se disparan
// `input` + `change`, así toda la lógica sigue igual (formularios, ficha, filtros, molde…).
// En pantallas táctiles queda el selector nativo del teléfono (más cómodo y accesible).
let SD = null;
const tactil = () => window.matchMedia && matchMedia('(hover: none) and (pointer: coarse)').matches;
const mejorable = el => !!el && el.tagName === 'SELECT' && !el.disabled && !el.multiple && raiz.contains(el) && !tactil();
function itemsSel(sel) {
    const out = [];
    const opt = (o, g) => out.push({ v: o.value, txt: o.textContent, dis: o.disabled, tn: o.dataset.tn || '', uid: +o.dataset.uid || 0, g });
    [...sel.children].forEach(c => {
        if (c.tagName === 'OPTGROUP') { out.push({ grupo: c.label }); [...c.children].forEach(o => opt(o, c.label)); }
        else if (c.tagName === 'OPTION') opt(c);
    });
    return out;
}
function itemSelHTML(it, i, val) {
    const on = it.v === val;
    const cuerpo = it.tn ? `<span class="tp-pill tn-${esc(it.tn)}">${esc(it.txt)}</span>`
        : it.uid ? `${av(it.uid, 'tp-av--s')}<span class="tp-dd-t">${esc(it.txt)}</span>`
        : `<span class="tp-dd-t">${esc(it.txt)}</span>`;
    return `<button type="button" role="option" class="tp-dd-it${it.v === '' ? ' is-empty' : ''}" data-i="${i}" aria-selected="${on}" ${it.dis ? 'disabled' : ''}>${cuerpo}${on ? `<span class="tp-dd-ck">${I.check}</span>` : ''}</button>`;
}
function pintarSel(q) {
    const n = norm(q), lista = SD.el.querySelector('.tp-dd-list'), val = SD.sel.value;
    let html = '', grupo = null;
    SD.items.forEach((it, i) => {
        if (it.grupo != null) return;
        if (n && !norm(it.txt).includes(n)) return;
        if (it.g && it.g !== grupo) { grupo = it.g; html += `<div class="tp-dd-g" role="presentation">${esc(it.g)}</div>`; }
        html += itemSelHTML(it, i, val);
    });
    lista.innerHTML = html || '<p class="tp-dd-none">Sin resultados</p>';
}
function abrirSel(sel) {
    if (SD && SD.sel === sel) { cerrarSel(true); return; }
    cerrarSel(false); cerrarPop(true);
    const items = itemsSel(sel), buscar = items.filter(x => x.grupo == null).length > 8;
    const el = document.createElement('div');
    el.className = 'tp-dd';
    const etiqueta = (sel.labels && sel.labels[0] && sel.labels[0].textContent.trim()) || sel.getAttribute('aria-label') || 'Opciones';
    el.innerHTML = `${buscar ? `<label class="tp-dd-search">${I.search}<input type="text" placeholder="Buscar…" aria-label="Buscar en ${esc(etiqueta)}" autocomplete="off"></label>` : ''}<div class="tp-dd-list" role="listbox" aria-label="${esc(etiqueta)}"></div>`;
    capas.appendChild(el);
    SD = { sel, el, items, t0: Date.now() };
    pintarSel('');
    sel.classList.add('is-open'); sel.setAttribute('aria-expanded', 'true');
    const r = sel.getBoundingClientRect(), w = Math.min(Math.max(r.width, 220), innerWidth - 16);
    el.style.width = w + 'px';
    const alto = Math.min(el.scrollHeight, 360), abajo = innerHeight - r.bottom - 12, arriba = r.top - 12;
    const max = Math.max(150, Math.min(360, abajo >= alto || abajo >= arriba ? abajo : arriba));
    el.style.maxHeight = max + 'px';
    el.style.left = Math.max(8, Math.min(r.left, innerWidth - w - 8)) + 'px';
    el.style.top = (abajo >= Math.min(alto, max) || abajo >= arriba ? r.bottom + 6 : r.top - Math.min(alto, max) - 6) + 'px';
    el.addEventListener('click', e => {
        const b = e.target.closest('.tp-dd-it'); if (!b || b.disabled) return;
        elegirSel(SD.items[+b.dataset.i].v);
    });
    el.addEventListener('input', e => { if (e.target.tagName === 'INPUT') { e.stopPropagation(); pintarSel(e.target.value); } });
    el.addEventListener('mousedown', e => { if (!e.target.closest('input')) e.preventDefault(); });   // el foco no se va del ítem/buscador
    const s = el.querySelector('[aria-selected="true"]'); if (s) s.scrollIntoView({ block: 'nearest' });
    (el.querySelector('.tp-dd-search input') || s || el.querySelector('.tp-dd-it:not(:disabled)') || el).focus();
}
function elegirSel(v) {
    const sel = SD.sel, cambio = sel.value !== v;
    cerrarSel(true, true);
    if (cambio && sel.isConnected) {
        sel.value = v;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (M && M.repintar) pintarCompartir(M.repintar);
}
function cerrarSel(devolverFoco, sinRepintar) {
    if (!SD) return;
    const { el, sel } = SD; SD = null; el.remove();
    sel.classList.remove('is-open'); sel.removeAttribute('aria-expanded');
    if (devolverFoco && sel.isConnected) sel.focus();
    if (!sinRepintar && M && M.repintar) pintarCompartir(M.repintar);
}
/** Si se re-dibujó lo que estaba debajo del desplegable abierto, se cierra. */
const revisarSel = () => { if (SD && !SD.sel.isConnected) cerrarSel(false); };

const askHTML = () => '<div class="tp-ask"><p>Tienes cambios sin guardar.</p><button type="button" class="tp-btn tp-btn-ghost tp-btn-sm" data-act="ask-no">Seguir editando</button><button type="button" class="tp-btn tp-btn-danger tp-btn-sm" data-act="ask-si">Descartar cambios</button></div>';
function abrirModal(html, opts = {}) {
    if (M) cerrarModal(true);
    const w = document.createElement('div'); w.innerHTML = html.trim();
    const el = w.firstElementChild; capas.appendChild(el);
    M = { el, opener: document.activeElement, dirty: false, ...opts };
    bloquear();
    requestAnimationFrame(() => {
        const f = el.querySelector('[autofocus]') || el.querySelector('.tp-md-body input:not([type=radio]):not([type=checkbox]), .tp-md-body textarea') || el.querySelector('.tp-md-foot .tp-btn:last-of-type');
        if (f) f.focus();
    });
    return el;
}
function cerrarModal(forzar) {
    if (!M) return;
    if (!forzar && M.dirty) {
        const foot = M.el.querySelector('.tp-md-foot');
        if (foot && foot.querySelector('.tp-ask')) { foot.classList.add('is-asking'); foco(foot.querySelector('[data-act="ask-no"]')); return; }
    }
    const { el, opener, onClose } = M; M = null; el.remove(); revisarSel();
    if (onClose) onClose();
    bloquear();
    if (opener && opener.isConnected) opener.focus();
}
function modalHTML({ titulo, sub, cuerpo, pie, form, xl, l, ask }) {
    return `<div class="tp-md${xl ? ' tp-md--xl' : l ? ' tp-md--l' : ''}" role="dialog" aria-modal="true" aria-labelledby="md-t">
      <div class="tp-md-bg" data-act="cerrar"></div>
      <form class="tp-md-card" data-form="${form}" novalidate>
        <header class="tp-md-head"><div><h2 id="md-t">${titulo}</h2>${sub ? `<p>${sub}</p>` : ''}</div><button type="button" class="tp-ib" data-act="cerrar" aria-label="Cerrar">${I.x}</button></header>
        <div class="tp-md-body">${cuerpo}</div>
        <footer class="tp-md-foot"><p class="tp-err" id="md-err" role="alert"></p>${pie}${ask ? askHTML() : ''}</footer>
      </form></div>`;
}
const pieBtns = (txt, cls = 'tp-btn-main') => `<button type="button" class="tp-btn tp-btn-ghost" data-act="cerrar">Cancelar</button><button type="submit" class="tp-btn ${cls}">${txt}</button>`;
function confirmar({ titulo, texto, boton, fn }) {
    abrirModal(modalHTML({ titulo, cuerpo: `<p>${texto}</p>`, pie: pieBtns(boton, 'tp-btn-danger-main'), form: 'confirm' }), { onOk: fn });
}
function errCampo(el, msg) {
    if (!el) return;
    el.setAttribute('aria-invalid', 'true');
    const p = document.getElementById(el.id + '-e'); if (p) p.textContent = msg;
}
function limpiarErrores(root) {
    root.querySelectorAll('[aria-invalid]').forEach(e => e.removeAttribute('aria-invalid'));
    root.querySelectorAll('.tp-err').forEach(p => { p.textContent = ''; });
}

// ── Tablero: crear / editar / eliminar ──
function modalTablero(t) {
    const d = t ? t.desc : '';
    abrirModal(modalHTML({
        titulo: t ? 'Editar tablero' : 'Nuevo tablero',
        sub: t ? '' : 'Primero dale un nombre y una breve descripción. Después creas las columnas y la tarjeta de ejemplo.',
        form: 'tablero',
        cuerpo: `<input type="hidden" name="id" value="${t ? t.id : ''}">
          <div class="tp-f"><label for="b-nom">Nombre del tablero</label><input id="b-nom" name="nombre" class="tp-in" maxlength="60" value="${esc(t ? t.nombre : '')}" placeholder="Ej.: Proveedores de limpieza" autocomplete="off" autofocus><p class="tp-err" id="b-nom-e" role="alert"></p></div>
          <div class="tp-f"><label for="b-desc">Breve descripción <span class="tp-help">(opcional)</span></label><textarea id="b-desc" name="desc" class="tp-in" rows="3" maxlength="200" placeholder="¿Para qué es este tablero?">${esc(d)}</textarea><span class="tp-count" id="b-desc-n">${d.length}/200</span></div>
          <p class="tp-lock">${I.lock}Solo tú verás este tablero.</p>`,
        pie: pieBtns(t ? 'Guardar' : 'Crear tablero'),
    }));
}
function menuTablero(b, t, enInicio) {
    if (!t) return;
    const e = t.columnas ? etapaDe(t) : etapaLista(t), OW = esDueno(t), AR = OW && !esNotion(t);
    abrirPop(b, [
        { head: t.nombre },
        enInicio ? { txt: 'Abrir', ic: I.board, fn() { opciones.navegar(t.id); } } : { txt: 'Tableros', ic: I.back, fn() { opciones.navegar(0); } },
        !enInicio && t.listo ? { txt: modoDe(t) === 'planilla' ? 'Ver como tablero' : 'Ver como planilla', ic: modoDe(t) === 'planilla' ? I.board : I.sheet, fn() { ponerModo(t, modoDe(t) === 'planilla' ? 'tablero' : 'planilla'); render(); } } : null,
        !enInicio && t.listo ? { txt: 'Exportar a Excel', ic: I.excel, fn() { exportarExcel(t); } } : null,
        !enInicio && esNotion(t) ? { txt: 'Actualizar desde Notion', ic: I.undo, fn() { syncNotion(t, true); } } : null,
        !enInicio && moverColsNotion(t) ? { txt: 'Columnas como en Notion', ic: I.board, fn() { modalColsNotion(t, false); } } : null,
        !enInicio && esNotion(t) && t.notion && t.notion.url ? { txt: 'Abrir en Notion', ic: I.open, fn() { window.open(t.notion.url, '_blank', 'noopener'); } } : null,
        AR ? { txt: 'Editar nombre y descripción', ic: I.edit, fn() { modalTablero(t); } } : null,
        OW ? { txt: 'Compartir', ic: I.users, fn() { if (enInicio) { compartirTras = true; opciones.navegar(t.id); } else abrirCompartir(t); } } : null,
        AR && !enInicio && e !== 'columnas' ? { txt: 'Agregar columna', ic: I.plus, fn() { modalColumna(t, null); } } : null,
        AR && !enInicio && t.listo ? { txt: 'Molde de tarjeta', ic: I.layout, fn() { abrirMolde(t); } } : null,
        OW ? { txt: 'Traspasar a otro admin', ic: I.arrow, fn() { modalTraspaso(t); } } : null,
        puedeSalir(t) ? { txt: 'Salir del tablero', ic: I.back, danger: 1, fn() { salirDeTablero(t); } } : null,
        OW ? { sep: 1 } : null,
        OW ? { txt: 'Eliminar tablero', ic: I.trash, danger: 1, fn() { borrarTablero(t); } } : null,
    ].filter(Boolean), 'Opciones del tablero');
}

// «Nuevo tablero de Notion»: lista los tableros que la conexión de Notion ve y crea la copia.
async function modalNotion() {
    abrirModal(modalHTML({ titulo: `${LOGO_NOTION}Nuevo tablero de Notion`, form: 'notion', l: true,
        sub: 'Elige un tablero de Notion: se copia aquí tal cual (columnas, datos, comentarios) y se actualiza solo. Es de solo lectura: lo puedes filtrar, guardar vistas, ver como planilla, exportar y compartir.',
        cuerpo: '<div class="tp-loading" role="status"><span class="tp-spin" aria-hidden="true"></span>Buscando tus tableros en Notion…</div>',
        pie: pieBtns('Traer el tablero') }), { kind: 'notion' });
    const m = M;
    m.el.querySelector('button[type=submit]').disabled = true;
    let d;
    try { d = await api.get('/notion'); }
    catch (e) { if (M === m) M.el.querySelector('.tp-md-body').innerHTML = `<section class="tp-empty tp-empty--s"><span class="tp-empty-ic">${I.lock}</span><h3>No se pudo leer Notion</h3><p>${esc(msgErr(e))}</p></section>`; return; }
    if (M !== m) return;
    M.lista = d.tableros || [];
    const body = M.el.querySelector('.tp-md-body');
    if (!M.lista.length) {
        body.innerHTML = `<section class="tp-empty tp-empty--s"><span class="tp-empty-ic">${LOGO_NOTION}</span><h3>No hay tableros compartidos</h3><p>En Notion, abre el tablero → «…» → Conexiones → agrega «House &amp; Flats – Tableros». Solo aparecen las bases que tienen una vista de tipo Tablero.</p></section>`;
        return;
    }
    body.innerHTML = `<fieldset class="tp-fg"><legend>${I.board}Tableros en Notion <span class="tp-n">${M.lista.length}</span></legend><div class="tp-nt-list">${M.lista.map((b, i) => `
        <label class="tp-radio tp-nt-it"><input type="radio" name="ds" value="${esc(b.ds)}" ${i === 0 && !b.copias.length ? 'checked' : ''}>
          <span><b>${esc(b.nombre)}</b><small>${b.vistas.length === 1 ? `Vista «${esc(b.vistas[0].nombre)}» · columnas por «${esc(b.vistas[0].grupo || 'Estado')}»` : `${b.vistas.length} vistas de tablero`}${b.editado ? ` · editado en Notion ${rel(b.editado)}` : ''}</small>
          ${b.copias.length ? `<small class="tp-nt-ya">${I.check}Ya está aquí: ${b.copias.map(c => `<a href="/admin/tableros/${c.id}" data-nav="${c.id}">${esc(c.nombre)}</a>`).join(', ')}</small>` : ''}
          ${b.vistas.length > 1 ? `<span class="tp-nt-vista"><select class="tp-in tp-in--s" name="vista-${esc(b.ds)}" aria-label="Vista de «${esc(b.nombre)}»">${b.vistas.map(v => `<option value="${esc(v.id)}">${esc(v.nombre)} · por «${esc(v.grupo || 'Estado')}»</option>`).join('')}</select></span>` : ''}</span>
          <a class="tp-ib" href="${esc(b.url)}" target="_blank" rel="noopener noreferrer" aria-label="Ver «${esc(b.nombre)}» en Notion" title="Ver en Notion">${I.open}</a></label>`).join('')}</div></fieldset>
      <p class="tp-help">${I.info}<span> Solo aparecen los tableros que se compartieron con la conexión «House &amp; Flats – Tableros» en Notion. La copia queda solo para ti hasta que la compartas.</span></p>`;
    M.el.querySelector('button[type=submit]').disabled = false;
}
/** Aplica un cambio de acceso (se ve al instante) y lo manda a la API, que avisa a cada persona
 *  y deja sin asignar las tarjetas de quien ya no puede editar. */
// «Columnas como en Notion»: la API de Notion no da el orden manual de las columnas del
// tablero ni cuáles están ocultas → el dueño lo deja igual una vez (vale para todos).
const moverColsNotion = t => esDueno(t) && esNotion(t);
function modalColsNotion(t, alImportar) {
    abrirModal(modalHTML({ titulo: `${LOGO_NOTION}Columnas como en Notion`, form: 'cols-notion', l: true,
        sub: (alImportar ? '¡Listo, ya está aquí! Último paso: ' : '') + 'Notion no comparte el orden de las columnas de tu tablero ni cuáles tienes ocultas. Déjalas igual que en Notion: el orden y las ocultas se guardan para todos y se respetan cada vez que se actualiza.',
        cuerpo: '<ol class="tp-cn-l" id="cn-l"></ol><p class="tp-err" id="cn-e" role="alert"></p>',
        pie: (alImportar ? '<button type="button" class="tp-btn tp-btn-ghost" data-act="cerrar">Ahora no</button>' : '<button type="button" class="tp-btn tp-btn-ghost" data-act="cerrar">Cancelar</button>') + '<button type="submit" class="tp-btn tp-btn-main">Guardar columnas</button>' }),
        { kind: 'cols-notion', tid: t.id, cols: t.columnas.map(c => ({ id: c.id, oculta: alImportar && !t.notion.manual ? !t.tarjetas.some(x => x.col === c.id) : !!c.oculta })) });
    pintarColsNotion();
}
function pintarColsNotion(focoSel) {
    if (!M || M.kind !== 'cols-notion') return;
    const t = tablero(M.tid);
    M.el.querySelector('#cn-l').innerHTML = M.cols.map((it, i) => {
        const c = colDe(t, it.id); if (!c) return '';
        const k = t.tarjetas.filter(x => x.col === c.id).length;
        return `<li class="tp-cn${it.oculta ? ' is-off' : ''}" data-cid="${c.id}"><button type="button" class="tp-cn-grip" id="cng-${c.id}" aria-label="Mover «${esc(c.nombre)}» (arrastra, o usa las flechas ↑ ↓)" title="Arrastra para mover">${GRIP}</button><span class="tp-collist-n">${i + 1}</span><span class="tp-colpill tn-${c.color}"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span><span class="tp-n">${plural(k, 'tarjeta', 'tarjetas')}</span><span class="tp-sp"></span>
          <label class="tp-tog"><input type="checkbox" data-cn="ver" ${it.oculta ? '' : 'checked'}><span>${I.eye}${it.oculta ? 'Oculta' : 'Se ve'}</span></label></li>`;
    }).join('');
    if (focoSel) { const el = M.el.querySelector(focoSel); if (el) el.focus(); }
}
const GRIP = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><g fill="currentColor"><circle cx="9" cy="6" r="1.6"/><circle cx="15" cy="6" r="1.6"/><circle cx="9" cy="12" r="1.6"/><circle cx="15" cy="12" r="1.6"/><circle cx="9" cy="18" r="1.6"/><circle cx="15" cy="18" r="1.6"/></g></svg>';
/** Mueve una columna en la lista de «Columnas como en Notion» (teclado). */
function moverColNotion(cid, d) {
    const i = M.cols.findIndex(c => c.id === cid), j = i + d;
    if (i < 0 || j < 0 || j >= M.cols.length) return;
    [M.cols[i], M.cols[j]] = [M.cols[j], M.cols[i]]; M.dirty = true;
    pintarColsNotion('#cng-' + cid); anunciar(`Columna movida a la posición ${j + 1}`);
}
// Arrastrar filas de la lista (mouse: desde cualquier parte de la fila; táctil: desde el agarre).
let DN = null;
function empezarDN() {
    const li = DN.li, r = li.getBoundingClientRect();
    DN.on = true; DN.dy = DN.y0 - r.top; DN.dx = DN.x0 - r.left;
    DN.ghost = li.cloneNode(true); DN.ghost.classList.add('tp-cn-ghost'); DN.ghost.style.width = r.width + 'px';
    capas.appendChild(DN.ghost);
    li.classList.add('is-src');
    document.documentElement.classList.add('tp-dragging');
    seguirDN();
    DN.raf = requestAnimationFrame(autoDN);
}
function seguirDN() {
    DN.ghost.style.transform = `translate(${DN.x - DN.dx}px, ${DN.y - DN.dy}px)`;
    const ol = DN.li.parentElement, otras = [...ol.children].filter(x => x !== DN.li);
    const sig = otras.find(x => { const r = x.getBoundingClientRect(); return DN.y < r.top + r.height / 2; });
    if (sig) { if (DN.li.nextElementSibling !== sig) ol.insertBefore(DN.li, sig); }
    else if (ol.lastElementChild !== DN.li) ol.appendChild(DN.li);
    [...ol.children].forEach((x, i) => { const n = x.querySelector('.tp-collist-n'); if (n) n.textContent = i + 1; });
}
function autoDN() {
    if (!DN || !DN.on) return;
    const box = M && M.el.querySelector('.tp-md-body');
    if (box) {
        const r = box.getBoundingClientRect(), antes = box.scrollTop;
        if (DN.y < r.top + 50) box.scrollTop -= 12; else if (DN.y > r.bottom - 50) box.scrollTop += 12;
        if (box.scrollTop !== antes) seguirDN();
    }
    DN.raf = requestAnimationFrame(autoDN);
}
function soltarDN() {
    cancelAnimationFrame(DN.raf);
    DN.ghost.remove(); DN.li.classList.remove('is-src');
    document.documentElement.classList.remove('tp-dragging');
    if (M && M.kind === 'cols-notion') {
        const ids = [...DN.li.parentElement.children].map(x => +x.dataset.cid);
        const antes = M.cols.map(c => c.id).join();
        M.cols = ids.map(id => M.cols.find(c => c.id === id)).filter(Boolean);
        if (M.cols.map(c => c.id).join() !== antes) { M.dirty = true; anunciar(`Columna movida a la posición ${ids.indexOf(DN.cid) + 1}`); }
        pintarColsNotion();
        const li = M.el.querySelector(`.tp-cn[data-cid="${DN.cid}"]`);
        if (li) { li.classList.add('is-flash'); setTimeout(() => li.classList.remove('is-flash'), 900); }
    }
}
async function guardarColsNotion(t, cols, form) {
    const ocultas = cols.filter(c => c.oculta).map(c => c.id);
    try {
        const d = await api.put(`/${t.id}/notion-columnas`, { orden: cols.map(c => c.id), ocultas });
        aplicarTablero(d); return true;
    } catch (e) {
        if (form) { const p = form.querySelector('#cn-e'); if (p) p.textContent = msgErr(e); }
        else { toast(msgErr(e)); recargar(); }
        return false;
    }
}
// Los cambios de acceso van de a uno y siempre con el estado MÁS NUEVO. Antes cada clic
// mandaba su PUT en paralelo con la lista completa: al agregar el 3.º/4.º admin seguido,
// la respuesta (o el PUT) del cambio anterior llegaba después y borraba al recién agregado.
let accCola = Promise.resolve(), accSeq = 0;
function aplicarAcceso(t, cambio) {
    cambio();
    const mio = ++accSeq;
    pintarCompartir(t);   // se ve al instante, sin esperar a la API
    const corrida = accCola.then(async () => {
        if (mio !== accSeq) return true;   // viene otro cambio más nuevo: ese manda todo junto
        const tt = S.t && S.t.id === t.id ? S.t : t;
        try {
            const d = await api.put(`/${tt.id}/acceso`, { visib: tt.visib, rolEquipo: tt.rolEquipo, miembros: (tt.miembros || []).filter(m => m.id !== tt.dueno).map(m => ({ id: m.id, rol: m.rol })) });
            if (mio !== accSeq) return true;   // mientras tanto hubo otro cambio: no pisar lo de la pantalla
            aplicarTablero(d.tablero);
            if (d.desasignadas) toast(`${plural(d.desasignadas, 'tarjeta quedó', 'tarjetas quedaron')} sin asignar.`);
            pintarCompartir(S.t);
            if (actual() === S.t) pintarZona();
            return true;
        } catch (e) {
            toast(msgErr(e));
            if (mio === accSeq) { await recargar(); pintarCompartir(S.t); }
            return false;
        }
    });
    accCola = corrida.catch(() => {});
    return corrida;
}
function abrirCompartir(t) {
    abrirModal(modalHTML({ titulo: `Compartir «${esc(t.nombre)}»`, sub: 'Los cambios se guardan al instante y a cada persona le llega un aviso.', form: 'compartir', l: true,
        cuerpo: compartirHTML(t), pie: '<button type="button" class="tp-btn tp-btn-main" data-act="cerrar">Listo</button>' }), { kind: 'compartir', tid: t.id });
}
function compartirHTML(t) {
    const rad = (v, tit, txt, ic) => `<label class="tp-radio"><input type="radio" name="visib" value="${v}" ${t.visib === v ? 'checked' : ''}><span><b>${ic}${tit}</b><small>${txt}</small></span></label>`;
    const NT = esNotion(t);
    const rolSel = (name, v, label) => NT ? `<select class="tp-in tp-in--s" name="${name}" aria-label="${label}" disabled><option value="ver" selected>Solo ver</option></select>`
        : `<select class="tp-in tp-in--s" name="${name}" aria-label="${label}"><option value="editar" ${v === 'editar' ? 'selected' : ''}>Puede editar</option><option value="ver" ${v === 'ver' ? 'selected' : ''}>Solo ver</option></select>`;
    const miembros = (t.miembros || []).filter(m => m.id !== t.dueno);
    const libres = ADMINS.filter(a => a.id !== t.dueno && !miembros.some(m => m.id === a.id));
    const persona = (id, extra) => `<li class="tp-mbr">${av(id)}<span class="tp-mbr-tx"><b>${esc(nombreDe(id))}${id === S.yo ? ' (yo)' : ''}</b><small>${esSuper(id) ? 'Súper admin' : 'Admin'}</small></span>${extra}</li>`;
    return `<fieldset class="tp-fg"><legend>${I.lock}Quién lo ve</legend>
        <div class="tp-vis">
          ${rad('privado', 'Solo yo', 'Nadie más lo ve.', I.lock)}
          ${rad('personas', 'Personas específicas', 'Solo los admins que agregues abajo, con el permiso que elijas.', I.user)}
          ${rad('equipo', 'Todo el equipo', 'Todos los admins con el módulo «Tableros».', I.users)}
        </div>
        <div class="tp-vis-eq" ${t.visib === 'equipo' ? '' : 'hidden'}><span>Permiso del equipo</span>${rolSel('rolEquipo', t.rolEquipo || 'editar', 'Permiso del equipo')}</div>
      </fieldset>
      <fieldset class="tp-fg" ${t.visib === 'privado' ? 'hidden' : ''}><legend>${I.users}Personas con acceso</legend>
        <ul class="tp-mbrs">
          ${persona(t.dueno, '<span class="tp-tag tp-tag--rol tp-tag--dueno">Dueño</span>')}
          ${miembros.map(m => persona(m.id, `${rolSel('rol-' + m.id, m.rol, 'Permiso de ' + nombreDe(m.id))}<button type="button" class="tp-ib" data-act="sh-quitar" data-uid="${m.id}" aria-label="Quitar a ${esc(nombreDe(m.id))}">${I.x}</button>`)).join('')}
        </ul>
        ${t.visib === 'equipo' ? '<p class="tp-help">Los que agregues aquí tienen su propio permiso; el resto del equipo usa el «Permiso del equipo».</p>' : ''}
        ${libres.length ? `<div class="tp-mbr-add"><label class="tp-sr" for="sh-uid">Agregar admin</label><select class="tp-in tp-in--s" id="sh-uid" name="nuevo"><option value="">Agregar un admin…</option>${libres.map(a => `<option value="${a.id}" data-uid="${a.id}" ${a.modulo === false ? 'disabled' : ''}>${esc(a.nombre)}${a.modulo === false ? ' · sin el módulo «Tableros»' : ''}</option>`).join('')}</select>${rolSel('nuevoRol', 'editar', 'Permiso del nuevo')}<button type="button" class="tp-btn tp-btn-soft tp-btn-sm" data-act="sh-agregar">${I.plus}Agregar</button></div>` : '<p class="tp-help">Ya agregaste a todos los admins.</p>'}
      </fieldset>
      <p class="tp-help tp-sh-sup">${I.eye}${NT ? 'Es una copia de Notion: todos la ven en modo «Solo ver». ' : ''}Los súper admins pueden mirar cualquier tablero (solo ver), aunque sea privado.</p>`;
}
function pintarCompartir(t, focoSel) {
    if (!M || M.kind !== 'compartir') return;
    const body = M.el.querySelector('.tp-md-body');
    // Con un desplegable abierto en la ventana no se re-dibuja (se haría al cerrarlo).
    if (SD && body.contains(SD.sel)) { M.repintar = t; return; }
    M.repintar = null;
    // Lo que se estaba eligiendo en «Agregar un admin» no se pierde al re-dibujar.
    const q = s => body.querySelector(s), uid = q('#sh-uid'), rolN = q('[name="nuevoRol"]');
    const antes = { uid: uid ? uid.value : '', rol: rolN ? rolN.value : '' };
    const a = document.activeElement, enfocado = a && body.contains(a) ? (a.id ? '#' + a.id : a.name ? `[name="${a.name}"]${a.type === 'radio' ? `[value="${a.value}"]` : ''}` : a.dataset && a.dataset.act ? `[data-act="${a.dataset.act}"]` : null) : null;
    body.innerHTML = compartirHTML(t);
    const uid2 = q('#sh-uid'), rol2 = q('[name="nuevoRol"]');
    if (uid2 && antes.uid && [...uid2.options].some(o => o.value === antes.uid)) uid2.value = antes.uid;
    if (rol2 && antes.rol) rol2.value = antes.rol;
    const f = focoSel || enfocado;
    if (f) { const el = M.el.querySelector(f); if (el) foco(el); }
}
function compartirInput(el) {
    const t = tablero(M.tid);
    const listo = msg => ok => { if (ok && msg) anunciar(msg); };
    if (el.name === 'visib') { const v = el.value; aplicarAcceso(t, () => { t.visib = v; }).then(listo('Se guardó quién lo ve')); }
    else if (el.name === 'rolEquipo') { const v = el.value; aplicarAcceso(t, () => { t.rolEquipo = v; }).then(listo('Permiso del equipo guardado')); }
    else if (el.name.startsWith('rol-')) { const id = +el.name.slice(4), v = el.value; aplicarAcceso(t, () => { const m = t.miembros.find(x => x.id === id); if (m) m.rol = v; }).then(listo('Permiso cambiado')); }
}
function modalTraspaso(t) {
    const otros = ADMINS.filter(a => a.id !== t.dueno);
    abrirModal(modalHTML({ titulo: `Traspasar «${esc(t.nombre)}»`, form: 'traspasar',
        cuerpo: `<p>La otra persona pasa a ser la dueña: podrá cambiar columnas, molde y con quién se comparte. Tú quedas con permiso «Puede editar».</p>
          <div class="tp-f"><label for="tr-uid">Nuevo dueño</label><select id="tr-uid" name="uid" class="tp-in">${otros.map(a => `<option value="${a.id}" data-uid="${a.id}" ${a.modulo === false ? 'disabled' : ''}>${esc(a.nombre)}${a.modulo === false ? ' · sin el módulo «Tableros»' : ''}</option>`).join('')}</select></div>`,
        pie: pieBtns('Traspasar') }), { tid: t.id });
}
function salirDeTablero(t) {
    confirmar({ titulo: `¿Salir de «${esc(t.nombre)}»?`, texto: `Dejarás de verlo. Para volver, ${esc(nombreDe(t.dueno))} tendría que compartírtelo de nuevo.`, boton: 'Salir del tablero', fn() {
        llamar(() => api.post(`/${t.id}/salir`), { sinRecarga: true }).then(() => {
            toast(`Saliste de «${t.nombre}».`);
            if (ruta().v === 'tablero') opciones.navegar(0); else cargarLista();
        }).catch(() => {});
    } });
}
function borrarTablero(t) {
    confirmar({
        titulo: `¿Eliminar «${esc(t.nombre)}»?`,
        texto: `Se borrarán ${plural(t.columnas ? t.columnas.length : t.nColumnas, 'columna', 'columnas')} y ${plural(t.tarjetas ? t.tarjetas.length : t.nTarjetas, 'tarjeta', 'tarjetas')}. Podrás deshacerlo durante unos segundos.`,
        boton: 'Eliminar tablero',
        fn() {
            const id = t.id, nombre = t.nombre;
            llamar(() => api.del(`/${id}`), { sinRecarga: true }).then(() => {
                if (S.lista) S.lista = S.lista.filter(x => x.id !== id);
                if (ruta().v === 'tablero') opciones.navegar(0); else render();
                toast(`Tablero «${nombre}» eliminado.`, { undo() { llamar(() => api.post(`/${id}/restaurar`), { sinRecarga: true }).then(() => cargarLista()).catch(() => {}); } });
            }).catch(() => {});
        },
    });
}

// ── Columnas ──
function modalColumna(t, c) {
    abrirModal(modalHTML({
        titulo: c ? 'Editar columna' : 'Nueva columna', form: 'col',
        cuerpo: `<input type="hidden" name="id" value="${c ? c.id : ''}">
          <div class="tp-f"><label for="c-nom">Nombre de la columna</label><input id="c-nom" name="nombre" class="tp-in" maxlength="40" value="${esc(c ? c.nombre : '')}" placeholder="Ej.: En revisión" autocomplete="off" autofocus><p class="tp-err" id="c-nom-e" role="alert"></p></div>
          <fieldset class="tp-f"><legend>Color</legend>${swatches('color', c ? c.color : colorLibre(t))}</fieldset>`,
        pie: pieBtns(c ? 'Guardar' : 'Agregar columna'),
    }), { tid: t.id });
}
/** Valida una columna nueva; si está bien devuelve { nombre, color }. */
function agregarColumna(t, nombre, color, input) {
    const v = limpio(nombre);
    if (!v) { errCampo(input, 'Escribe un nombre para la columna.'); input.focus(); return null; }
    if (t.columnas.some(c => norm(c.nombre) === norm(v))) { errCampo(input, 'Ya hay una columna con ese nombre.'); input.focus(); return null; }
    return { nombre: v, color: color || colorLibre(t) };
}
/** Errores 422 de la API → el campo del formulario. */
function errApi(e, input) {
    const m = e && e.status === 422 && e.data && e.data.message;
    if (m && input) { errCampo(input, m); input.focus(); return true; }
    return false;
}
function moverCol(id, d, btnId) {
    const t = actual(), i = t.columnas.findIndex(c => c.id === id), j = i + d;
    if (i < 0 || j < 0 || j >= t.columnas.length) return;
    [t.columnas[i], t.columnas[j]] = [t.columnas[j], t.columnas[i]];
    tocar(t);
    llamar(() => api.put(`/${t.id}/columnas-orden`, { ids: t.columnas.map(c => c.id) })).catch(() => {});
    if (etapaDe(t) === 'columnas') render(); else pintarZona();
    requestAnimationFrame(() => {
        let el = btnId && document.getElementById(btnId);
        if (el && el.disabled) el = document.getElementById((btnId.startsWith('cu-') ? 'cd-' : 'cu-') + id);
        if (el) el.focus();
    });
    anunciar(`Columna movida a la posición ${j + 1}`);
}
function menuCol(b) {
    const t = actual(), c = colDe(t, +b.dataset.col); if (!c) return;
    const i = t.columnas.indexOf(c), plegada = PF(t).plegadas.includes(c.id);
    abrirPop(b, [
        { head: c.nombre },
        { txt: 'Cambiar nombre y color', ic: I.edit, fn() { modalColumna(t, c); } },
        t.listo ? { txt: 'Nueva tarjeta aquí', ic: I.plus, fn() { modalTarjeta(t, c.id); } } : null,
        { txt: 'Mover a la izquierda', ic: I.left, disabled: i === 0, fn() { moverCol(c.id, -1); } },
        { txt: 'Mover a la derecha', ic: I.right, disabled: i === t.columnas.length - 1, fn() { moverCol(c.id, 1); } },
        { txt: plegada ? 'Desplegar columna' : 'Plegar columna', ic: I.fold, fn() { PF(t).plegadas = plegada ? PF(t).plegadas.filter(x => x !== c.id) : [...PF(t).plegadas, c.id]; guardarPref(t, ['plegadas']); pintarZona(); } },
        { sep: 1 },
        { txt: 'Eliminar columna', ic: I.trash, danger: 1, fn() { borrarColumna(t, c); } },
    ].filter(Boolean), 'Opciones de la columna');
}
function borrarColumna(t, c) {
    const n = tarjetasCol(t, c.id).length;
    if (!n) {
        // Vacía: se borra y se puede deshacer (se vuelve a crear en el mismo lugar).
        const orden = t.columnas.map(x => x.id), tid = t.id, { nombre, color } = c;
        t.columnas = t.columnas.filter(x => x.id !== c.id); render();
        llamar(() => api.del(`/${tid}/columnas/${c.id}`)).then(d => { aplicarTablero(d); render(); toast(`Columna «${nombre}» eliminada.`, { async undo() {
            try {
                const d2 = await api.post(`/${tid}/columnas`, { nombre, color });
                const nueva = d2.columnas.find(x => norm(x.nombre) === norm(nombre));
                const ids = orden.map(id => id === c.id ? nueva.id : id).filter(id => d2.columnas.some(x => x.id === id));
                await api.put(`/${tid}/columnas-orden`, { ids });
            } catch (e) { toast(msgErr(e)); }
            recargar();
        } }); }).catch(() => {});
        return;
    }
    const otras = t.columnas.filter(x => x.id !== c.id);
    abrirModal(modalHTML({
        titulo: `¿Eliminar la columna «${esc(c.nombre)}»?`, form: 'col-del',
        cuerpo: `<input type="hidden" name="id" value="${c.id}"><p>Tiene ${plural(n, 'tarjeta', 'tarjetas')}. ¿Qué hacemos con ${n === 1 ? 'ella' : 'ellas'}?</p>
          ${otras.length ? `<label class="tp-radio"><input type="radio" name="que" value="mover" checked><span>Moverlas a otra columna<select class="tp-in tp-in--s" name="dest" aria-label="Columna de destino">${otras.map(o => `<option value="${o.id}">${esc(o.nombre)}</option>`).join('')}</select></span></label>` : ''}
          <label class="tp-radio"><input type="radio" name="que" value="borrar" ${otras.length ? '' : 'checked'}><span>Eliminarlas junto con la columna</span></label>`,
        pie: pieBtns('Eliminar columna', 'tp-btn-danger-main'),
    }), { tid: t.id });
}

// ── Tarjetas ──
/** Manda a la API la posición actual de la tarjeta (columna + antes de cuál queda). */
function guardarMov(t, id) {
    const x = t.tarjetas.find(c => c.id === id); if (!x) return;
    const lista = tarjetasCol(t, x.col), sig = lista[lista.indexOf(x) + 1];
    llamar(() => api.post(`/tarjetas/${id}/mover`, { col: x.col, antes: sig ? sig.id : null })).then(d => { ponerTarjeta(t, d.tarjeta); }).catch(() => {});
}
function moverTarjeta(t, id, col, antes) {
    const x = t.tarjetas.find(c => c.id === id); if (!x || !colDe(t, col)) return false;
    const desde = x.col, previo = tarjetasCol(t, col).map(c => c.id).join();
    const lista = tarjetasCol(t, col).filter(c => c.id !== id);
    let i = antes ? lista.findIndex(c => c.id === antes) : -1; if (i < 0) i = lista.length;
    lista.splice(i, 0, x);
    x.col = col; lista.forEach((c, k) => { c.orden = k; });
    if (desde !== col) {
        tarjetasCol(t, desde).forEach((c, k) => { c.orden = k; });
        hist(x, 'mov', `Movió de «${(colDe(t, desde) || {}).nombre}» a «${colDe(t, col).nombre}»`);
        tocar(t, x);
        return true;
    }
    const cambio = lista.map(c => c.id).join() !== previo;
    if (cambio) tocar(t);
    return cambio;
}
const opcionesCol = (t, sel) => t.columnas.map(c => `<option value="${c.id}" data-tn="${c.color}" ${c.id === sel ? 'selected' : ''}>${esc(c.nombre)}</option>`).join('');
function modalTarjeta(t, col) {
    const ej = t.tarjetas.find(x => x.id === t.molde), n = t.campos.length;
    const sec = (k, titulo, texto, st, extra = '') => `<header class="tp-sec-h"><span class="tp-sec-n" id="nv-n${k}" aria-hidden="true">${k}</span><div class="tp-sec-tt"><h3 id="nv-s${k}">${titulo}</h3><p>${texto}</p></div>${extra}<span class="tp-sec-st" id="nv-st${k}">${st}</span></header>`;
    abrirModal(modalHTML({
        titulo: 'Nueva tarjeta', sub: `En «${esc(t.nombre)}» · la crea ${esc(nombreDe(S.yo))}`, form: 'tarjeta', ask: true, xl: true,
        cuerpo: `<div class="tp-nv">
          <div class="tp-nv-main">
            <p class="tp-info tp-nv-lead">${I.info}<span>Solo el <b>título</b> es obligatorio. Lo demás lo puedes completar ahora o después, desde la tarjeta.</span></p>
            <section class="tp-sec" aria-labelledby="nv-s1">
              ${sec(1, 'Lo principal', 'Cómo se llama la tarjeta y en qué columna empieza.', 'Falta el título')}
              <div class="tp-nv-grid">
                <div class="tp-f is-full"><label for="n-tit">Título <span class="tp-req">Obligatorio</span></label><input id="n-tit" name="titulo" class="tp-in" maxlength="120" autocomplete="off" autofocus placeholder="${ej ? 'Ej.: ' + esc(ej.titulo) : 'Ej.: Revisar contrato de limpieza'}"><p class="tp-err" id="n-tit-e" role="alert"></p></div>
                <div class="tp-f"><label for="n-col">Columna</label><select id="n-col" name="col" class="tp-in">${opcionesCol(t, col)}</select><span class="tp-hint">Después la puedes mover arrastrándola.</span></div>
              </div>
            </section>
            <section class="tp-sec" aria-labelledby="nv-s2">
              ${sec(2, 'Responsable y seguimiento', 'Quién se hace cargo y cuándo volver a revisarla.', 'Opcional')}
              <div class="tp-nv-grid">
                <div class="tp-f"><label for="n-asig">Asignada a</label><select id="n-asig" name="asignado" class="tp-in"><option value="">Sin asignar</option>${asignables(t).map(a => `<option value="${a.id}" data-uid="${a.id}" ${a.id === S.yo ? 'selected' : ''}>${esc(a.nombre)}${a.id === S.yo ? ' (yo)' : ''}</option>`).join('')}</select>
                  <span class="tp-hint" id="n-asig-h"></span></div>
                <div class="tp-f"><label for="n-seg">Seguimiento</label><input type="date" id="n-seg" name="seguimiento" class="tp-in" min="${hoyISO()}" aria-describedby="n-seg-h">
                  <div class="tp-nv-chips">${[[1, 'Mañana'], [3, 'En 3 días'], [7, 'En 1 semana']].map(([d, l]) => `<button type="button" class="tp-chip tp-chip--xs" data-act="nv-seg" data-d="${d}" aria-pressed="false">${l}</button>`).join('')}<button type="button" class="tp-btn-link" data-act="nv-seg" data-d="" id="n-seg-x" hidden>Quitar</button></div>
                  <span class="tp-hint" id="n-seg-h">Te llega un aviso ese día para volver a revisarla.</span></div>
              </div>
            </section>
            <section class="tp-sec" aria-labelledby="nv-s3">
              ${sec(3, 'Datos de la tarjeta', n ? 'Los campos del molde de este tablero.' : 'Este tablero no tiene más campos: la tarjeta tendrá solo el título.', n ? `0 de ${n}` : 'Sin campos',
                ej && n ? `<button type="button" class="tp-btn-link tp-sec-btn" data-act="copiar-ej">${I.copy}Copiar del ejemplo</button>` : '')}
              ${n ? `<div class="tp-props tp-nv-grid" id="n-props">${t.campos.map(f => campoNuevo(f, { datos: {} }, 'n')).join('')}</div>` : (esDueno(t) ? '<p class="tp-help">Para agregar campos usa «Molde de tarjeta» (arriba, junto a «Nueva tarjeta»).</p>' : '')}
            </section>
          </div>
          <aside class="tp-nv-side" aria-label="Vista previa de la tarjeta"><div class="tp-nv-sticky">
            <h4 class="tp-nv-h">Así se verá en el tablero</h4><div id="n-prev"></div>
            <h4 class="tp-nv-h">Qué tiene la tarjeta</h4><ul class="tp-nv-ck" id="n-ck"></ul>
          </div></aside>
        </div>`,
        pie: '<small class="tp-nv-foot" id="n-foot" aria-live="polite"></small>' + pieBtns(`${I.plus}Crear tarjeta`),
    }), { tid: t.id, kind: 'tarjeta' });
    prevNueva();
}
/** Campo del molde dentro de «Nueva tarjeta» (mismo data-fid / data-campo / .tp-err que lee leerDatos). */
function campoNuevo(f, x, pre) {
    const id = `${pre}-${f.id}`;
    return `<div class="tp-prop tp-nf${esAncho(f) ? ' is-full' : ''}" data-fid="${f.id}"><label class="tp-nf-l" for="${id}" id="${id}-l"><span class="tp-nf-ic" aria-hidden="true">${TIPO_IC[f.tipo]}</span>${esc(f.nombre)}</label>${inputCampo(f, x.datos[f.id], id)}<p class="tp-err" role="alert"></p></div>`;
}
/** Vista previa, estado de cada sección y lista de lo que falta en «Nueva tarjeta». */
function prevNueva() {
    if (!M || M.kind !== 'tarjeta') return;
    const t = tablero(M.tid), f = M.el.querySelector('form'); if (!t || !f) return;
    const q = s => M.el.querySelector(s), E = f.elements;
    const titulo = limpio(E.titulo.value), c = colDe(t, +E.col.value) || t.columnas[0];
    const asig = E.asignado.value ? +E.asignado.value : null, seg = /^\d{4}-\d{2}-\d{2}$/.test(E.seguimiento.value) ? E.seguimiento.value : null;
    const datos = {}; let llenos = 0, primeroVacio = null;
    t.campos.forEach(cf => {
        const row = f.querySelector(`.tp-prop[data-fid="${cf.id}"]`); if (!row) return;
        const v = leerCampo(cf, row);
        if (!vacio(v) && !validar(cf, v)) { datos[cf.id] = normalizar(cf, v); llenos++; } else if (!primeroVacio) primeroVacio = row.querySelector('[data-campo]');
    });
    const x = { id: -1, titulo: titulo || 'Título de la tarjeta', datos, asignado: asig, seguimiento: seg, creada: ahora(), editada: ahora(), nNotas: 0, archivos: [] };
    q('#n-prev').innerHTML = `<div class="tp-col tn-${c.color}"><header class="tp-col-head"><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span></header><div class="tp-col-body">${cardHTML(t, x, { preview: true, ph: !titulo })}</div></div>`;
    const st = (k, txt, cls, hecho) => { const s = q('#nv-st' + k), n = q('#nv-n' + k); if (s) { s.textContent = txt; s.className = 'tp-sec-st' + (cls ? ' is-' + cls : ''); } if (n) n.classList.toggle('is-done', !!hecho); };
    st(1, titulo ? 'Completo' : 'Falta el título', titulo ? 'ok' : 'warn', titulo);
    st(2, asig && seg ? 'Completo' : asig || seg ? '1 de 2' : 'Opcional', asig && seg ? 'ok' : '', asig || seg);
    const n = t.campos.length;
    if (n) st(3, `${llenos} de ${n}`, llenos === n ? 'ok' : '', llenos);
    // Ayudas de la sección 2
    const h = q('#n-asig-h');
    if (h) h.innerHTML = asig === S.yo ? 'Te la asignas a ti.' : asignables(t).some(a => a.id === S.yo) ? '<button type="button" class="tp-btn-link" data-act="nv-mia">Asignármela</button>' : 'Solo aparecen quienes pueden editar el tablero.';
    M.el.querySelectorAll('[data-act="nv-seg"][data-d]:not([data-d=""])').forEach(b => b.setAttribute('aria-pressed', String(seg === isoMas(+b.dataset.d))));
    const sx = q('#n-seg-x'); if (sx) sx.hidden = !E.seguimiento.value;
    // Lo que tiene / le falta
    const item = (on, txt, to, req) => `<li class="${on ? 'is-on' : req ? 'is-req' : ''}"><span class="tp-nv-ck-i" aria-hidden="true">${on ? I.check : ''}</span>${!on && to ? `<button type="button" class="tp-nv-ck-b" data-act="nv-ir" data-to="${to}">${txt}</button>` : `<span>${txt}</span>`}${req && !on ? '<span class="tp-req">Obligatorio</span>' : ''}</li>`;
    q('#n-ck').innerHTML = item(!!titulo, 'Título', '#n-tit', true) + item(true, `Columna «${esc(c.nombre)}»`)
        + item(!!asig, asig ? `Asignada a ${esc(nombreDe(asig))}` : 'Sin asignar', '#n-asig') + item(!!seg, seg ? `Seguimiento: ${esc(fechaCorta(seg))}` : 'Sin seguimiento', '#n-seg')
        + (n ? item(llenos > 0, `${llenos} de ${plural(n, 'dato', 'datos')} cargados`, primeroVacio && primeroVacio.id ? '#' + primeroVacio.id : null) : '');
    const foot = q('#n-foot');
    foot.className = 'tp-nv-foot' + (titulo ? '' : ' is-warn');
    foot.innerHTML = titulo ? `${I.check}Se crea en «${esc(c.nombre)}»` : `${I.info}Falta el título`;
}
function leerDatos(t, root) {
    const datos = {}; let primero = null;
    t.campos.forEach(f => {
        const row = root.querySelector(`.tp-prop[data-fid="${f.id}"]`); if (!row) return;
        const v = leerCampo(f, row), m = validar(f, v);
        if (m) { const c = row.querySelector('[data-campo]'); c.setAttribute('aria-invalid', 'true'); row.querySelector('.tp-err').textContent = m; primero = primero || c; return; }
        const nv = normalizar(f, v); if (!vacio(nv)) datos[f.id] = nv;
    });
    return { datos, primero };
}

// ── Panel de la tarjeta: ficha a la izquierda + pestañas Resumen / Notas e historial / Datos ──
const TABS = [['resumen', 'Resumen'], ['notas', 'Notas e historial'], ['datos', 'Datos']];
const tabNombre = t => (esNotion(t) ? 'Comentarios' : 'Notas e historial');
const listaRapida = t => t.campos.filter(f => f.tipo === 'lista');   // se cambian al instante desde la ficha
const camposDatos = t => t.campos.filter(f => f.tipo !== 'lista');   // se editan en «Datos» con Guardar
const esAncho = f => f.tipo === 'largo' || f.tipo === 'multi';
function abrirTarjeta(id, tab) {
    const t = actual(), x = t && t.tarjetas.find(c => c.id === id); if (!x) return;
    const opener = DR ? DR.opener : document.activeElement;
    if (DR) DR.el.remove();
    DR = { el: null, tid: t.id, cid: id, opener, tab: tab || 'resumen', dirty: false };
    const w = document.createElement('div'); w.innerHTML = drawerHTML(t, x).trim();
    DR.el = w.firstElementChild; capas.insertBefore(DR.el, capas.firstChild);
    bloquear(); marcarAbierta(id); cargarMiniaturas(DR.el);
    foco(DR.el.querySelector('.tp-dr-card'));
    cargarDetalle(t, id);
}
/** Notas e historial completos de la tarjeta (el tablero solo trae el contador). */
async function cargarDetalle(t, id) {
    try {
        const d = await api.get(`/tarjetas/${id}`);
        if (!DR || DR.cid !== id || S.t !== t) return;
        const x = ponerTarjeta(t, d.tarjeta);
        x.notas = d.notas; x.hist = d.hist; if (d.contenido != null) x.contenido = d.contenido;
        pintarDrawer('notas');
        if (esNotion(t)) pintarZona();   // pudo cambiar el número de comentarios
    } catch (e) { if (DR && DR.cid === id) toast(msgErr(e)); }
}
function marcarAbierta(id) {
    app.querySelectorAll('.tp-cd.is-open').forEach(c => c.classList.remove('is-open'));
    app.querySelectorAll('.tp-xl tr.is-sel').forEach(c => c.classList.remove('is-sel'));
    const cd = id && app.querySelector(`.tp-cd[data-id="${id}"]`); if (cd) cd.classList.add('is-open');
    const tr = id && app.querySelector(`.tp-xl tr[data-id="${id}"]`); if (tr) tr.classList.add('is-sel');
}
/** sinFoco = cierre interno (borrar, cambiar de página): no pregunta ni devuelve el foco. */
function cerrarDrawer(sinFoco) {
    if (!DR) return;
    if (!sinFoco && DR.dirty) { preguntarSalida(); return; }
    if (VW) cerrarVisor(true);
    const { el, opener, cid } = DR; DR = null; el.remove(); revisarSel(); bloquear(); marcarAbierta(null);
    if (sinFoco) return;
    const cd = app.querySelector(`.tp-cd[data-id="${cid}"]`) || app.querySelector(`.tp-xl tr[data-id="${cid}"] td[data-k="titulo"]`);
    if (cd) { if (cd.tagName === 'TD') activarCelda(cd, true); else cd.focus(); } else if (opener && opener.isConnected) opener.focus();
}
function preguntarSalida() {
    abrirModal(modalHTML({
        titulo: 'Tienes cambios sin guardar', form: 'salir-datos',
        cuerpo: '<p>Cambiaste datos de la tarjeta y todavía no los guardas.</p>',
        pie: '<button type="button" class="tp-btn tp-btn-ghost" data-act="cerrar">Seguir editando</button><button type="button" class="tp-btn tp-btn-danger" data-act="salir-descartar">Descartar</button><button type="submit" class="tp-btn tp-btn-main">Guardar y cerrar</button>',
    }));
}
function drawerHTML(t, x) {
    const oculto = k => DR.tab !== k ? 'hidden' : '';
    return `<div class="tp-dr" role="dialog" aria-modal="true" aria-labelledby="dr-t">
      <div class="tp-dr-bg" data-act="cerrar"></div>
      <div class="tp-dr-card" tabindex="-1">
        <button type="button" class="tp-ib tp-dr-xm" data-act="cerrar" aria-label="Cerrar">${I.x}</button>
        <aside class="tp-fi" id="dr-ficha" aria-label="Ficha de la tarjeta">${fichaHTML(t, x)}</aside>
        <div class="tp-dr-main">
          <header class="tp-tabs">
            <div class="tp-tabs-l" role="tablist" aria-label="Secciones de la tarjeta">${TABS.filter(([k]) => k !== 'datos' || puedeEditar(t)).map(([k, n]) => `<button type="button" role="tab" id="tab-${k}" aria-controls="pn-${k}" aria-selected="${DR.tab === k}" tabindex="${DR.tab === k ? 0 : -1}" data-act="dr-tab" data-tab="${k}">${tabTxt(k, k === 'notas' ? tabNombre(t) : n, x)}</button>`).join('')}</div>
            <span class="tp-sp"></span>
            ${puedeEditar(t) ? `<button type="button" class="tp-ib" data-act="dr-menu" aria-haspopup="menu" aria-expanded="false" aria-label="Más opciones de la tarjeta">${I.more}</button>` : ''}
            <button type="button" class="tp-ib" data-act="cerrar" aria-label="Cerrar">${I.x}</button>
          </header>
          <div class="tp-panes">
            <section class="tp-pane" id="pn-resumen" role="tabpanel" aria-labelledby="tab-resumen" ${oculto('resumen')}>${resumenHTML(t, x)}</section>
            <section class="tp-pane" id="pn-notas" role="tabpanel" aria-labelledby="tab-notas" ${oculto('notas')}>
              <div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.note}${esNotion(t) ? 'Comentarios de Notion' : 'Notas'}</h3></div><div id="dr-notes" class="tp-notes">${notasHTML(x, t)}</div></div>
              ${esNotion(t) ? '' : `<div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.hist}Historial</h3></div><ol class="tp-hist" id="dr-hist">${histHTML(x)}</ol></div>`}
            </section>
            ${puedeEditar(t) ? `<form class="tp-pane" id="pn-datos" role="tabpanel" aria-labelledby="tab-datos" data-form="datos" novalidate ${oculto('datos')}>${datosHTML(t, x)}</form>` : ''}
          </div>
          ${puedeEditar(t) ? '' : '<!-- solo ver -->'}<footer class="tp-dr-foot" id="dr-foot" ${puedeEditar(t) ? oculto('datos') : 'hidden'}><span class="tp-dr-state" id="dr-state" aria-live="polite">Sin cambios</span><span class="tp-sp"></span><button type="button" class="tp-btn tp-btn-ghost" data-act="datos-descartar" id="dr-desc" disabled>Descartar</button><button type="button" class="tp-btn tp-btn-main" data-act="datos-guardar" id="dr-save" disabled>Guardar cambios</button></footer>
        </div>
      </div></div>`;
}
const tabTxt = (k, n, x) => n + (k === 'notas' && x.nNotas ? ` <span class="tp-tab-n">${x.nNotas}</span>` : '');
function segHint(x) {
    if (!x.seguimiento) return 'Para acordarte de volver a revisarla';
    if (x.seguimiento === hoyISO()) return 'Toca hoy';
    return segVencido(x) ? 'Vencido: ya pasó la fecha' : `Te toca ${segTxt(x).toLowerCase() === 'mañana' ? 'mañana' : 'el ' + fechaCorta(x.seguimiento)}`;
}
function opcionesAsignar(t, x) {
    const pueden = asignables(t), otros = esDueno(t) ? ADMINS.filter(a => !pueden.includes(a) && a.modulo !== false) : [];
    const op = a => `<option value="${a.id}" data-uid="${a.id}" ${a.id === x.asignado ? 'selected' : ''}>${esc(a.nombre)}${a.id === S.yo ? ' (yo)' : ''}</option>`;
    const fuera = x.asignado && !pueden.some(a => a.id === x.asignado) && !otros.some(a => a.id === x.asignado) ? `<option value="${x.asignado}" data-uid="${x.asignado}" selected>${esc(nombreDe(x.asignado))} (sin acceso)</option>` : '';
    return `<option value="">Sin asignar</option>${pueden.map(op).join('')}${fuera}${otros.length ? `<optgroup label="Compartir el tablero y asignar">${otros.map(op).join('')}</optgroup>` : ''}`;
}
function fichaHTML(t, x) {
    const c = colDe(t, x.col), ej = x.id === t.molde, ED = puedeEditar(t), dis = ED ? '' : ' disabled';
    const pills = listaRapida(t).map(f => { const o = f.opciones.find(o => o.id === x.datos[f.id]); return o ? pill(o) : ''; }).join('');
    const sub = camposDatos(t).find(f => f.tipo === 'texto' && !vacio(x.datos[f.id]));
    const desde = x.colDesde || x.creada;
    const fila = (icono, label, forId, control, extra = '') => `<div class="tp-fi-row"><label class="tp-fi-k" for="${forId}">${icono}<span>${label}</span></label><div class="tp-fi-v">${control}</div>${extra}</div>`;
    const selPill = (id, attrs, cls, opciones) => `<span class="tp-pillsel ${cls}"><select id="${id}" ${attrs}>${opciones}</select></span>`;
    const opsLista = f => `<option value="">Sin elegir</option>${f.opciones.map(o => `<option value="${o.id}" data-tn="${o.color}" ${o.id === x.datos[f.id] ? 'selected' : ''}>${esc(o.nombre)}</option>`).join('')}`;
    const opsAdmins = opcionesAsignar(t, x);
    return `<div class="tp-fi-pills">${ej ? `<span class="tp-ej-tag">${I.star}Ejemplo</span>` : ''}${pills}<span class="tp-colpill tn-${c.color}"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span></div>
      <h2 class="tp-fi-title" id="dr-t">${esc(x.titulo)}</h2>
      ${sub ? `<p class="tp-fi-sub">${esc(x.datos[sub.id])}</p>` : ''}
      <div class="tp-fi-props">
        ${fila(I.arrow, 'Estado', 'dr-col', selPill('dr-col', 'data-k="col"' + dis, 'tn-' + c.color, opcionesCol(t, x.col)))}
        ${listaRapida(t).map(f => { const o = f.opciones.find(o => o.id === x.datos[f.id]); return fila(I.sel, esc(f.nombre), 'dr-q-' + f.id, selPill('dr-q-' + f.id, `data-q="${f.id}"` + dis, o ? 'tn-' + o.color : 'is-none', opsLista(f))); }).join('')}
        ${esNotion(t) ? '' : fila(I.user, 'Asignada a', 'dr-asig', selPill('dr-asig', 'data-k="asignado"' + dis, x.asignado ? 'is-person' : 'is-none', opsAdmins) + (ED && x.asignado !== S.yo ? '<button type="button" class="tp-btn-link" data-act="asignarme">Asignármela</button>' : ''))}
        ${esNotion(t) ? '' : fila(I.cal, 'Seguimiento', 'dr-seg', `<input type="date" id="dr-seg" data-k="seguimiento" class="tp-in tp-in--s${segVencido(x) ? ' is-due' : ''}" value="${esc(x.seguimiento || '')}" aria-describedby="dr-seg-h"${dis}><span id="dr-seg-x">${x.seguimiento && ED ? `<button type="button" class="tp-ib" data-act="seg-quitar" aria-label="Quitar el seguimiento">${I.x}</button>` : ''}</span>`,
            `<p class="tp-fi-hint${segVencido(x) ? ' is-due' : ''}" id="dr-seg-h">${segHint(x)}</p>`)}
      </div>
      <div class="tp-fi-box">
        ${esNotion(t) ? '' : x.asignado ? `<div class="tp-fi-who">${av(x.asignado, 'tp-av--l')}<span><b>${esc(nombreDe(x.asignado))}</b><small>A cargo de esta tarjeta</small></span></div>` : `<div class="tp-fi-who is-none"><span class="tp-av tp-av--l tp-av--x" aria-hidden="true">${I.user}</span><span><b>Sin asignar</b><small>Elige quién se hace cargo</small></span></div>`}
        <dl class="tp-fi-meta">
          <div><dt>En «${esc(c.nombre)}»</dt><dd title="${fechaHora(desde)}">${rel(desde)}</dd></div>
          <div><dt>Creada</dt><dd title="${fechaHora(x.creada)}">${rel(x.creada)}${x.nUrl ? ' · en Notion' : ' · ' + esc(nombreDe(x.por))}</dd></div>
          <div><dt>Último cambio</dt><dd title="${fechaHora(x.editada)}">${rel(x.editada)}</dd></div>
        </dl>
        ${x.nUrl ? `<a class="tp-btn tp-btn-ghost tp-btn-sm tp-fi-notion" href="${esc(x.nUrl)}" target="_blank" rel="noopener noreferrer">${LOGO_NOTION}Abrir la tarjeta en Notion</a>` : ''}
      </div>`;
}
function resumenHTML(t, x) {
    const cs = camposDatos(t), n = x.notas ? x.notas[0] : x.ultimaNota, NT = esNotion(t);
    const contenido = NT ? `<div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.para}Contenido de la página</h3></div>${x.contenido == null ? '<p class="tp-help">Cargando el contenido desde Notion…</p>' : x.contenido ? `<p class="tp-pre tp-notion-txt">${esc(x.contenido)}</p>` : '<p class="tp-help">La página no tiene contenido.</p>'}</div>` : '';
    return `<div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.summary}Datos</h3>${puedeEditar(t) ? `<button type="button" class="tp-btn-link" data-act="dr-tab" data-tab="datos">${I.edit}Editar</button>` : ''}</div>
        ${cs.length ? `<dl class="tp-sum">${cs.map(f => `<div class="${esAncho(f) ? 'is-full' : ''}"><dt>${esc(f.nombre)}</dt><dd>${vacio(x.datos[f.id]) ? '<span class="tp-faint">—</span>' : f.tipo === 'largo' ? `<span class="tp-pre">${esc(x.datos[f.id])}</span>` : valorHTML(f, x.datos[f.id])}</dd></div>`).join('')}</dl>` : '<p class="tp-help">Este tablero no tiene más campos.' + (puedeArmar(t) ? ' Agrégalos con «Molde de tarjeta».' : '') + '</p>'}
      </div>
      ${contenido}
      <div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.clip}Archivos <span class="tp-dr-n" id="dr-files-n">${(x.archivos || []).length + (x.nArch || []).length || ''}</span></h3></div><div id="dr-files">${NT ? archivosNotionHTML(x) : archivosHTML(x, t)}</div></div>
      ${n ? `<div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.note}${NT ? 'Último comentario' : 'Última nota'}</h3><button type="button" class="tp-btn-link" data-act="dr-tab" data-tab="notas">${NT ? 'Ver comentarios' : 'Ver notas e historial'}</button></div><p class="tp-pre">${esc(n.txt)}</p><p class="tp-help tp-mt-s">${esc(n.autor || nombreDe(n.q))} · ${rel(n.t)}</p></div>` : ''}`;
}
/** Archivos de una tarjeta de Notion: se abren allá (los enlaces de Notion vencen en una hora). */
function archivosNotionHTML(x) {
    const l = x.nArch || [];
    if (!l.length) return '<p class="tp-help">Sin archivos.</p>';
    return `<ul class="tp-files">${l.map(a => {
        const url = a.url || x.nUrl;
        return `<li class="tp-file"><span class="tp-file-th" aria-hidden="true">${I.file}<i>${esc(extDe(a.nombre))}</i></span>
          <span class="tp-file-tx"><a class="tp-file-nom" href="${esc(url || '#')}" target="_blank" rel="noopener noreferrer" title="Abrir «${esc(a.nombre)}»${a.url ? '' : ' en Notion'}">${esc(a.nombre)}</a><small>${esc(a.campo || '')}${a.url ? ' · enlace externo' : ' · en Notion'}</small></span>
          <a class="tp-ib" href="${esc(url || '#')}" target="_blank" rel="noopener noreferrer" aria-label="Abrir «${esc(a.nombre)}»${a.url ? '' : ' en Notion'}" title="Abrir${a.url ? '' : ' en Notion'}">${I.open}</a></li>`;
    }).join('')}</ul>`;
}
function datosHTML(t, x) {
    return `<div class="tp-dcard"><div class="tp-dcard-h"><h3>${I.edit}Datos de la tarjeta</h3>${esDueno(t) ? `<button type="button" class="tp-btn-link" data-act="molde">${I.layout}Cambiar los campos</button>` : ''}</div>
        <div class="tp-dgrid">
          <div class="tp-f is-full"><label for="d-tit">Título</label><input id="d-tit" name="titulo" class="tp-in" maxlength="120" value="${esc(x.titulo)}" autocomplete="off"><p class="tp-err" id="d-tit-e" role="alert"></p></div>
          ${camposDatos(t).map(f => `<div class="tp-f${esAncho(f) ? ' is-full' : ''}" data-fid="${f.id}"><label for="d-${f.id}" id="d-${f.id}-l">${esc(f.nombre)} <span class="tp-opc">(opcional)</span></label>${inputCampo(f, x.datos[f.id], 'd-' + f.id)}<p class="tp-err" role="alert"></p></div>`).join('')}
        </div></div>
      <div class="tp-dcard tp-dcard--danger"><p>Eliminar la tarjeta: se borra con sus notas, archivos e historial. Podrás deshacerlo durante unos segundos.</p><button type="button" class="tp-btn tp-btn-danger tp-btn-sm" data-act="tarjeta-eliminar">${I.trash}Eliminar tarjeta</button></div>`;
}
function notasHTML(x, t) {
    const ED = puedeEditar(t);
    if (!x.notas) return `<p class="tp-help">${esNotion(t) ? 'Cargando los comentarios desde Notion…' : 'Cargando notas…'}</p>`;
    if (!ED && !x.notas.length) return `<p class="tp-help">${esNotion(t) ? 'Esta tarjeta no tiene comentarios en Notion.' : 'Sin notas.'}</p>`;
    return `${ED ? '' : '<!--'}<form data-form="nota" novalidate><label class="tp-sr" for="nt">Nueva nota</label><textarea id="nt" name="txt" class="tp-in" rows="2" maxlength="2000" placeholder="Escribe una nota… (Ctrl + Enter para guardar)"></textarea><p class="tp-err" id="nt-e" role="alert"></p><div class="tp-notes-act"><button type="submit" class="tp-btn tp-btn-soft tp-btn-sm">Agregar nota</button></div></form>${ED ? '' : '-->'}
      ${x.notas.length ? `<ul class="tp-note-list">${x.notas.map(n => `<li class="tp-note"><div class="tp-note-h">${n.autor ? avNotion(n.autor) : av(n.q, 'tp-av--s')}<b>${esc(n.autor || nombreDe(n.q))}</b><span title="${fechaHora(n.t)}">${rel(n.t)}</span>${ED && n.q === S.yo && !n.autor ? `<button type="button" class="tp-ib" data-act="nota-del" data-nid="${n.id}" aria-label="Borrar nota">${I.trash}</button>` : ''}</div><p>${esc(n.txt)}</p></li>`).join('')}</ul>` : ''}`;
}
/** Avatar con iniciales para personas de Notion (no son admins del panel). */
const avNotion = nombre => `<span class="tp-av tp-av--s tp-av--notion" aria-hidden="true">${esc(iniciales(String(nombre).replace(/[^\p{L}\s]/gu, '').trim() || 'N'))}</span>`;
function archivosHTML(x, t) {
    const arch = x.archivos || [], ED = puedeEditar(t);
    if (!ED && !arch.length) return '<p class="tp-help">Sin archivos.</p>';
    return `${ED ? '' : '<!--'}<div class="tp-drop" data-drop>
        <input type="file" id="fa" class="tp-sr" multiple data-files aria-describedby="fa-ayuda">
        <label for="fa" class="tp-drop-in">${I.upload}<span><b>Arrastra archivos aquí</b> o <u>elígelos desde tu equipo</u></span><small id="fa-ayuda">Imágenes, PDF, planillas, documentos… hasta 10 MB cada uno</small></label>
      </div>${ED ? '' : '-->'}
      ${arch.length ? `<ul class="tp-files">${arch.map(a => `<li class="tp-file" data-aid="${a.id}">
          <button type="button" class="tp-file-th" ${esImagen(a) ? `data-th="${a.id}"` : ''} data-act="file-ver" tabindex="-1" aria-hidden="true">${esImagen(a) ? '' : `${I.file}<i>${esc(extDe(a.nombre))}</i>`}</button>
          <span class="tp-file-tx"><button type="button" class="tp-file-nom" data-act="file-ver" title="Ver «${esc(a.nombre)}»">${esc(a.nombre)}</button><small>${tamTxt(a.tam)} · <span title="${fechaHora(a.t)}">${rel(a.t)}</span> · ${esc(nombreDe(a.q))}</small></span>
          <button type="button" class="tp-ib" data-act="file-ver" aria-label="Vista previa de «${esc(a.nombre)}»" title="Vista previa">${I.eye}</button>
          ${ED ? `<button type="button" class="tp-ib" data-act="file-mover" aria-label="Mover «${esc(a.nombre)}» a otra tarjeta" title="Mover a otra tarjeta">${I.mover}</button>` : ''}
          <button type="button" class="tp-ib" data-act="file-bajar" aria-label="Descargar «${esc(a.nombre)}»" title="Descargar">${I.download}</button>
          ${ED ? `<button type="button" class="tp-ib" data-act="file-del" aria-label="Quitar «${esc(a.nombre)}»" title="Quitar">${I.trash}</button>` : ''}
        </li>`).join('')}</ul>` : ''}`;
}
async function subirArchivos(lista) {
    if (!DR) return;
    if (!puedeEditar(tablero(DR.tid))) { toast('Solo puedes ver este tablero.'); return; }
    const t = tablero(DR.tid), x = t && t.tarjetas.find(c => c.id === DR.cid); if (!x) return;
    const files = [...lista], grandes = files.filter(f => f.size > MAX_ARCHIVO).map(f => f.name);
    const ok = files.filter(f => f.size > 0 && f.size <= MAX_ARCHIVO).slice(0, Math.max(0, MAX_POR_TARJETA - x.archivos.length));
    if (grandes.length) toast(`${grandes.length === 1 ? `«${grandes[0]}» pesa` : `${grandes.length} archivos pesan`} más de 10 MB y no se ${grandes.length === 1 ? 'subió' : 'subieron'}.`);
    if (files.filter(f => f.size > 0 && f.size <= MAX_ARCHIVO).length > ok.length) toast(`Máximo ${MAX_POR_TARJETA} archivos por tarjeta.`);
    if (!ok.length) return;
    const fd = new FormData(); ok.forEach(f => fd.append('archivos[]', f, f.name));
    const zona = DR.el.querySelector('[data-drop]'); if (zona) zona.classList.add('is-busy');
    anunciar('Subiendo archivos…');
    let d;
    try { d = await api.subir(`/tarjetas/${x.id}/archivos`, fd); }
    catch (e) { d = e && e.data; if (!d || !d.rechazados) { toast(msgErr(e)); if (zona) zona.classList.remove('is-busy'); return; } }
    (d.rechazados || []).forEach(r => toast(`«${r.nombre}» no se subió: ${r.motivo}.`));
    if (d.tarjeta) ponerTarjeta(t, d.tarjeta);
    if (!DR || DR.cid !== x.id) { pintarZona(); return; }
    if (d.subidos) { const y = t.tarjetas.find(c => c.id === x.id); hist(y, 'arch', d.subidos === 1 ? `Adjuntó «${ok[0].name}»` : `Adjuntó ${d.subidos} archivos`); }
    if (DR.tab !== 'resumen') cambiarTab('resumen');
    pintarDrawer('archivos'); pintarZona();
    if (d.subidos) anunciar(d.subidos === 1 ? 'Archivo adjuntado' : `${d.subidos} archivos adjuntados`);
}
function archivoDe(b) {
    const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid);
    return { t, x, a: (x.archivos || []).find(a => String(a.id) === b.closest('[data-aid]').dataset.aid) };
}
async function abrirArchivo(a, descargar) {
    // La ventana se abre en el clic (si no, el navegador la bloquea) y después se le pone el archivo.
    const w = descargar ? null : window.open('', '_blank');
    let b;
    try { b = await api.blob(`/archivos/${a.id}${descargar ? '?descargar=1' : ''}`); }
    catch (e) { if (w) w.close(); toast(msgErr(e)); return; }
    const u = URL.createObjectURL(b);
    if (descargar) { const l = document.createElement('a'); l.href = u; l.download = a.nombre; document.body.appendChild(l); l.click(); l.remove(); }
    else if (w) w.location.href = u;
    setTimeout(() => URL.revokeObjectURL(u), 60000);
}

// ── Visor de archivos (sin descargar): imagen, PDF, video, audio, texto y planillas ──
let VW = null;   // { el, tid, cid, lista, i, url, tok }
function tipoVista(a) {
    const n = String(a.nombre || '').toLowerCase(), ty = String(a.tipo || '');
    if (esImagen(a) || /\.(png|jpe?g|gif|webp|bmp|avif|svg)$/.test(n)) return 'img';
    if (ty === 'application/pdf' || /\.pdf$/.test(n)) return 'pdf';
    if (/^video\//.test(ty) || /\.(mp4|webm|ogv|mov|m4v)$/.test(n)) return 'video';
    if (/^audio\//.test(ty) || /\.(mp3|wav|ogg|oga|m4a|aac|flac|opus)$/.test(n)) return 'audio';
    if (/\.(xlsx|xlsm|xlsb|xls|ods|csv|tsv)$/.test(n) || /spreadsheet|ms-excel|text\/csv/.test(ty)) return 'hoja';
    if (/^text\//.test(ty) || ty === 'application/json' || /\.(txt|md|json|xml|log|html?|css|js|ya?ml|ini|sql)$/.test(n)) return 'texto';
    return '';
}
const MIME_VISTA = { img: a => (esImagen(a) ? a.tipo : /\.svg$/i.test(a.nombre) ? 'image/svg+xml' : a.tipo && /^image\//.test(a.tipo) ? a.tipo : 'image/png'), pdf: () => 'application/pdf' };
function abrirVisor(t, x, a) {
    if (VW) cerrarVisor(true);
    const lista = (x.archivos || []).slice(), i = Math.max(0, lista.findIndex(o => o.id === a.id));
    const el = document.createElement('div');
    el.className = 'tp-vw'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'vw-t');
    el.innerHTML = `<div class="tp-vw-bg" data-act="vw-cerrar"></div>
      <div class="tp-vw-card" tabindex="-1">
        <header class="tp-vw-head"><span class="tp-vw-ic" aria-hidden="true"></span><div class="tp-vw-tx"><h2 id="vw-t"></h2><p></p></div>
          <div class="tp-vw-act"><span class="tp-vw-n" aria-live="polite"></span>
            ${puedeEditar(t) ? `<button type="button" class="tp-btn tp-btn-ghost tp-btn-sm" data-act="vw-mover">${I.mover}<span>Mover</span></button>` : ''}
            <button type="button" class="tp-btn tp-btn-soft tp-btn-sm" data-act="vw-bajar">${I.download}<span>Descargar</span></button>
            <button type="button" class="tp-ib" data-act="vw-cerrar" aria-label="Cerrar la vista previa">${I.x}</button></div></header>
        <div class="tp-vw-body"></div>
        ${lista.length > 1 ? `<button type="button" class="tp-vw-nav is-prev" data-act="vw-ant" aria-label="Archivo anterior">${I.left}</button><button type="button" class="tp-vw-nav is-next" data-act="vw-sig" aria-label="Archivo siguiente">${I.right}</button>` : ''}
      </div>`;
    capas.appendChild(el);
    VW = { el, tid: t.id, cid: x.id, lista, i, url: null, tok: 0, opener: document.activeElement };
    bloquear(); cargarVista();
    foco(el.querySelector('.tp-vw-card'));
}
function cerrarVisor(sinFoco) {
    if (!VW) return;
    const { el, url, opener } = VW; VW = null; el.remove();
    if (url) URL.revokeObjectURL(url);
    bloquear();
    if (!sinFoco && opener && opener.isConnected) opener.focus();
}
function moverVisor(d) { if (!VW || VW.lista.length < 2) return; VW.i = (VW.i + d + VW.lista.length) % VW.lista.length; cargarVista(); }
async function cargarVista() {
    const v = VW, a = v.lista[v.i], tok = ++v.tok, body = v.el.querySelector('.tp-vw-body'), tipo = tipoVista(a);
    const t = tablero(v.tid), x = t && t.tarjetas.find(c => c.id === v.cid);
    v.el.querySelector('#vw-t').textContent = a.nombre;
    v.el.querySelector('.tp-vw-tx p').textContent = [tamTxt(a.tam), extDe(a.nombre) || a.tipo, nombreDe(a.q), rel(a.t), x ? `«${x.titulo}»` : ''].filter(Boolean).join(' · ');
    v.el.querySelector('.tp-vw-ic').innerHTML = `${I.file}<i>${esc(extDe(a.nombre))}</i>`;
    v.el.querySelector('.tp-vw-n').textContent = v.lista.length > 1 ? `${v.i + 1} de ${v.lista.length}` : '';
    body.className = 'tp-vw-body is-' + (tipo || 'otro');
    body.innerHTML = '<div class="tp-loading tp-vw-load" role="status"><span class="tp-spin" aria-hidden="true"></span>Cargando la vista previa…</div>';
    if (v.url) { URL.revokeObjectURL(v.url); v.url = null; }
    const sinVista = (txt) => `<div class="tp-vw-none"><span class="tp-empty-ic">${I.file}</span><h3>${esc(txt || 'Este tipo de archivo no tiene vista previa')}</h3><p>Descárgalo para abrirlo con el programa que corresponda.</p><button type="button" class="tp-btn tp-btn-main" data-act="vw-bajar">${I.download}Descargar «${esc(a.nombre)}»</button></div>`;
    if (!tipo) { body.innerHTML = sinVista(); return; }
    let b;
    try { b = await api.blob(`/archivos/${a.id}`); } catch (e) { if (VW === v && v.tok === tok) body.innerHTML = sinVista(msgErr(e)); return; }
    if (VW !== v || v.tok !== tok) return;
    try {
        if (tipo === 'texto') {
            const txt = await b.slice(0, 1024 * 1024).text();
            if (VW !== v || v.tok !== tok) return;
            body.innerHTML = `<pre class="tp-vw-pre" tabindex="0">${esc(txt)}</pre>${b.size > 1024 * 1024 ? '<p class="tp-help tp-vw-cut">Se muestra el primer MB. Descarga el archivo para verlo completo.</p>' : ''}`;
            return;
        }
        if (tipo === 'hoja') { await vistaHoja(v, tok, b, body); return; }
        const tipoBlob = MIME_VISTA[tipo] ? MIME_VISTA[tipo](a) : a.tipo;
        v.url = URL.createObjectURL(new Blob([b], { type: tipoBlob || b.type }));
        const u = esc(v.url);
        if (tipo === 'img') body.innerHTML = `<img src="${u}" alt="${esc(a.nombre)}">`;
        else if (tipo === 'pdf') body.innerHTML = `<iframe src="${u}" title="${esc(a.nombre)}"></iframe>`;
        else if (tipo === 'video') body.innerHTML = `<video src="${u}" controls preload="metadata"></video>`;
        else if (tipo === 'audio') body.innerHTML = `<div class="tp-vw-audio"><span class="tp-empty-ic">${I.file}</span><b>${esc(a.nombre)}</b><audio src="${u}" controls preload="metadata"></audio></div>`;
        const m = body.querySelector('video, audio, img');
        if (m) m.addEventListener('error', () => { if (VW === v && v.tok === tok) body.innerHTML = sinVista('El navegador no puede mostrar este archivo'); }, { once: true });
    } catch (e) { if (VW === v && v.tok === tok) body.innerHTML = sinVista('No se pudo leer el archivo'); }
}
/** Planillas (xlsx, xls, ods, csv): se leen en el navegador y se muestran como tabla. */
async function vistaHoja(v, tok, b, body) {
    const XLSX = await import(/* webpackChunkName: "xlsx" */ 'xlsx');
    const wb = XLSX.read(new Uint8Array(await b.arrayBuffer()), { type: 'array' });
    if (VW !== v || v.tok !== tok) return;
    const MAXF = 300, MAXC = 40;
    const hoja = n => {
        const filas = XLSX.utils.sheet_to_json(wb.Sheets[n], { header: 1, defval: '', raw: false, blankrows: false });
        const nc = Math.min(MAXC, filas.reduce((m, r) => Math.max(m, r.length), 0));
        const cab = Array.from({ length: nc }, (_, i) => `<th scope="col">${esc(XLSX.utils.encode_col(i))}</th>`).join('');
        const cuerpo = filas.slice(0, MAXF).map((r, i) => `<tr><th scope="row">${i + 1}</th>${Array.from({ length: nc }, (_, j) => `<td>${esc(r[j] == null ? '' : r[j])}</td>`).join('')}</tr>`).join('');
        const corte = filas.length > MAXF || filas.reduce((m, r) => Math.max(m, r.length), 0) > MAXC;
        return filas.length ? `<div class="tp-vw-xl" tabindex="0"><table><thead><tr><th></th>${cab}</tr></thead><tbody>${cuerpo}</tbody></table></div>${corte ? `<p class="tp-help tp-vw-cut">Se muestran las primeras ${MAXF} filas y ${MAXC} columnas. Descarga el archivo para verlo completo.</p>` : ''}` : '<p class="tp-help tp-vw-cut">Esta hoja está vacía.</p>';
    };
    const nombres = wb.SheetNames;
    const pintar = k => {
        body.innerHTML = `${nombres.length > 1 ? `<div class="tp-vw-hojas" role="group" aria-label="Hojas de la planilla">${nombres.map((n, i) => `<button type="button" class="tp-vista" aria-pressed="${i === k}" data-hoja="${i}">${esc(n)}</button>`).join('')}</div>` : ''}${hoja(nombres[k])}`;
        body.querySelectorAll('[data-hoja]').forEach(btn => btn.addEventListener('click', () => pintar(+btn.dataset.hoja)));
    };
    pintar(0);
}

// ── Mover un archivo a otra tarjeta (de este u otro tablero) ──
async function modalMoverArchivo(t, x, a) {
    abrirModal(modalHTML({ titulo: `Mover «${esc(a.nombre)}»`, sub: `Ahora está en «${esc(x.titulo)}». Elige la tarjeta a la que pasa: puede ser de otra columna o de otro tablero.`, form: 'mover-archivo', l: true,
        cuerpo: '<div class="tp-loading" role="status"><span class="tp-spin" aria-hidden="true"></span>Cargando tus tableros…</div>',
        pie: pieBtns('Mover archivo') }), { kind: 'mover', tid: t.id, cid: x.id, aid: a.id, nombre: a.nombre, tab: t.id, q: '' });
    const m = M;
    let d;
    try { d = await api.get('/destinos'); } catch (e) { if (M === m) M.el.querySelector('.tp-md-body').innerHTML = `<p class="tp-err">${esc(msgErr(e))}</p>`; return; }
    if (M !== m) return;
    M.dest = d.tableros || [];
    if (!M.dest.some(b => b.id === M.tab)) M.tab = M.dest.length ? M.dest[0].id : 0;
    pintarMover(true);
}
function pintarMover(primera) {
    if (!M || M.kind !== 'mover' || !M.dest) return;
    const body = M.el.querySelector('.tp-md-body'), tb = M.dest.find(b => b.id === M.tab), q = norm(M.q);
    const elegida = (body.querySelector('[name="dest"]:checked') || {}).value;
    if (!M.dest.length) { body.innerHTML = '<p class="tp-help">No tienes tableros donde puedas editar.</p>'; return; }
    const cols = tb ? tb.columnas.map(c => ({ ...c, tarjetas: c.tarjetas.filter(y => y.id !== M.cid && (!q || norm(y.titulo).includes(q))) })).filter(c => c.tarjetas.length) : [];
    const lista = cols.length ? cols.map(c => `<fieldset class="tp-mv-col tn-${c.color}"><legend><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span><span class="tp-n">${c.tarjetas.length}</span></legend>
        ${c.tarjetas.map(y => `<label class="tp-mv-it"><input type="radio" name="dest" value="${y.id}" ${String(y.id) === elegida ? 'checked' : ''}><span>${esc(y.titulo)}</span></label>`).join('')}</fieldset>`).join('')
        : `<p class="tp-help tp-mv-none">${q ? 'Ninguna tarjeta coincide con la búsqueda.' : 'Este tablero no tiene otras tarjetas.'}</p>`;
    if (primera || !body.querySelector('#mv-lista')) {
        body.innerHTML = `<div class="tp-molde-2 tp-mv-top">
            <div class="tp-f"><label for="mv-tab">Tablero</label><select id="mv-tab" name="tab" class="tp-in">${M.dest.map(b => `<option value="${b.id}" ${b.id === M.tab ? 'selected' : ''}>${esc(b.nombre)}${b.id === M.tid ? ' (este tablero)' : ''}</option>`).join('')}</select></div>
            <div class="tp-f"><label for="mv-q">Buscar tarjeta</label><input id="mv-q" name="q" type="search" class="tp-in" placeholder="Título de la tarjeta…" autocomplete="off" value="${esc(M.q)}"></div></div>
          <div class="tp-f"><span class="tp-mv-h" id="mv-h">Tarjeta de destino</span><div class="tp-mv-lista" id="mv-lista" role="radiogroup" aria-labelledby="mv-h">${lista}</div><p class="tp-err" id="mv-e" role="alert"></p></div>
          <p class="tp-help">${I.info}<span> El archivo deja de estar en «${esc((tablero(M.tid).tarjetas.find(c => c.id === M.cid) || {}).titulo || '')}». Queda anotado en el historial de las dos tarjetas.</span></p>`;
        if (primera) foco('#mv-q');
    } else body.querySelector('#mv-lista').innerHTML = lista;
}
const histHTML = x => !x.hist ? '<li class="tp-help">Cargando historial…</li>' : x.hist.map(h => `<li><span class="tp-hist-ic">${HIST_IC[h.ty] || I.edit}</span><p>${esc(h.txt)}<time datetime="${new Date(h.t).toISOString()}" title="${fechaHora(h.t)}">${esc(nombreDe(h.q))} · ${rel(h.t)}</time></p></li>`).join('');
function pintarDrawer(seccion) {
    if (!DR) return;
    const t = tablero(DR.tid), x = t && t.tarjetas.find(c => c.id === DR.cid);
    if (!x) { cerrarDrawer(true); return; }
    const q0 = s => DR.el.querySelector(s);
    // En las copias de Notion no hay historial: el contenedor no existe.
    const q = s => q0(s) || (s === '#dr-hist' ? document.createElement('ol') : null);
    if (seccion === 'hist') { q('#dr-hist').innerHTML = histHTML(x); return; }
    if (seccion === 'archivos') {
        q('#dr-files').innerHTML = archivosHTML(x, t);
        q('#dr-files-n').textContent = (x.archivos || []).length || '';
        q('#dr-hist').innerHTML = histHTML(x);
        cargarMiniaturas(DR.el); return;
    }
    if (seccion === 'seg') {   // sin re-dibujar el campo de fecha mientras se escribe
        const v = segVencido(x);
        q('#dr-seg').classList.toggle('is-due', v);
        q('#dr-seg-h').className = 'tp-fi-hint' + (v ? ' is-due' : ''); q('#dr-seg-h').textContent = segHint(x);
        q('#dr-seg-x').innerHTML = x.seguimiento && puedeEditar(t) ? `<button type="button" class="tp-ib" data-act="seg-quitar" aria-label="Quitar el seguimiento">${I.x}</button>` : '';
        q('#dr-hist').innerHTML = histHTML(x); return;
    }
    const activo = document.activeElement && DR.el.contains(document.activeElement) ? document.activeElement.id : null;
    if (seccion === 'notas') { q('#dr-notes').innerHTML = notasHTML(x, t); q('#dr-ficha').innerHTML = fichaHTML(t, x); }
    else {
        q('#dr-ficha').innerHTML = fichaHTML(t, x);
        if (q('#pn-datos') && (seccion === 'todo' || !DR.dirty)) { q('#pn-datos').innerHTML = datosHTML(t, x); DR.dirty = false; estadoDatos(); }
    }
    q('#pn-resumen').innerHTML = resumenHTML(t, x);
    q('#dr-hist').innerHTML = histHTML(x);
    q('#tab-notas').innerHTML = tabTxt('notas', tabNombre(t), x);
    cargarMiniaturas(DR.el);
    if (activo) { const el = document.getElementById(activo); if (el) el.focus(); }
}
function autoAlto(el) { if (!el) return; el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; }
function cambiarTab(k) {
    if (!DR) return;
    DR.tab = k;
    TABS.forEach(([n]) => {
        const b = DR.el.querySelector('#tab-' + n), on = n === k;
        if (!b) return;
        b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1;
        DR.el.querySelector('#pn-' + n).hidden = !on;
    });
    DR.el.querySelector('#dr-foot').hidden = k !== 'datos';
}
function drawerChange(el) {
    if (!puedeEditar(tablero(DR.tid))) { toast('Solo puedes ver este tablero.'); pintarDrawer(); return; }
    if (el.hasAttribute('data-files')) { const f = el.files; if (f && f.length) subirArchivos(f).finally(() => { el.value = ''; }); return; }
    const t = tablero(DR.tid), x = t && t.tarjetas.find(c => c.id === DR.cid); if (!x) return;
    const k = el.dataset.k;
    if (k === 'col') {
        if (moverTarjeta(t, x.id, +el.value, null)) { guardarMov(t, x.id); pintarZona(); anunciar(`Movida a «${colDe(t, +el.value).nombre}»`); }
        pintarDrawer(); return;
    }
    if (k === 'asignado') {
        const id = el.value ? +el.value : null;
        if (id && !puedeEditar(t, id)) {
            if (!esDueno(t)) { el.value = x.asignado || ''; return; }
            el.value = x.asignado || '';
            abrirModal(modalHTML({ titulo: `¿Compartir con ${esc(nombreDe(id))}?`, form: 'compartir-asignar',
                cuerpo: `<input type="hidden" name="uid" value="${id}"><p>${esc(nombreDe(id))} todavía no tiene acceso a «${esc(t.nombre)}». Para asignarle la tarjeta, se le comparte el tablero con permiso <b>Puede editar</b> y le llega un aviso.</p>`,
                pie: pieBtns('Compartir y asignar') }), { tid: t.id });
            return;
        }
        setAsignado(t, x, id); return;
    }
    if (k === 'seguimiento') {
        const v = el.value, y = +v.slice(0, 4);
        if (v && (!/^\d{4}-\d{2}-\d{2}$/.test(v) || y < 2000 || y > 2100)) return;   // año a medio escribir
        setSeguimiento(t, x, v || null); return;
    }
    if (el.dataset.q) {
        const f = t.campos.find(c => String(c.id) === el.dataset.q), v = el.value ? +el.value : null;
        if (!f || igual(x.datos[f.id], v)) return;
        setDato(x, f, v); hist(x, 'edit', `«${f.nombre}»: ${textoValor(f, v)}`); tocar(t, x);
        pintarZona(); pintarDrawer();
        llamar(() => api.put(`/tarjetas/${x.id}`, { datos: { [f.id]: v } })).then(d => { ponerTarjeta(t, d.tarjeta); }).catch(() => {});
    }
}
/** Asignar (con `compartir` el dueño le da acceso de editor a quien no lo tiene). */
function setAsignado(t, x, id, compartir, enLugar) {
    if ((x.asignado || null) === id) return;
    x.asignado = id;
    hist(x, 'asig', id ? `Asignó a ${nombreDe(id)}` : 'Quitó la asignación');
    tocar(t, x); if (enLugar) enLugar(); else pintarZona(); pintarDrawer();
    anunciar(id ? `Asignada a ${nombreDe(id)}` : 'Sin asignar');
    llamar(() => api.post(`/tarjetas/${x.id}/asignar`, { asignado: id, compartir: !!compartir })).then(d => {
        aplicarTablero(d.tablero); if (!XE) pintarZona(); if (DR) pintarDrawer();
    }).catch(() => {});
}
function setSeguimiento(t, x, v, enLugar) {
    if ((x.seguimiento || null) === v) return;
    x.seguimiento = v;
    hist(x, 'seg', v ? `Seguimiento para el ${fechaCorta(v)}` : 'Quitó el seguimiento');
    tocar(t, x); if (enLugar) enLugar(); else pintarZona(); pintarDrawer('seg');
    llamar(() => api.post(`/tarjetas/${x.id}/seguimiento`, { fecha: v })).then(d => { ponerTarjeta(t, d.tarjeta); }).catch(() => {});
}
// «Datos»: se edita en borrador y se guarda con el botón (como el CRM).
function datosLeer(t, form) {
    const datos = {}, errs = [], el = form.elements.titulo, titulo = limpio(el.value);
    if (!titulo) errs.push([el, form.querySelector('#d-tit-e'), 'El título no puede quedar vacío.']);
    camposDatos(t).forEach(f => {
        const row = form.querySelector(`[data-fid="${f.id}"]`); if (!row) return;
        const v = leerCampo(f, row), m = validar(f, v);
        if (m) { errs.push([row.querySelector('[data-campo]'), row.querySelector('.tp-err'), m]); return; }
        const nv = normalizar(f, v); if (!vacio(nv)) datos[f.id] = nv;
    });
    return { titulo, datos, errs };
}
function estadoDatos() {
    if (!DR) return;
    const st = DR.el.querySelector('#dr-state');
    st.textContent = DR.dirty ? 'Cambios sin guardar' : 'Sin cambios';
    st.classList.toggle('is-dirty', DR.dirty);
    DR.el.querySelector('#dr-save').disabled = !DR.dirty;
    DR.el.querySelector('#dr-desc').disabled = !DR.dirty;
}
function marcarDatos() {
    const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid), form = DR.el.querySelector('#pn-datos');
    const { titulo, datos } = datosLeer(t, form);
    DR.dirty = titulo !== x.titulo || camposDatos(t).some(f => !igual(x.datos[f.id], datos[f.id]))
        || camposDatos(t).some(f => { const row = form.querySelector(`[data-fid="${f.id}"]`); return row && validar(f, leerCampo(f, row)); });
    estadoDatos();
}
function guardarDatos() {
    const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid), form = DR.el.querySelector('#pn-datos');
    limpiarErrores(form);
    const { titulo, datos, errs } = datosLeer(t, form);
    if (errs.length) {
        errs.forEach(([el, p, m]) => { el.setAttribute('aria-invalid', 'true'); if (p) p.textContent = m; });
        cambiarTab('datos'); errs[0][0].focus();
        DR.el.querySelector('#dr-state').textContent = 'Revisa lo marcado en rojo';
        return false;
    }
    const cambios = [], body = {};
    if (titulo !== x.titulo) { cambios.push('Título'); x.titulo = titulo; body.titulo = titulo; }
    camposDatos(t).forEach(f => { if (!igual(x.datos[f.id], datos[f.id])) { cambios.push(f.nombre); setDato(x, f, datos[f.id]); (body.datos = body.datos || {})[f.id] = vacio(datos[f.id]) ? null : datos[f.id]; } });
    if (cambios.length) {
        hist(x, 'edit', 'Editó ' + cambios.map(c => `«${c}»`).join(', ')); tocar(t, x);
        llamar(() => api.put(`/tarjetas/${x.id}`, body)).then(d => { ponerTarjeta(t, d.tarjeta); pintarZona(); }).catch(() => {});
    }
    DR.dirty = false;
    pintarDrawer('todo'); pintarZona();
    if (cambios.length) toast('Cambios guardados.');
    return true;
}
function eliminarTarjeta(t0, x0) {
    const t = t0 || tablero(DR.tid), x = x0 || t.tarjetas.find(c => c.id === DR.cid);
    if (!x) return;
    t.tarjetas = t.tarjetas.filter(c => c.id !== x.id);
    if (t.molde === x.id) t.molde = 0;
    tocar(t);
    if (DR && DR.cid === x.id) { DR.dirty = false; cerrarDrawer(true); }
    pintarZona();
    llamar(() => api.del(`/tarjetas/${x.id}`)).then(() => {
        toast(`Tarjeta «${x.titulo}» eliminada.`, { undo() { llamar(() => api.post(`/tarjetas/${x.id}/restaurar`)).then(() => recargar()).catch(() => {}); } });
    }).catch(() => {});
}
/** Duplica en la API (copia datos y archivos, queda debajo de la original). `abrir` = abrirla después. */
function duplicarTarjeta(t, x, abrir) {
    llamar(() => api.post(`/tarjetas/${x.id}/duplicar`)).then(d => {
        // Se pone al instante justo debajo de la original (con el orden que hay en pantalla;
        // el del servidor puede ir con otra numeración hasta la próxima recarga).
        const nueva = ponerTarjeta(t, d.tarjeta);
        nueva.col = x.col; nueva.orden = x.orden + 0.5;
        tarjetasCol(t, x.col).forEach((c, k) => { c.orden = k; });
        if (S.t === t) { pintarZona(); if (abrir) abrirTarjeta(nueva.id); else requestAnimationFrame(() => flash(nueva.id)); }
        toast('Tarjeta duplicada.');
    }).catch(() => {});
}
/** Menú «…» de la tarjeta en el tablero (sin abrirla). */
function menuCard(b) {
    const t = actual(), x = t && t.tarjetas.find(c => c.id === +b.dataset.id); if (!x) return;
    const col = colDe(t, x.col);
    abrirPop(b, [
        { head: x.titulo },
        { txt: 'Abrir tarjeta', ic: I.eye, fn() { abrirTarjeta(x.id); } },
        { txt: `Nueva tarjeta en «${col ? col.nombre : ''}»`, ic: I.plus, fn() { modalTarjeta(t, x.col); } },
        { txt: 'Duplicar tarjeta', ic: I.copy, fn() { if (DR && DR.dirty) { pedirGuardar(); return; } duplicarTarjeta(t, x, false); } },
        { sep: 1 },
        { txt: 'Eliminar tarjeta', ic: I.trash, danger: 1, fn() { if (DR && DR.dirty && DR.cid === x.id) { pedirGuardar(); return; } eliminarTarjeta(t, x); } },
    ], 'Opciones de la tarjeta');
}
const pedirGuardar = () => { cambiarTab('datos'); toast('Primero guarda o descarta los cambios de «Datos».'); foco('#dr-save:not(:disabled), #dr-desc'); };
function menuDrawer(b) {
    const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid);
    abrirPop(b, [
        { txt: 'Duplicar tarjeta', ic: I.copy, fn() {
            if (DR.dirty) { pedirGuardar(); return; }
            duplicarTarjeta(t, x, true);
        } },
        x.id !== t.molde && esDueno(t) ? { txt: 'Usar como tarjeta de ejemplo', ic: I.star, fn() {
            const ant = t.tarjetas.find(c => c.id === t.molde);
            t.molde = x.id; hist(x, 'ej', 'Pasó a ser la tarjeta de ejemplo');
            if (ant) hist(ant, 'ej', 'Dejó de ser la tarjeta de ejemplo');
            tocar(t); pintarZona(); pintarDrawer(); toast('Ahora es la tarjeta de ejemplo del tablero.');
            llamar(() => api.put(`/${t.id}/ejemplo`, { tarjeta_id: x.id })).catch(() => {});
        } } : null,
        { sep: 1 },
        { txt: 'Eliminar tarjeta', ic: I.trash, danger: 1, fn: eliminarTarjeta },
    ].filter(Boolean), 'Opciones de la tarjeta');
}

// ── Molde de tarjeta (tarjeta de ejemplo + campos) ──
let MD = null;
function sugeridos() {
    return [
        { id: nid(), nombre: 'Prioridad', tipo: 'lista', opciones: [{ id: nid(), nombre: 'Alta', color: 'red' }, { id: nid(), nombre: 'Media', color: 'amber' }, { id: nid(), nombre: 'Baja', color: 'gray' }], enTarjeta: true },
        { id: nid(), nombre: 'Contacto', tipo: 'texto', opciones: [], enTarjeta: true },
        { id: nid(), nombre: 'Correo', tipo: 'correo', opciones: [], enTarjeta: false },
        { id: nid(), nombre: 'Teléfono', tipo: 'telefono', opciones: [], enTarjeta: false },
        { id: nid(), nombre: 'Detalle', tipo: 'largo', opciones: [], enTarjeta: false },
    ];
}
function abrirMolde(t) {
    if (!t || !t.columnas.length) return;
    const ej = t.tarjetas.find(x => x.id === t.molde), nuevo = !t.listo;
    MD = {
        tid: t.id, nuevo, hayEj: nuevo || !!ej, sugeridos: nuevo && !t.campos.length,
        titulo: ej ? ej.titulo : '', col: ej ? ej.col : t.columnas[0].id,
        campos: t.campos.length ? copia(t.campos) : sugeridos(),
        valores: ej ? copia(ej.datos) : {},
        orig: Object.fromEntries(t.campos.map(f => [f.id, f.tipo])),
    };
    abrirModal(moldeHTML(t), { kind: 'molde', onClose() { MD = null; } });
    pintarPrev();
}
// Nombres cortos para los botones «Agregar un campo».
const TIPO_CORTO = { texto: 'Texto', largo: 'Texto largo', numero: 'Número', fecha: 'Fecha', lista: 'Lista', multi: 'Etiquetas', persona: 'Persona', correo: 'Correo', telefono: 'Teléfono', enlace: 'Enlace', casilla: 'Sí / No' };
const TIPO_AYUDA = { texto: 'Una línea: nombre, ciudad, código…', largo: 'Varias líneas: detalle, observaciones…', numero: 'Cantidades, montos, códigos numéricos', fecha: 'Un día del calendario', lista: 'Una opción de una lista con colores', multi: 'Varias opciones a la vez', persona: 'Un admin del panel', correo: 'Se puede abrir para escribir', telefono: 'Se puede tocar para llamar', enlace: 'Una página web', casilla: 'Marcado o no marcado' };
function moldeHTML(t) {
    const sec = (k, titulo, texto, st) => `<header class="tp-sec-h"><span class="tp-sec-n" id="ms-n${k}" aria-hidden="true">${k}</span><div class="tp-sec-tt"><h3 id="ms-s${k}">${titulo}</h3><p>${texto}</p></div><span class="tp-sec-st" id="ms-st${k}">${st}</span></header>`;
    return modalHTML({
        titulo: MD.nuevo ? 'Crea la tarjeta de ejemplo' : 'Molde de tarjeta', form: 'molde', xl: true, ask: true,
        sub: MD.nuevo ? 'Es la base del tablero: todas las tarjetas nuevas van a tener los mismos campos que armes aquí.'
            : 'Los cambios se aplican a todas las tarjetas del tablero.',
        cuerpo: `<div class="tp-molde tp-molde--v2"><div class="tp-molde-ed">
            <ol class="tp-molde-pasos" aria-label="Cómo funciona">
              <li><i>1</i><span><b>Tarjeta de ejemplo</b>Una tarjeta real que sirve de guía (se marca con ★).</span></li>
              <li><i>2</i><span><b>Campos</b>Los datos que vas a llenar en cada tarjeta y de qué tipo son.</span></li>
              <li><i>${I.eye}</i><span><b>En el tablero</b>Elige cuáles se ven en la tarjeta; el resto, al abrirla.</span></li>
            </ol>
            <section class="tp-sec" aria-labelledby="ms-s1">
              ${sec(1, 'Tarjeta de ejemplo', MD.hayEj ? 'Ponle un título real y llena los campos de abajo con datos de ejemplo.' : 'Este tablero todavía no tiene una tarjeta de ejemplo.', MD.hayEj ? '' : 'Sin ejemplo')}
              ${MD.hayEj ? `<div class="tp-nv-grid">
                <div class="tp-f is-full2"><label for="m-tit">Título de la tarjeta de ejemplo <span class="tp-req">Obligatorio</span></label><input id="m-tit" name="titulo" class="tp-in" maxlength="120" value="${esc(MD.titulo)}" placeholder="Ej.: Revisar contrato de limpieza" autocomplete="off" autofocus><p class="tp-err" id="m-tit-e" role="alert"></p></div>
                <div class="tp-f"><label for="m-col">Columna donde queda</label><select id="m-col" name="col" class="tp-in">${opcionesCol(t, MD.col)}</select></div></div>`
            : `<p class="tp-info">${I.star}<span>Abre una tarjeta y, en su menú «…», elige «Usar como tarjeta de ejemplo».</span></p>`}
            </section>
            <section class="tp-sec" aria-labelledby="ms-s2">
              ${sec(2, 'Campos de cada tarjeta', 'Para cada dato: un nombre, el tipo y si se ve en el tablero.' + (MD.sugeridos ? ' Te sugerimos algunos: cámbialos o quítalos.' : ''), `<span id="m-n">${MD.campos.filter(f => !f._borrar).length}</span> campos`)}
              <p class="tp-fijos">${I.lock}<span>Siempre incluidos, no hace falta crearlos:</span><span class="tp-tag">Título</span><span class="tp-tag">Asignada a</span><span class="tp-tag">Seguimiento</span><span class="tp-tag">Notas</span><span class="tp-tag">Archivos</span></p>
              <ol class="tp-fields" id="m-fields">${camposHTML(t)}</ol>
              <div class="tp-addf"><span class="tp-addf-h" id="m-add-h">${I.plus}Agregar un campo</span>
                <div class="tp-addf-l" role="group" aria-labelledby="m-add-h">${TIPOS.map(([k], i) => `<button type="button" class="tp-addf-b" ${i === 0 ? 'id="m-add"' : ''} data-act="campo-add" data-tipo="${k}" title="${esc(TIPO_AYUDA[k])}">${TIPO_IC[k]}<span>${TIPO_CORTO[k]}</span></button>`).join('')}</div></div>
            </section>
          </div>
          <aside class="tp-molde-prev" aria-label="Vista previa de la tarjeta"><h3>Así se ve en el tablero</h3><div id="m-prev">${previewHTML(t)}</div>
            <p class="tp-molde-res" id="m-res"></p>
            <p class="tp-help">Solo se ven en la tarjeta los campos con «Se ve en la tarjeta». Todos los datos se ven al abrirla.</p></aside></div>`,
        pie: pieBtns(MD.nuevo ? 'Guardar y empezar' : 'Guardar cambios'),
    });
}
const conDato = (t, fid) => t.tarjetas.filter(x => !vacio(x.datos[fid])).length;
function camposHTML(t) {
    if (!MD.campos.length) return '<li class="tp-fld-empty">Sin campos: las tarjetas tendrán solo el título. Agrega abajo los datos que quieras guardar.</li>';
    const vivos = MD.campos.filter(f => !f._borrar);
    return MD.campos.map(f => {
        if (f._borrar) {
            const n = conDato(t, f.id);
            return `<li class="tp-fld is-del" data-fid="${f.id}"><span>«${esc(f.nombre || 'Sin nombre')}» se quitará al guardar${n ? ` y se borrará su dato en ${plural(n, 'tarjeta', 'tarjetas')}` : ''}.</span><button type="button" class="tp-btn-link" id="fz-${f.id}" data-act="campo-undel">Deshacer</button></li>`;
        }
        const i = vivos.indexOf(f), op = f.tipo === 'lista' || f.tipo === 'multi', o = MD.orig[f.id];
        const n = !MD.nuevo && o && o !== f.tipo && !(TEXTOS.has(o) && TEXTOS.has(f.tipo)) ? conDato(t, f.id) : 0;
        const nom = esc(f.nombre || `campo ${i + 1}`);
        return `<li class="tp-fld" data-fid="${f.id}">
          <div class="tp-fld-top">
            <span class="tp-fld-num" aria-hidden="true">${i + 1}</span>
            <div class="tp-fld-c"><label class="tp-fld-lb" for="fn-${f.id}">Nombre del campo</label>
              <input id="fn-${f.id}" class="tp-in tp-in--s" data-fk="nombre" value="${esc(f.nombre)}" maxlength="40" placeholder="Ej.: ${esc({ lista: 'Prioridad', multi: 'Etiquetas', fecha: 'Fecha límite', numero: 'Monto', persona: 'Responsable', correo: 'Correo', telefono: 'Teléfono', enlace: 'Sitio web', casilla: '¿Pagado?', largo: 'Detalle' }[f.tipo] || 'Contacto')}" autocomplete="off"></div>
            <div class="tp-fld-c"><label class="tp-fld-lb" for="ft-${f.id}">Tipo de dato</label>
              <span class="tp-fld-tw"><span class="tp-fld-ic" aria-hidden="true">${TIPO_IC[f.tipo]}</span><select id="ft-${f.id}" class="tp-in tp-in--s" data-fk="tipo">${TIPOS.map(([k, v]) => `<option value="${k}" ${k === f.tipo ? 'selected' : ''}>${v}</option>`).join('')}</select></span></div>
            <span class="tp-fld-tools">
              <button type="button" class="tp-ib" id="fu-${f.id}" data-act="campo-up" aria-label="Subir «${nom}»" title="Subir" ${i === 0 ? 'disabled' : ''}>${I.up}</button>
              <button type="button" class="tp-ib" id="fd-${f.id}" data-act="campo-down" aria-label="Bajar «${nom}»" title="Bajar" ${i === vivos.length - 1 ? 'disabled' : ''}>${I.down}</button>
              <button type="button" class="tp-ib" id="fx-${f.id}" data-act="campo-del" aria-label="Quitar «${nom}»" title="Quitar">${I.trash}</button></span>
          </div>
          <p class="tp-fld-ayuda">${esc(TIPO_AYUDA[f.tipo])}</p>
          ${op ? `<div class="tp-fld-ops"><span class="tp-fld-lb">Opciones <small>· toca el color para cambiarlo</small></span><div class="tp-opts" role="group" aria-label="Opciones de «${nom}»">${f.opciones.map(o => `<span class="tp-opt tn-${o.color}" data-oid="${o.id}"><button type="button" class="tp-opt-c" id="oc-${o.id}" data-act="opt-color" aria-label="Color ${COLOR_NOMBRE[o.color]} de «${esc(o.nombre || 'opción')}». Cambiar"></button><input id="o-${o.id}" class="tp-opt-in" data-ok="nombre" value="${esc(o.nombre)}" maxlength="30" size="${Math.max(5, o.nombre.length + 1)}" placeholder="Opción" aria-label="Nombre de la opción" autocomplete="off"><button type="button" class="tp-opt-x" id="ox-${o.id}" data-act="opt-del" aria-label="Quitar la opción «${esc(o.nombre || 'sin nombre')}»">${I.x}</button></span>`).join('')}<button type="button" class="tp-opt-add" id="oa-${f.id}" data-act="opt-add">${I.plus}Opción</button></div></div>` : ''}
          <div class="tp-fld-val">
            ${MD.hayEj ? `<div class="tp-fld-c tp-fld-ej"><label class="tp-fld-lb" for="fv-${f.id}" id="fv-${f.id}-l">Valor en la tarjeta de ejemplo <small>(opcional)</small></label>${inputCampo(f, MD.valores[f.id], 'fv-' + f.id)}</div>` : '<span></span>'}
            <span class="tp-fld-checks"><label class="tp-tog"><input type="checkbox" id="fe-${f.id}" data-fk="enTarjeta" ${f.enTarjeta ? 'checked' : ''}><span>${I.eye}Se ve en la tarjeta</span></label><label class="tp-tog"><input type="checkbox" id="fq-${f.id}" data-fk="filtro" ${usaFiltro(f) ? 'checked' : ''}><span>${I.filter}Sirve de filtro</span></label></span>
          </div>
          ${n ? `<p class="tp-warn">Al guardar se borrará este dato en ${plural(n, 'tarjeta', 'tarjetas')} porque cambia el tipo.</p>` : ''}
          <p class="tp-err" data-errf role="alert"></p>
        </li>`;
    }).join('');
}
function previewHTML(t) {
    const c = colDe(t, MD.col) || t.columnas[0];
    const campos = MD.campos.filter(f => !f._borrar && f.nombre.trim());
    const x = { id: -1, titulo: limpio(MD.titulo) || 'Título de la tarjeta', datos: MD.valores, creada: ahora(), editada: ahora(), nNotas: 0, archivos: [] };
    return `<div class="tp-col tn-${c.color}"><header class="tp-col-head"><span class="tp-colpill"><span class="tp-dot"></span><span>${esc(c.nombre)}</span></span></header><div class="tp-col-body">${cardHTML(t, x, { campos, ej: MD.hayEj, preview: true })}</div></div>`;
}
function pintarCampos(focoId) {
    const t = tablero(MD.tid), id = focoId || (document.activeElement && document.activeElement.id);
    M.el.querySelector('#m-fields').innerHTML = camposHTML(t);
    M.el.querySelector('#m-n').textContent = MD.campos.filter(f => !f._borrar).length;
    pintarPrev();
    if (!id) return;
    let el = document.getElementById(id);
    if (el && el.disabled) el = document.getElementById(id.replace(/^f[ud]-/, m => m === 'fu-' ? 'fd-' : 'fu-'));
    if (el) el.focus();
}
function pintarPrev() {
    M.el.querySelector('#m-prev').innerHTML = previewHTML(tablero(MD.tid));
    const vivos = MD.campos.filter(f => !f._borrar), ve = vivos.filter(f => f.enTarjeta).length, fi = vivos.filter(usaFiltro).length;
    const res = M.el.querySelector('#m-res');
    if (res) res.innerHTML = vivos.length ? `<b>${plural(vivos.length, 'campo', 'campos')}</b> · ${ve} ${ve === 1 ? 'se ve' : 'se ven'} en la tarjeta · ${fi} ${fi === 1 ? 'sirve' : 'sirven'} de filtro` : 'Sin campos: solo el título.';
    const st = M.el.querySelector('#ms-st1'), n1 = M.el.querySelector('#ms-n1');
    if (MD.hayEj && st) { const ok = !!limpio(MD.titulo); st.textContent = ok ? 'Completo' : 'Falta el título'; st.className = 'tp-sec-st is-' + (ok ? 'ok' : 'warn'); if (n1) n1.classList.toggle('is-done', ok); }
    const n2 = M.el.querySelector('#ms-n2'); if (n2) n2.classList.toggle('is-done', vivos.length > 0);
}
const campoDe = b => MD.campos.find(f => String(f.id) === b.closest('[data-fid]').dataset.fid);
function moldeInput(e) {
    const el = e.target, li = el.closest('[data-fid]');
    if (el.getAttribute('aria-invalid')) { el.removeAttribute('aria-invalid'); const p = li && li.querySelector('[data-errf]'); if (p) p.textContent = ''; }
    M.dirty = true;
    if (el.name === 'titulo') { MD.titulo = el.value; M.el.querySelector('#m-tit-e').textContent = ''; pintarPrev(); return; }
    if (el.name === 'col') { MD.col = +el.value; pintarPrev(); return; }
    if (!li) return;
    const f = MD.campos.find(c => String(c.id) === li.dataset.fid); if (!f) return;
    if (el.dataset.fk === 'nombre') { f.nombre = el.value; pintarPrev(); }
    else if (el.dataset.fk === 'tipo') {
        if (e.type !== 'change' || el.value === f.tipo) return;
        f.tipo = el.value; delete MD.valores[f.id];
        if ((f.tipo === 'lista' || f.tipo === 'multi') && !f.opciones.length) f.opciones = [{ id: nid(), nombre: 'Opción 1', color: 'blue' }, { id: nid(), nombre: 'Opción 2', color: 'green' }];
        pintarCampos(el.id);
    } else if (el.dataset.fk === 'enTarjeta') { f.enTarjeta = el.checked; pintarPrev(); }
    else if (el.dataset.fk === 'filtro') { f.filtro = el.checked; pintarPrev(); }
    else if (el.dataset.ok === 'nombre') {
        const o = f.opciones.find(o => String(o.id) === el.closest('[data-oid]').dataset.oid); o.nombre = el.value;
        el.size = Math.max(5, el.value.length + 1);
        if (e.type === 'change') pintarCampos(); else pintarPrev();
    } else if (el.dataset.campo) { MD.valores[f.id] = leerCampo(f, li); pintarPrev(); }
}
function moverCampo(b, d) {
    const f = campoDe(b), vivos = MD.campos.filter(c => !c._borrar), j = vivos.indexOf(f) + d;
    if (j < 0 || j >= vivos.length) return;
    const otro = vivos[j], a = MD.campos.indexOf(f), z = MD.campos.indexOf(otro);
    [MD.campos[a], MD.campos[z]] = [MD.campos[z], MD.campos[a]];
    M.dirty = true; pintarCampos(b.id); anunciar(`Campo movido a la posición ${j + 1}`);
}
async function guardarMolde(form) {
    const t = tablero(MD.tid); if (!t) { cerrarModal(true); return; }
    limpiarErrores(form);
    let primero = null;
    const marcar = (el, p, msg) => { if (p) p.textContent = msg; if (el) { el.setAttribute('aria-invalid', 'true'); primero = primero || el; } };
    if (MD.hayEj && !limpio(MD.titulo)) marcar(form.querySelector('#m-tit'), form.querySelector('#m-tit-e'), 'Ponle un título a la tarjeta de ejemplo.');
    const vivos = MD.campos.filter(f => !f._borrar), nombres = new Set();
    vivos.forEach(f => {
        const li = form.querySelector(`[data-fid="${f.id}"]`), p = li.querySelector('[data-errf]'), n = norm(f.nombre);
        if (!n) return marcar(li.querySelector('[data-fk="nombre"]'), p, 'Ponle un nombre al campo.');
        if (nombres.has(n)) return marcar(li.querySelector('[data-fk="nombre"]'), p, 'Ya hay otro campo con ese nombre.');
        nombres.add(n);
        if (f.tipo === 'lista' || f.tipo === 'multi') {
            if (!f.opciones.length) return marcar(li.querySelector('[data-act="opt-add"]'), p, 'Agrega al menos una opción.');
            const vistos = new Set();
            for (const o of f.opciones) {
                const k = norm(o.nombre);
                if (!k) return marcar(form.querySelector('#o-' + o.id), p, 'Hay una opción sin nombre.');
                if (vistos.has(k)) return marcar(form.querySelector('#o-' + o.id), p, `La opción «${o.nombre.trim()}» está repetida.`);
                vistos.add(k);
            }
        }
        if (MD.hayEj) { const m = validar(f, MD.valores[f.id]); if (m) marcar(li.querySelector('[data-campo]'), p, m); }
    });
    if (primero) { form.querySelector('#md-err').textContent = 'Revisa lo marcado en rojo.'; primero.focus(); return; }

    const clave = f => MD.orig[f.id] ? String(f.id) : 'n' + f.id;
    const campos = vivos.map(f => ({ id: MD.orig[f.id] ? f.id : undefined, tmp: clave(f), nombre: limpio(f.nombre), tipo: f.tipo, opciones: (f.tipo === 'lista' || f.tipo === 'multi') ? f.opciones.map(o => ({ id: o.id, nombre: limpio(o.nombre), color: o.color })) : [], enTarjeta: !!f.enTarjeta, filtro: usaFiltro(f) }));
    const ejemplo = MD.hayEj ? { titulo: limpio(MD.titulo), col: MD.col, datos: Object.fromEntries(vivos.map(f => [clave(f), normalizar(f, MD.valores[f.id])]).filter(([, v]) => !vacio(v))) } : null;
    const nuevo = MD.nuevo, boton = form.querySelector('button[type=submit]');
    boton.disabled = true; form.querySelector('#md-err').textContent = '';
    let d;
    try { d = await api.put(`/${t.id}/molde`, { campos, ejemplo }); }
    catch (e) {
        boton.disabled = false;
        const errs = (e && e.data && e.data.errores) || {};
        Object.keys(errs).forEach(k => {
            if (k === 'titulo') { marcar(form.querySelector('#m-tit'), form.querySelector('#m-tit-e'), errs[k]); return; }
            const f = vivos.find(c => clave(c) === k), li = f && form.querySelector(`[data-fid="${f.id}"]`);
            if (li) marcar(li.querySelector('[data-fk="nombre"]'), li.querySelector('[data-errf]'), errs[k]);
        });
        form.querySelector('#md-err').textContent = msgErr(e);
        if (primero) primero.focus();
        return;
    }
    aplicarTablero(d.tablero);
    const ej = d.ejemplo ? { id: d.ejemplo } : null;
    cerrarModal(true);
    if (nuevo) render(); else pintarZona();
    if (DR) pintarDrawer();
    if (ej) requestAnimationFrame(() => flash(ej.id));
    toast(nuevo ? '¡Listo! Ya puedes crear tarjetas con este molde.' : 'Molde de tarjeta guardado.');
}
// ── Avisos ──
function toast(msg, { undo } = {}) {
    const box = raiz.querySelector('.tp-toasts'), el = document.createElement('div');
    el.className = 'tp-toast'; el.setAttribute('role', 'status');
    el.innerHTML = `<span>${esc(msg)}</span>${undo ? `<button type="button" class="tp-toast-b">${I.undo}Deshacer</button>` : ''}<button type="button" class="tp-toast-x" aria-label="Cerrar aviso">${I.x}</button>`;
    box.appendChild(el);
    const fuera = () => { el.classList.add('is-out'); setTimeout(() => el.remove(), 220); };
    const tm = setTimeout(fuera, undo ? 8000 : 4500);
    el.querySelector('.tp-toast-x').onclick = () => { clearTimeout(tm); fuera(); };
    if (undo) el.querySelector('.tp-toast-b').onclick = () => { clearTimeout(tm); fuera(); undo(); toast('Listo, se deshizo.'); };
    while (box.children.length > 3) box.firstChild.remove();
}

// ── Acciones (data-act) ──
const ACT = {
    'nuevo-tablero': () => modalTablero(null),
    'notion-nuevo': () => modalNotion(),
    'notion-cols': () => { const t = actual(); if (t && moverColsNotion(t)) modalColsNotion(t, false); },
    'notion-sync': () => syncNotion(actual(), true),
    'menu-tablero': b => menuTablero(b, (S.lista || []).find(x => x.id === +b.dataset.id), true),
    'reintentar': () => { errorCarga = ''; render(); cargarLista().catch(e => { errorCarga = msgErr(e); render(); }); },
    'menu-board': b => menuTablero(b, actual(), false),
    'rapido': b => {
        const t = actual(), F = Fde(t);
        if (b.dataset.f === 'mias') F.asig = F.asig.length === 1 && F.asig[0] === S.yo ? [] : [S.yo];
        else F.seg = F.seg.m === 'vencida' ? {} : { m: 'vencida' };
        aplicarF(t); foco(`[data-act="rapido"][data-f="${b.dataset.f}"]`);
    },
    'fquitar': b => {
        const t = actual(), F = Fde(t), k = b.dataset.k;
        if (k.startsWith('c:')) delete F.campos[k.slice(2)];
        else F[k] = F0()[k];
        aplicarF(t); foco(app.querySelector('.tp-fchip') || '#tp-fbtn'); anunciar('Filtro quitado');
    },
    'filtros': () => abrirFiltros(actual()),
    'modo': b => {
        const t = actual(); if (!t || modoDe(t) === b.dataset.m) return;
        ponerModo(t, b.dataset.m); cerrarPop(true); render();
        foco(`[data-act="modo"][data-m="${b.dataset.m}"]`);
        anunciar(b.dataset.m === 'planilla' ? 'Vista planilla' : 'Vista tablero');
    },
    'exportar': () => { const t = actual(); if (t && t.listo) exportarExcel(t); },
    'xl-orden': b => {
        const t = actual(), k = b.dataset.k, o = XO && XO.tid === t.id ? XO : null;
        // 1.er clic: A → Z · 2.º: Z → A · 3.º: vuelve al orden de las columnas.
        XO = !o || o.k !== k ? { tid: t.id, k, dir: k === 'editada' ? -1 : 1 } : o.dir === (k === 'editada' ? -1 : 1) ? { tid: t.id, k, dir: -o.dir } : null;
        pintarZona(); foco(`.tp-xl th [data-k="${k}"]`);
        anunciar(XO ? `Ordenado por «${b.textContent.trim()}» ${XO.dir > 0 ? 'ascendente' : 'descendente'}` : 'Orden de las columnas');
    },
    'xl-abrir': b => { const tr = b.closest('tr[data-id]'); if (tr) { activarCelda(tr.querySelector('td[data-k="titulo"]'), false); abrirTarjeta(+tr.dataset.id); } },
    'xl-limpiar': () => { const t = actual(), o = Fde(t).orden; busqueda = ''; const q = app.querySelector('#tp-q'); if (q) q.value = ''; PF(t).F = F0(); PF(t).F.orden = o; aplicarF(t); foco('#tp-q'); },
    'compartir': () => abrirCompartir(actual()),
    'sh-agregar': () => {
        const t = tablero(M.tid), sel = M.el.querySelector('#sh-uid'), id = +sel.value, rol = M.el.querySelector('[name="nuevoRol"]').value;
        if (!id) { sel.focus(); toast('Elige a quién agregar.'); return; }
        if (t.miembros.some(m => m.id === id)) return;
        aplicarAcceso(t, () => { if (t.visib === 'privado') t.visib = 'personas'; t.miembros.push({ id, rol }); }).then(ok => {
            if (ok) { anunciar(`${nombreDe(id)} agregado`); toast(`Compartido con ${nombreDe(id)}.`); }
        });
        foco(M.el.querySelector('#sh-uid') || M.el.querySelector('[data-act="cerrar"]'));
    },
    'sh-quitar': b => {
        const t = tablero(M.tid), id = +b.dataset.uid;
        aplicarAcceso(t, () => { t.miembros = t.miembros.filter(m => m.id !== id); }).then(ok => { if (ok) anunciar(`${nombreDe(id)} quitado`); });
        foco(M.el.querySelector('#sh-uid') || M.el.querySelector('[data-act="cerrar"]'));
    },
    'f-limpiar': () => { const t = tablero(M.tid), o = Fde(t).orden; PF(t).F = F0(); PF(t).F.orden = o; aplicarF(t); M.el.querySelector('.tp-md-body').innerHTML = filtrosHTML(t); M.el.querySelector('#f-count').textContent = totalTxt(t); anunciar('Filtros quitados'); },
    'vista': b => elegirVista(actual(), +b.dataset.v),
    'vista-nueva': () => modalVista(actual(), null),
    'vista-actualizar': () => { const t = actual(), v = vistaDe(t); if (!esMia(v)) return; v.F = copia(Fde(t)); pintarFiltrosUI(t);
        llamar(() => api.put(`/vistas/${v.id}`, { F: v.F })).catch(() => {}); foco(`#tp-vistas [data-v="${v.id}"]`); toast(`Vista «${v.nombre}» actualizada.`); },
    'vista-revertir': () => { const t = actual(); elegirVista(t, PF(t).vista); },
    'vista-menu': b => {
        const t = actual(), v = vistaDe(t); if (!v) return;
        abrirPop(b, [
            { head: v.nombre },
            { txt: 'Cambiar nombre', ic: I.edit, fn() { modalVista(t, v); } },
            esDueno(t) ? { txt: v.todos ? 'Dejar de mostrarla a todos' : 'Mostrar a todos los miembros', ic: I.users, fn() {
                v.todos = !v.todos; pintarFiltrosUI(t);
                llamar(() => api.put(`/vistas/${v.id}`, { todos: v.todos })).catch(() => {});
                toast(v.todos ? 'Ahora todos los miembros ven esta vista.' : 'La vista volvió a ser solo tuya.');
            } } : null,
            vistaSucia(t) ? { txt: 'Guardar los filtros de ahora', ic: I.check, fn() { ACT['vista-actualizar'](); } } : null,
            { sep: 1 },
            { txt: 'Eliminar vista', ic: I.trash, danger: 1, fn() {
                t.vistas = t.vistas.filter(x => x !== v); PF(t).vista = 0; guardarPref(t, ['vista']); pintarZona(); foco('#tp-vistas [data-v="0"]');
                llamar(() => api.del(`/vistas/${v.id}`)).then(() => toast(`Vista «${v.nombre}» eliminada.`, { undo() {
                    llamar(() => api.post(`/${t.id}/vistas`, { nombre: v.nombre, F: v.F })).then(d => {
                        const nv = { ...d.vista, F: normF(d.vista.F) }; t.vistas.push(nv);
                        if (v.todos) llamar(() => api.put(`/vistas/${nv.id}`, { todos: true })).then(() => { nv.todos = true; pintarFiltrosUI(t); }).catch(() => {});
                        elegirVista(t, nv.id);
                    }).catch(() => {});
                } })).catch(() => {});
            } },
        ].filter(Boolean), 'Opciones de la vista');
    },
    'flimpiar': () => { const t = actual(), o = Fde(t).orden; PF(t).F = F0(); PF(t).F.orden = o; aplicarF(t); foco('#tp-fbtn'); anunciar('Filtros quitados'); },
    'preset': () => {
        const t = actual();
        const nuevas = PRESETS.filter(([n]) => !t.columnas.some(o => norm(o.nombre) === norm(n))).map(([nombre, color]) => ({ nombre, color }));
        llamar(() => api.post(`/${t.id}/columnas`, { columnas: nuevas })).then(d => { aplicarTablero(d); focoTras = '#cn'; render(); anunciar('Se agregaron 3 columnas'); }).catch(() => {});
    },
    'a-ejemplo': () => { const t = actual(); t.etapa = 'ejemplo'; render(); abrirMolde(t); llamar(() => api.put(`/${t.id}/etapa`, { etapa: 'ejemplo' })).catch(() => {}); },
    'volver-cols': () => { const t = actual(); t.etapa = 'columnas'; focoTras = '#cn'; render(); llamar(() => api.put(`/${t.id}/etapa`, { etapa: 'columnas' })).catch(() => {}); },
    'col-up': b => moverCol(+b.dataset.col, -1, b.id),
    'col-down': b => moverCol(+b.dataset.col, 1, b.id),
    'col-edit': b => { const t = actual(); modalColumna(t, colDe(t, +b.dataset.col)); },
    'col-del': b => { const t = actual(); borrarColumna(t, colDe(t, +b.dataset.col)); },
    'col-nueva': () => modalColumna(actual(), null),
    'menu-col': b => menuCol(b),
    'menu-card': b => menuCard(b),
    'desplegar': b => { const t = actual(); PF(t).plegadas = PF(t).plegadas.filter(id => id !== +b.dataset.col); guardarPref(t, ['plegadas']); pintarZona(); },
    'molde': () => { if (DR && DR.dirty) { pedirGuardar(); return; } const t = DR ? tablero(DR.tid) : actual(); if (t) abrirMolde(t); },
    'dr-tab': b => { const enTab = b.getAttribute('role') === 'tab'; cambiarTab(b.dataset.tab); if (!enTab) foco('#tab-' + b.dataset.tab); },
    'asignarme': () => { const t = tablero(DR.tid); setAsignado(t, t.tarjetas.find(c => c.id === DR.cid), S.yo); foco('#dr-asig'); },
    'seg-quitar': () => { const t = tablero(DR.tid); setSeguimiento(t, t.tarjetas.find(c => c.id === DR.cid), null); const i = DR.el.querySelector('#dr-seg'); i.value = ''; i.focus(); },
    'datos-guardar': () => FORMS.datos(),
    'datos-descartar': () => { DR.dirty = false; pintarDrawer('todo'); foco('#d-tit'); anunciar('Cambios descartados'); },
    'tarjeta-eliminar': () => eliminarTarjeta(),
    'salir-descartar': () => { cerrarModal(true); if (DR) { DR.dirty = false; cerrarDrawer(); } },
    'tarjeta-nueva': b => { const t = actual(); if (t && t.listo) modalTarjeta(t, b.dataset.col ? +b.dataset.col : t.columnas[0].id); },
    'cerrar': () => { if (M) cerrarModal(); else if (DR) cerrarDrawer(); },
    'ask-no': () => { const f = M.el.querySelector('.tp-md-foot'); f.classList.remove('is-asking'); foco(M.el.querySelector('.tp-md-body input, .tp-md-body select')); },
    'ask-si': () => cerrarModal(true),
    'dr-menu': b => menuDrawer(b),
    'nota-del': b => {
        const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid), nid0 = +b.dataset.nid, cid = x.id;
        const ponerNotas = d => { const y = ponerTarjeta(t, d.tarjeta); y.notas = d.notas; y.hist = d.hist; if (DR && DR.cid === cid) pintarDrawer('notas'); pintarZona(); };
        x.notas = (x.notas || []).filter(o => o.id !== nid0); x.nNotas = Math.max(0, x.nNotas - 1); pintarDrawer('notas'); pintarZona(); foco('#nt');
        llamar(() => api.del(`/notas/${nid0}`)).then(d => { ponerNotas(d); toast('Nota borrada.', { undo() { llamar(() => api.post(`/notas/${nid0}/restaurar`)).then(ponerNotas).catch(() => {}); } }); }).catch(() => {});
    },
    'copiar-ej': () => {
        const t = tablero(M.tid), ej = t.tarjetas.find(x => x.id === t.molde); if (!ej) return;
        M.el.querySelector('#n-props').innerHTML = t.campos.map(f => campoNuevo(f, { datos: ej.datos }, 'n')).join('');
        M.dirty = true; prevNueva(); anunciar('Se copiaron los datos de la tarjeta de ejemplo'); toast('Se copiaron los datos del ejemplo. Cámbialos a gusto.');
    },
    'nv-mia': () => { const s = M && M.el.querySelector('#n-asig'); if (!s) return; s.value = String(S.yo); M.dirty = true; prevNueva(); foco(s); },
    'nv-seg': b => {
        const i = M && M.el.querySelector('#n-seg'); if (!i) return;
        i.value = b.dataset.d === '' ? '' : isoMas(+b.dataset.d); M.dirty = true; prevNueva();
        foco(b.dataset.d === '' ? i : b);
    },
    'nv-ir': b => { const el = M && M.el.querySelector(b.dataset.to); if (el) { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); foco(el); } },
    'file-ver': b => { const { t, x, a } = archivoDe(b); if (a) abrirVisor(t, x, a); },
    'file-mover': b => { const { t, x, a } = archivoDe(b); if (a) modalMoverArchivo(t, x, a); },
    'vw-cerrar': () => cerrarVisor(),
    'vw-ant': () => moverVisor(-1),
    'vw-sig': () => moverVisor(1),
    'vw-bajar': () => { if (VW) abrirArchivo(VW.lista[VW.i], true); },
    'vw-mover': () => {
        if (!VW) return;
        const t = tablero(VW.tid), x = t && t.tarjetas.find(c => c.id === VW.cid), a = VW.lista[VW.i];
        if (x && a) modalMoverArchivo(t, x, a);
    },
    'file-bajar': b => { const { a } = archivoDe(b); if (a) abrirArchivo(a, true); },
    'file-del': b => {
        const { t, x, a } = archivoDe(b); if (!a) return;
        const cid = x.id, poner = d => { ponerTarjeta(t, d.tarjeta); if (DR && DR.cid === cid) pintarDrawer('archivos'); pintarZona(); };
        x.archivos = x.archivos.filter(o => o !== a); hist(x, 'arch', `Quitó «${a.nombre}»`); tocar(t, x);
        pintarDrawer('archivos'); pintarZona(); foco('#fa');
        llamar(() => api.del(`/archivos/${a.id}`)).then(d => { poner(d); toast(`Archivo «${a.nombre}» quitado.`, { undo() { llamar(() => api.post(`/archivos/${a.id}/restaurar`)).then(poner).catch(() => {}); } }); }).catch(() => {});
    },
    // Molde
    'campo-add': b => {
        const tipo = (b && b.dataset && TIPOS.some(([k]) => k === b.dataset.tipo)) ? b.dataset.tipo : 'texto';
        const f = { id: nid(), nombre: '', tipo, opciones: [], enTarjeta: tipo !== 'largo' };
        if (tipo === 'lista' || tipo === 'multi') f.opciones = [{ id: nid(), nombre: 'Opción 1', color: 'blue' }, { id: nid(), nombre: 'Opción 2', color: 'green' }];
        MD.campos.push(f); M.dirty = true; pintarCampos('fn-' + f.id);
        const li = M.el.querySelector(`.tp-fld[data-fid="${f.id}"]`); if (li) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        anunciar(`Campo de tipo ${TIPO_CORTO[tipo]} agregado: escribe su nombre`);
    },
    'campo-up': b => moverCampo(b, -1),
    'campo-down': b => moverCampo(b, 1),
    'campo-del': b => {
        const f = campoDe(b);
        if (MD.orig[f.id]) f._borrar = true; else { MD.campos = MD.campos.filter(c => c !== f); delete MD.valores[f.id]; }
        M.dirty = true; pintarCampos(MD.orig[f.id] ? 'fz-' + f.id : 'm-add'); anunciar(`Campo «${f.nombre || 'sin nombre'}» quitado`);
    },
    'campo-undel': b => { const f = campoDe(b); delete f._borrar; pintarCampos('fn-' + f.id); },
    'opt-add': b => { const f = campoDe(b), o = { id: nid(), nombre: '', color: colorLibre(null, f.opciones) }; f.opciones.push(o); M.dirty = true; pintarCampos('o-' + o.id); },
    'opt-del': b => {
        const f = campoDe(b), oid = +b.closest('[data-oid]').dataset.oid;
        f.opciones = f.opciones.filter(o => o.id !== oid);
        if (MD.valores[f.id] === oid) delete MD.valores[f.id];
        if (Array.isArray(MD.valores[f.id])) MD.valores[f.id] = MD.valores[f.id].filter(id => id !== oid);
        M.dirty = true; pintarCampos('oa-' + f.id);
    },
    'opt-color': b => {
        const f = campoDe(b), o = f.opciones.find(o => o.id === +b.closest('[data-oid]').dataset.oid);
        o.color = COLORES[(COLORES.findIndex(([k]) => k === o.color) + 1) % COLORES.length][0];
        M.dirty = true; pintarCampos(b.id); anunciar(`Color: ${COLOR_NOMBRE[o.color]}`);
    },
};

// Permiso que pide cada acción (en hyf-api se comprueba en el servidor).
const REQ = {
    'preset': 'arma', 'a-ejemplo': 'arma', 'volver-cols': 'arma', 'col-up': 'arma', 'col-down': 'arma', 'col-edit': 'arma', 'col-del': 'arma',
    'col-nueva': 'arma', 'menu-col': 'arma', 'molde': 'arma', 'compartir': 'dueno', 'sh-agregar': 'dueno', 'sh-quitar': 'dueno',
    'tarjeta-nueva': 'editar', 'asignarme': 'editar', 'seg-quitar': 'editar', 'datos-descartar': 'editar', 'datos-guardar': 'editar', 'tarjeta-eliminar': 'editar',
    'file-del': 'editar', 'file-mover': 'editar', 'vw-mover': 'editar', 'copiar-ej': 'editar', 'nota-del': 'editar', 'menu-card': 'editar',
};
const REQF = { compartir: 'dueno', 'compartir-asignar': 'dueno', traspasar: 'dueno', 'col-add': 'arma', col: 'arma', 'col-del': 'arma', molde: 'arma', tarjeta: 'editar', datos: 'editar', nota: 'editar', 'salir-datos': 'editar', 'mover-archivo': 'editar' };
function permitido(nivel, el) {
    if (!nivel) return true;
    const t = DR && DR.el.contains(el) ? tablero(DR.tid) : M && M.tid && M.el.contains(el) ? tablero(M.tid) : actual();
    return nivel === 'arma' ? puedeArmar(t) : nivel === 'dueno' ? esDueno(t) : puedeEditar(t);
}

// ── Formularios ──
const FORMS = {
    async tablero(f) {
        const id = +f.elements.id.value || 0, el = f.elements.nombre, nombre = limpio(el.value), desc = f.elements.desc.value.trim();
        if (!nombre) { errCampo(el, 'Escribe un nombre para el tablero.'); el.focus(); return; }
        if (misTableros().some(t => t.id !== id && norm(t.nombre) === norm(nombre)) || (S.t && S.t.id !== id && S.t.rol === 'dueno' && norm(S.t.nombre) === norm(nombre))) { errCampo(el, 'Ya tienes un tablero con ese nombre.'); el.focus(); return; }
        const boton = f.querySelector('button[type=submit]'); boton.disabled = true;
        let d;
        try { d = id ? await api.put(`/${id}`, { nombre, desc }) : await api.post('', { nombre, desc }); }
        catch (e) { boton.disabled = false; if (!errApi(e, el)) toast(msgErr(e)); return; }
        cerrarModal(true);
        if (id) {
            if (S.t && S.t.id === id) aplicarTablero(d);
            const it = (S.lista || []).find(x => x.id === id); if (it) { it.nombre = d.nombre; it.desc = d.desc; }
            render(); toast('Tablero actualizado.');
            return;
        }
        S.t = adaptar(d); focoTras = '#cn'; busqueda = '';
        opciones.navegar(d.id);
        toast('Tablero creado. Ahora crea las columnas.');
    },
    async 'col-add'(f) {
        const t = actual(), c = agregarColumna(t, f.elements.nombre.value, f.elements.color.value, f.elements.nombre);
        if (!c) return;
        try { aplicarTablero(await api.post(`/${t.id}/columnas`, c)); }
        catch (e) { if (!errApi(e, f.elements.nombre)) toast(msgErr(e)); return; }
        focoTras = '#cn'; render(); anunciar(`Columna «${c.nombre}» agregada`);
    },
    async col(f) {
        const t = tablero(M.tid), id = +f.elements.id.value || 0, el = f.elements.nombre, color = f.elements.color.value;
        if (!id) {
            const c = agregarColumna(t, el.value, color, el); if (!c) return;
            try { aplicarTablero(await api.post(`/${t.id}/columnas`, c)); }
            catch (e) { if (!errApi(e, el)) toast(msgErr(e)); return; }
            cerrarModal(true);
            if (etapaDe(t) === 'columnas') render(); else { pintarZona(); const b = app.querySelector('.tp-board'); if (b) b.scrollTo({ left: b.scrollWidth, behavior: 'smooth' }); }
            toast(`Columna «${c.nombre}» agregada.`);
            return;
        }
        const c = colDe(t, id), v = limpio(el.value);
        if (!v) { errCampo(el, 'Escribe un nombre para la columna.'); el.focus(); return; }
        if (t.columnas.some(o => o.id !== id && norm(o.nombre) === norm(v))) { errCampo(el, 'Ya hay una columna con ese nombre.'); el.focus(); return; }
        try { aplicarTablero(await api.put(`/${t.id}/columnas/${id}`, { nombre: v, color: color || c.color })); }
        catch (e) { if (!errApi(e, el)) toast(msgErr(e)); return; }
        cerrarModal(true);
        if (etapaDe(t) === 'columnas') render(); else pintarZona();
        if (DR) pintarDrawer();
        toast('Columna actualizada.');
    },
    async 'col-del'(f) {
        const t = tablero(M.tid), c = colDe(t, +f.elements.id.value), que = f.elements.que.value;
        const q = que === 'mover' ? `?mover_a=${+f.elements.dest.value}` : '';
        let d;
        try { d = await api.del(`/${t.id}/columnas/${c.id}${q}`); } catch (e) { toast(msgErr(e)); return; }
        if (DR && que !== 'mover' && tarjetasCol(t, c.id).some(x => x.id === DR.cid)) cerrarDrawer(true);
        aplicarTablero(d); cerrarModal(true); render(); if (DR) pintarDrawer();
        toast(`Columna «${c.nombre}» eliminada.`);
    },
    async tarjeta(f) {
        const t = tablero(M.tid); limpiarErrores(f);
        const el = f.elements.titulo, titulo = limpio(el.value);
        const { datos, primero } = leerDatos(t, f);
        if (!titulo) errCampo(el, 'Ponle un título a la tarjeta.');
        const malo = !titulo ? el : primero;
        if (malo) { f.querySelector('#md-err').textContent = 'Revisa lo marcado en rojo.'; malo.focus(); return; }
        const seg = /^\d{4}-\d{2}-\d{2}$/.test(f.elements.seguimiento.value) ? f.elements.seguimiento.value : null;
        const boton = f.querySelector('button[type=submit]'); boton.disabled = true;
        let d;
        try { d = await api.post(`/${t.id}/tarjetas`, { titulo, col: +f.elements.col.value, datos, asignado: f.elements.asignado.value ? +f.elements.asignado.value : null, seguimiento: seg }); }
        catch (e) { boton.disabled = false; f.querySelector('#md-err').textContent = msgErr(e); return; }
        const x = ponerTarjeta(t, d.tarjeta);
        tocar(t); cerrarModal(true); pintarZona();
        requestAnimationFrame(() => flash(x.id));
        toast(`Tarjeta «${titulo}» creada.`);
    },
    molde: guardarMolde,
    async vista(f) {
        const t = tablero(M.tid), id = +f.elements.id.value || 0, el = f.elements.nombre, nombre = limpio(el.value);
        t.vistas = t.vistas || [];
        if (!nombre) { errCampo(el, 'Escribe un nombre para la vista.'); el.focus(); return; }
        if (norm(nombre) === 'todas' || vistasVisibles(t).some(v => v.id !== id && norm(v.nombre) === norm(nombre))) { errCampo(el, 'Ya hay una vista con ese nombre.'); el.focus(); return; }
        try {
            if (id) { const v = t.vistas.find(v => v.id === id); if (!esMia(v)) return; await api.put(`/vistas/${id}`, { nombre }); v.nombre = nombre; }
            else { const d = await api.post(`/${t.id}/vistas`, { nombre, F: copia(Fde(t)) }); t.vistas.push({ ...d.vista, F: normF(d.vista.F) }); PF(t).vista = d.vista.id; guardarPref(t, ['vista']); }
        } catch (e) { if (!errApi(e, el)) toast(msgErr(e)); return; }
        cerrarModal(true); pintarZona();
        foco(`#tp-vistas [data-v="${id || PF(t).vista}"]`); toast(id ? 'Vista renombrada.' : `Vista «${nombre}» guardada.`);
    },
    async nota(f) {
        const t = tablero(DR.tid), x = t.tarjetas.find(c => c.id === DR.cid), el = f.elements.txt, v = el.value.trim();
        if (!v) { errCampo(el, 'Escribe algo antes de guardar.'); el.focus(); return; }
        const boton = f.querySelector('button[type=submit]'); boton.disabled = true;
        let d;
        try { d = await api.post(`/tarjetas/${x.id}/notas`, { texto: v }); } catch (e) { boton.disabled = false; errCampo(el, msgErr(e)); return; }
        const y = ponerTarjeta(t, d.tarjeta); y.notas = d.notas; y.hist = d.hist;
        if (!DR || DR.cid !== x.id) return;
        pintarDrawer('notas'); pintarZona(); foco('#nt'); anunciar('Nota agregada');
    },
    confirm() { const fn = M.onOk; cerrarModal(true); fn(); },
    compartir() { cerrarModal(true); },
    'compartir-asignar'(f) {
        const t = tablero(M.tid), id = +f.elements.uid.value;
        cerrarModal(true);
        if (DR) { const x = t.tarjetas.find(c => c.id === DR.cid); setAsignado(t, x, id, true); toast(`Compartido con ${nombreDe(id)} y asignada.`); }
    },
    async traspasar(f) {
        const tid = M.tid, id = +f.elements.uid.value, nombre = (S.t && S.t.id === tid ? S.t : (S.lista || []).find(x => x.id === tid) || {}).nombre;
        try { await api.post(`/${tid}/traspasar`, { usuario_id: id }); } catch (e) { f.querySelector('#md-err').textContent = msgErr(e); return; }
        cerrarModal(true); cerrarDrawer(true); toast(`Ahora «${nombre}» es de ${nombreDe(id)}.`);
        await recargar(); render();
    },
    datos() { if (guardarDatos()) foco('#tab-datos'); },
    async 'cols-notion'(f) {
        if (!M.cols.some(c => !c.oculta)) { f.querySelector('#cn-e').textContent = 'Tiene que quedar al menos una columna a la vista.'; return; }
        const t = tablero(M.tid), boton = f.querySelector('button[type=submit]'); boton.disabled = true;
        if (!(await guardarColsNotion(t, M.cols, f))) { boton.disabled = false; return; }
        cerrarModal(true); render(); toast('Columnas guardadas: el tablero queda como en Notion.');
    },
    async notion(f) {
        const r = f.querySelector('[name="ds"]:checked');
        if (!r) { f.querySelector('#md-err').textContent = 'Elige un tablero de Notion.'; return; }
        const b = (M.lista || []).find(x => x.ds === r.value); if (!b) return;
        const sv = f.querySelector(`[name="vista-${r.value}"]`), vista = sv ? sv.value : b.vistas[0].id;
        const boton = f.querySelector('button[type=submit]');
        boton.disabled = true; boton.textContent = 'Trayendo desde Notion…'; f.querySelector('#md-err').textContent = '';
        let d;
        try { d = await api.post('/notion', { ds: b.ds, vista }); }
        catch (e) { boton.disabled = false; boton.textContent = 'Traer el tablero'; f.querySelector('#md-err').textContent = msgErr(e); return; }
        cerrarModal(true);
        S.t = adaptar(d); busqueda = '';
        opciones.navegar(d.id);
        toast(`«${d.nombre}» llegó desde Notion: ${plural(d.tarjetas.length, 'tarjeta', 'tarjetas')}. Los comentarios aparecen en un par de minutos.`);
        setTimeout(() => { if (S.t && S.t.id === d.id && !M) modalColsNotion(S.t, true); }, 600);
    },
    async 'mover-archivo'(f) {
        const sel = f.querySelector('[name="dest"]:checked');
        if (!sel) { const e = f.querySelector('#mv-e'); if (e) e.textContent = 'Elige la tarjeta a la que pasa el archivo.'; foco(f.querySelector('#mv-q')); return; }
        const { tid, cid, aid, nombre } = M, dest = +sel.value, boton = f.querySelector('button[type=submit]');
        const titDest = sel.closest('label').textContent.trim();
        boton.disabled = true;
        let d;
        try { d = await api.post(`/archivos/${aid}/mover`, { tarjeta_id: dest }); }
        catch (e) { boton.disabled = false; f.querySelector('#md-err').textContent = msgErr(e); return; }
        cerrarModal(true);
        if (VW && VW.lista.some(a => a.id === aid)) cerrarVisor(true);
        const t = tablero(tid);
        const poner = (...cards) => {
            if (!t || S.t !== t) return;
            // Solo las tarjetas que son de este tablero (el destino puede ser de otro).
            cards.filter(Boolean).forEach(c => { if (t.tarjetas.some(y => y.id === c.id)) ponerTarjeta(t, c); });
            if (DR) { cargarDetalle(t, DR.cid); pintarDrawer('archivos'); }
            pintarZona();
        };
        poner(d.tarjeta, d.destino);
        toast(`«${nombre}» pasó a «${titDest}».`, { undo() {
            api.post(`/archivos/${aid}/mover`, { tarjeta_id: cid }).then(r => poner(r.tarjeta, r.destino)).catch(e => { toast(msgErr(e)); recargar(); });
        } });
    },
    'salir-datos'() { cerrarModal(true); if (DR && guardarDatos()) cerrarDrawer(); },
};

// ── Eventos ── (todos con on(): destruir() los quita)
const quitar = [];
const on = (el, ev, fn, o) => { el.addEventListener(ev, fn, o); quitar.push(() => el.removeEventListener(ev, fn, o)); };
let finArrastre = 0;
on(raiz, 'click', e => {
    const nav = e.target.closest('a[data-nav]');
    if (nav && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) { e.preventDefault(); opciones.navegar(nav.dataset.nav === 'admin' ? 'admin' : +nav.dataset.nav); return; }
    // El clic que cierra un arrastre (de tarjeta o de columna) no abre ni despliega nada.
    if (Date.now() - finArrastre < 250 && e.target.closest('.tp-board')) return;
    const b = e.target.closest('[data-act]');
    if (P && !e.target.closest('.tp-pop') && b !== P.anchor) cerrarPop(true);
    if (b && !b.disabled && ACT[b.dataset.act]) {
        e.preventDefault();
        if (!permitido(REQ[b.dataset.act], b)) { toast('No tienes permiso para hacer esto en este tablero.'); return; }
        ACT[b.dataset.act](b, e); return;
    }
    const cd = e.target.closest('.tp-board .tp-cd');
    if (cd && !e.target.closest('a')) { abrirTarjeta(+cd.dataset.id); return; }
    // Planilla: clic en una celda = editarla (o abrir la tarjeta si no se puede editar).
    const td = e.target.closest('.tp-xl td[data-k]');
    if (td && !e.target.closest('a, label.tp-xl-chk')) {
        if (td.dataset.ed) editarCelda(td);
        else { activarCelda(td, false); const x = filaDe(td); if (x) abrirTarjeta(x.id); }
    }
});
on(raiz, 'submit', e => {
    const f = e.target.closest('[data-form]'); if (!f) return;
    e.preventDefault();
    const nivel = f.dataset.form === 'tablero' ? (f.elements.id.value ? 'dueno' : null) : REQF[f.dataset.form];
    if (!permitido(nivel, f)) { toast('No tienes permiso para hacer esto en este tablero.'); return; }
    if (FORMS[f.dataset.form]) FORMS[f.dataset.form](f);
});
on(raiz, 'input', e => {
    const el = e.target;
    if (XE && XE.el.contains(el)) {
        el.removeAttribute('aria-invalid'); const p = XE.el.querySelector('.tp-xl-ed-err'); if (p) p.textContent = '';
        if (el.tagName === 'TEXTAREA') autoAlto(el);
        return;
    }
    if (el.id === 'tp-q') { busqueda = el.value; pintarZona(); return; }
    if (DR && el.closest('#pn-datos')) { marcarDatos(); if (el.getAttribute('aria-invalid')) { el.removeAttribute('aria-invalid'); const r = el.closest('.tp-f'), e2 = r && r.querySelector('.tp-err'); if (e2) e2.textContent = ''; } return; }
    if (M && M.el.contains(el)) {
        if (M.kind === 'mover') { if (el.name === 'q') { M.q = el.value; pintarMover(); } return; }
        if (M.kind === 'tarjeta') prevNueva();
        if (M.kind === 'molde') { moldeInput(e); return; }
        if (M.kind === 'filtros') { if (el.type === 'number' || el.type === 'date') filtrosInput(el); return; }
        if (M.el.querySelector('.tp-ask')) M.dirty = true;
        if (el.name === 'desc') { const c = M.el.querySelector('#b-desc-n'); if (c) c.textContent = `${el.value.length}/200`; }
    }
    if (el.getAttribute('aria-invalid')) {
        el.removeAttribute('aria-invalid');
        const p = document.getElementById(el.id + '-e') || (el.closest('.tp-prop') && el.closest('.tp-prop').querySelector('.tp-err'));
        if (p) p.textContent = '';
    }
});
on(raiz, 'change', e => {
    const el = e.target;
    if (XE && XE.el.contains(el)) { if (el.tagName === 'SELECT') guardarCelda(); return; }
    if (el.dataset && el.dataset.xchk) { casillaXL(el); return; }
    if (M && M.el.contains(el)) {
        if (M.kind === 'cols-notion') { if (el.dataset.cn === 'ver') { const it = M.cols.find(c => c.id === +el.closest('[data-cid]').dataset.cid); it.oculta = !el.checked; M.dirty = true; pintarColsNotion(); const e2 = M.el.querySelector(`[data-cid="${it.id}"] [data-cn]`); if (e2) e2.focus(); } return; }
        if (M.kind === 'mover') { if (el.name === 'tab') { M.tab = +el.value; pintarMover(); } else if (el.name === 'dest') { const p = M.el.querySelector('#mv-e'); if (p) p.textContent = ''; } return; }
        if (M.kind === 'tarjeta') prevNueva();
        if (M.kind === 'compartir') { if (el.name !== 'nuevo' && el.name !== 'nuevoRol') compartirInput(el); return; } if (M.kind === 'filtros') { filtrosInput(el); return; } if (M.kind === 'molde') moldeInput(e); else if (M.el.querySelector('.tp-ask')) M.dirty = true; return; }
    if (DR && el.closest('#pn-datos')) { marcarDatos(); return; }
    if (DR && DR.el.contains(el) && !el.closest('form')) drawerChange(el);
});
function capaArriba() { return P ? P.el : M ? M.el : VW ? VW.el : DR ? DR.el : null; }
on(document, 'keydown', e => {
    if (SD) {
        const its = [...SD.el.querySelectorAll('.tp-dd-it:not(:disabled)')], i = its.indexOf(document.activeElement);
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cerrarSel(true); return; }
        if (e.key === 'Tab') cerrarSel(true);   // sigue el Tab normal desde el select
        else if (SD.el.contains(e.target)) {
            const enBusca = e.target.tagName === 'INPUT';
            if (/^(ArrowDown|ArrowUp|Home|End)$/.test(e.key)) {
                e.preventDefault(); if (!its.length) return;
                const j = e.key === 'Home' ? 0 : e.key === 'End' ? its.length - 1 : i < 0 ? (e.key === 'ArrowDown' ? 0 : its.length - 1) : (i + (e.key === 'ArrowDown' ? 1 : -1) + its.length) % its.length;
                its[j].focus(); its[j].scrollIntoView({ block: 'nearest' });
            } else if (e.key === 'Enter' && enBusca) { e.preventDefault(); if (its[0]) elegirSel(SD.items[+its[0].dataset.i].v); }
            else if (!enBusca && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                // Escribir una letra salta a la opción que empieza así.
                const k = norm(e.key), orden = its.slice(i + 1).concat(its.slice(0, i + 1));
                const it = orden.find(b => norm(b.textContent).startsWith(k)); if (it) { e.preventDefault(); it.focus(); }
            }
            return;
        }
    } else if (mejorable(e.target) && (e.key === 'Enter' || e.key === ' ' || e.key === 'F4' || (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')))) {
        e.preventDefault(); abrirSel(e.target); return;
    }
    // Celda de la planilla en edición: Enter guarda (en texto largo, Ctrl + Enter), Tab guarda y pasa a la siguiente, Esc cancela.
    if (XE && XE.el.contains(e.target)) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cerrarCelda(true); return; }
        if (e.key === 'Enter' && e.target.tagName !== 'BUTTON' && (e.target.tagName !== 'TEXTAREA' || e.ctrlKey || e.metaKey)) { e.preventDefault(); guardarCelda(0, XE.f && (XE.f.tipo === 'largo' || XE.f.tipo === 'multi') ? 0 : 1); return; }
        if (e.key === 'Tab' && !(XE.el.classList.contains('is-pop') && XE.el.querySelectorAll('input, textarea, button').length > 1 && !e.target.matches('[data-xe="ok"]'))) { e.preventDefault(); guardarCelda(e.shiftKey ? -1 : 1, 0); return; }
        return;
    }
    if (e.key === 'Escape') {
        if (D && D.on) { cancelarArrastre(); return; }
        if (P) { cerrarPop(); return; }
        if (M) { cerrarModal(); return; }
        if (VW) { cerrarVisor(); return; }
        if (DR) { cerrarDrawer(); return; }
    }
    if (VW && !M && !P && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !/^(INPUT|TEXTAREA|SELECT|VIDEO|AUDIO)$/.test(e.target.tagName)) {
        e.preventDefault(); moverVisor(e.key === 'ArrowRight' ? 1 : -1); return;
    }
    if (P && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End')) {
        e.preventDefault();
        const its = [...P.el.querySelectorAll('.tp-pop-item:not(:disabled)')], i = its.indexOf(document.activeElement);
        const j = e.key === 'Home' ? 0 : e.key === 'End' ? its.length - 1 : (i + (e.key === 'ArrowDown' ? 1 : -1) + its.length) % its.length;
        if (its[j]) its[j].focus(); return;
    }
    if (e.key === 'Tab') {
        if (P) { cerrarPop(); return; }
        const capa = capaArriba(); if (!capa) return;
        const fs = [...capa.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(x => x.getClientRects().length);
        if (!fs.length) return;
        const a = fs[0], z = fs[fs.length - 1];
        if (!capa.contains(document.activeElement) || document.activeElement.classList.contains('tp-dr-card')) { if (e.shiftKey) { e.preventDefault(); z.focus(); } else if (!capa.contains(document.activeElement)) { e.preventDefault(); a.focus(); } return; }
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
        return;
    }
    const el = e.target;
    if (!raiz.contains(el) && el !== document.body) return;
    if (DR && el.getAttribute && el.getAttribute('role') === 'tab' && /^(ArrowLeft|ArrowRight|Home|End)$/.test(e.key)) {
        e.preventDefault();
        const ks = TABS.map(t => t[0]).filter(k => DR.el.querySelector('#tab-' + k)), i = ks.indexOf(el.dataset.tab);
        const j = e.key === 'Home' ? 0 : e.key === 'End' ? ks.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + ks.length) % ks.length;
        cambiarTab(ks[j]); DR.el.querySelector('#tab-' + ks[j]).focus(); return;
    }
    if (e.key === 'Enter' && DR && el.closest && el.closest('#pn-datos') && el.tagName === 'INPUT' && el.type !== 'checkbox') { e.preventDefault(); if (puedeEditar(tablero(DR.tid))) FORMS.datos(); return; }
    if (e.key === 'Enter') {
        if (el.classList && el.classList.contains('tp-dr-title')) { e.preventDefault(); el.blur(); return; }
        if (el.id === 'nt' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); el.form.requestSubmit(); return; }
        if (M && M.kind === 'molde' && el.tagName === 'INPUT' && el.type !== 'checkbox') {
            e.preventDefault();
            if (el.dataset.ok === 'nombre') ACT['opt-add'](el);
            return;
        }
    }
    const tdx = el.closest && el.closest('.tp-xl td[data-k]');
    if (tdx && tdx === el && !M && !DR && !VW) { teclaCelda(tdx, e); return; }
    const escribiendo = /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
    if (e.key === '/' && !escribiendo && !M && !DR) { const q = document.getElementById('tp-q'); if (q) { e.preventDefault(); q.focus(); } return; }
    const cd = el.closest && el.closest('.tp-board .tp-cd');
    if (cd && cd === el && !M && !DR) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrirTarjeta(+cd.dataset.id); return; }
        if (e.shiftKey && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
            e.preventDefault();
            if (!puedeEditar(actual())) { toast('Solo puedes ver este tablero.'); return; }
            const t = actual(), id = +cd.dataset.id, x = t.tarjetas.find(c => c.id === id);
            const i = t.columnas.findIndex(c => c.id === x.col) + (e.key === 'ArrowRight' ? 1 : -1), c = t.columnas[i];
            if (!c) return;
            if (moverTarjeta(t, id, c.id, null)) { guardarMov(t, id); pintarZona(); }
            const nuevo = app.querySelector(`.tp-cd[data-id="${id}"]`);
            if (nuevo) { nuevo.focus(); flash(id); }
            anunciar(`Movida a «${c.nombre}»`);
        }
    }
});
on(window, 'resize', () => cerrarPop(true));
// «Columnas como en Notion»: arrastrar filas (y flechas ↑ ↓ sobre el agarre).
on(capas, 'pointerdown', e => {
    if (e.button !== 0 || !M || M.kind !== 'cols-notion') return;
    const li = e.target.closest('.tp-cn'); if (!li) return;
    const grip = e.target.closest('.tp-cn-grip');
    if (!grip && (e.pointerType !== 'mouse' || e.target.closest('label, input, button'))) return;
    e.preventDefault(); if (grip) grip.focus({ preventScroll: true });
    DN = { li, cid: +li.dataset.cid, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, on: false };
});
on(window, 'pointermove', e => {
    if (!DN) return;
    DN.x = e.clientX; DN.y = e.clientY;
    if (!DN.on) { if (Math.hypot(DN.x - DN.x0, DN.y - DN.y0) < 5) return; empezarDN(); }
    e.preventDefault(); seguirDN();
}, { passive: false });
on(window, 'pointerup', () => { if (!DN) return; if (DN.on) soltarDN(); DN = null; });
on(window, 'pointercancel', () => { if (!DN) return; if (DN.on) { DN.on = true; soltarDN(); } DN = null; });
on(capas, 'keydown', e => {
    const g = e.target.closest && e.target.closest('.tp-cn-grip'); if (!g || !M || M.kind !== 'cols-notion') return;
    const d = { ArrowUp: -1, ArrowDown: 1 }[e.key]; if (!d) return;
    e.preventDefault(); moverColNotion(+g.closest('.tp-cn').dataset.cid, d);
});
on(window, 'resize', () => cerrarSel(false));
// Si se re-dibuja lo que había debajo de un desplegable abierto (refresco, otra acción), se cierra.
const obsSel = new MutationObserver(revisarSel);
obsSel.observe(raiz, { childList: true, subtree: true });
quitar.push(() => obsSel.disconnect());
// Desplegables propios: se abren con el clic (en vez del nativo) y con Enter / Espacio / Alt+↓.
on(raiz, 'mousedown', e => {
    const s = e.target.closest && e.target.closest('select');
    if (e.button !== 0 || !mejorable(s)) return;
    e.preventDefault(); s.focus({ preventScroll: true }); abrirSel(s);
}, true);
on(document, 'mousedown', e => { if (SD && !SD.el.contains(e.target) && e.target !== SD.sel) cerrarSel(false); }, true);
// Clic fuera de la celda en edición = guardar (sin re-dibujar la planilla, así el clic sigue en la otra celda).
on(document, 'mousedown', e => { if (XE && !XE.el.contains(e.target) && !(SD && SD.el.contains(e.target))) guardarCelda(0, 0, false, true); }, true);
on(window, 'resize', () => { if (XE && !guardarCelda(0, 0, false, true)) cerrarCelda(false); });
on(window, 'resize', () => barraH());
// Al aceptar las cookies el aviso desaparece: se libera su alto.
on(document, 'click', e => { if (e.target.closest && e.target.closest('.cookie-footer')) setTimeout(medirCookies, 350); }, true);
// Tablero ↔ barra de abajo: se mueven juntos (scroll no burbujea: se escucha en captura).
let syncH = false;
on(app, 'scroll', e => {
    const el = e.target; if (syncH || !el.classList) return;
    const otro = el.classList.contains('tp-board') ? app.querySelector('.tp-hbar') : el.classList.contains('tp-hbar') ? app.querySelector('.tp-board') : null;
    if (!otro) return;
    syncH = true; otro.scrollLeft = el.scrollLeft; requestAnimationFrame(() => { syncH = false; });
}, true);
on(window, 'beforeunload', e => { if (DR && DR.dirty) { e.preventDefault(); e.returnValue = ''; } });
on(document, 'scroll', e => {
    if (P && !P.el.contains(e.target)) cerrarPop(true);
    if (SD && !SD.el.contains(e.target) && Date.now() - SD.t0 > 250) cerrarSel(false);
    if (XE && !XE.el.contains(e.target) && !(SD && SD.el.contains(e.target)) && !guardarCelda(0, 0, false, true)) { cerrarCelda(false); toast('Se descartó el cambio de la celda: el valor no era válido.'); }
}, true);
// Cada 30 s se trae el tablero para ver lo que cambiaron los demás (si no se está editando nada).
const poll = setInterval(async () => {
    const t = actual();
    if (!t || M || D || DC || XE || SD || (DR && DR.dirty) || document.visibilityState !== 'visible' || prefTm && Object.keys(prefPend).length) return;
    const ref = { rol: t.rol, nombre: t.nombre, desc: t.desc, etapa: t.etapa, listo: t.listo };
    let d; try { d = await api.get(`/${t.id}`); } catch (e) { if (e && (e.status === 404 || e.status === 403)) { S.t = null; cerrarTodo(); render(); } return; }
    if (actual() !== t || M || D || DC || XE || SD || (DR && DR.dirty)) return;
    aplicarTablero(d);
    if (ref.rol !== t.rol || ref.nombre !== t.nombre || ref.desc !== t.desc || ref.etapa !== t.etapa || ref.listo !== t.listo) { if (DR) cerrarDrawer(true); render(); return; }
    if (etapaDe(t) !== 'columnas') pintarZona();
    if (DR) { if (t.tarjetas.some(x => x.id === DR.cid)) pintarDrawer(); else cerrarDrawer(true); }
}, 30000);

// ── Arrastrar y soltar (mouse; táctil con pulsación larga) ──
let D = null;
on(app, 'pointerdown', e => {
    if (e.button !== 0) return;
    const cd = e.target.closest('.tp-board .tp-cd');
    if (!cd || e.target.closest('a, button, input, select, textarea') || !puedeEditar(actual())) return;
    D = { el: cd, id: +cd.dataset.id, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, on: false, touch: e.pointerType !== 'mouse' };
    if (D.touch) D.timer = setTimeout(() => { if (D && !D.on) empezar(); }, 320);
});
on(window, 'pointermove', e => {
    if (!D) return;
    D.x = e.clientX; D.y = e.clientY;
    const lejos = Math.hypot(D.x - D.x0, D.y - D.y0) > 6;
    if (!D.on) {
        if (D.touch) { if (lejos) { clearTimeout(D.timer); D = null; } return; }
        if (!lejos) return;
        empezar();
    }
    e.preventDefault(); seguir();
}, { passive: false });
on(window, 'pointerup', () => { if (!D) return; clearTimeout(D.timer); if (D.on) soltar(); D = null; });
on(window, 'pointercancel', () => { if (D) { clearTimeout(D.timer); if (D.on) cancelarArrastre(); D = null; } });
on(window, 'touchmove', e => { if (D && D.on) e.preventDefault(); }, { passive: false });
function empezar() {
    const r = D.el.getBoundingClientRect();
    Object.assign(D, { on: true, dx: D.x0 - r.left, dy: D.y0 - r.top });
    D.ghost = D.el.cloneNode(true); D.ghost.classList.add('tp-cd-ghost'); D.ghost.style.width = r.width + 'px'; D.ghost.removeAttribute('tabindex');
    capas.appendChild(D.ghost);
    D.ph = document.createElement('div'); D.ph.className = 'tp-cd-ph'; D.ph.style.height = r.height + 'px';
    D.el.after(D.ph); D.el.classList.add('is-src');
    document.documentElement.classList.add('tp-dragging');
    cerrarPop(true);
    if (navigator.vibrate && D.touch) navigator.vibrate(12);
    seguir();
    D.raf = requestAnimationFrame(autoScroll);
}
function seguir() {
    D.ghost.style.transform = `translate(${D.x - D.dx}px, ${D.y - D.dy}px) rotate(2deg)`;
    const bajo = document.elementFromPoint(D.x, D.y), col = bajo && bajo.closest('.tp-board .tp-col');
    app.querySelectorAll('.tp-col.is-over').forEach(c => { if (c !== col) c.classList.remove('is-over'); });
    if (!col) { D.to = null; return; }
    col.classList.add('is-over'); D.to = +col.dataset.col;
    if (col.classList.contains('is-folded')) { D.ph.remove(); return; }
    const body = col.querySelector('.tp-col-body');
    const sig = [...body.querySelectorAll('.tp-cd:not(.is-src)')].find(c => { const r = c.getBoundingClientRect(); return D.y < r.top + r.height / 2; });
    if (sig) { if (sig.previousElementSibling !== D.ph) body.insertBefore(D.ph, sig); }
    else { const fin = body.querySelector('.tp-col-empty, .tp-ej-cta'); if (fin) body.insertBefore(D.ph, fin); else if (body.lastElementChild !== D.ph) body.appendChild(D.ph); }
}
function autoScroll() {
    if (!D || !D.on) return;
    const b = app.querySelector('.tp-board');
    if (b) {
        const r = b.getBoundingClientRect();
        if (D.x < r.left + 70) b.scrollLeft -= 14; else if (D.x > r.right - 70) b.scrollLeft += 14;
        // Las columnas no tienen scroll propio (como Notion): se desplaza la página.
        const arriba = (parseFloat(getComputedStyle(raiz).getPropertyValue('--top')) || 60) + 50, abajo = innerHeight - 60;
        if (D.y < arriba) { window.scrollBy(0, -14); seguir(); } else if (D.y > abajo) { window.scrollBy(0, 14); seguir(); }
    }
    D.raf = requestAnimationFrame(autoScroll);
}
function limpiarArrastre() {
    cancelAnimationFrame(D.raf);
    D.ghost.remove(); D.ph.remove(); D.el.classList.remove('is-src');
    app.querySelectorAll('.tp-col.is-over').forEach(c => c.classList.remove('is-over'));
    document.documentElement.classList.remove('tp-dragging');
    finArrastre = Date.now();
}
function cancelarArrastre() { if (!D) return; limpiarArrastre(); D = null; }
function soltar() {
    const t = actual(), id = D.id, to = D.to;
    let antes = null;
    if (to != null && D.ph.isConnected) {
        let s = D.ph.nextElementSibling;
        while (s && !(s.classList.contains('tp-cd') && !s.classList.contains('is-src'))) s = s.nextElementSibling;
        antes = s ? +s.dataset.id : null;
    }
    limpiarArrastre();
    if (to == null || !t) return;
    const desde = t.tarjetas.find(c => c.id === id).col;
    if (moverTarjeta(t, id, to, antes)) {
        guardarMov(t, id); pintarZona(); requestAnimationFrame(() => flash(id));
        if (desde !== to) anunciar(`Movida a «${colDe(t, to).nombre}»`);
    } else pintarZona();
}

// ── Arrastrar columnas (solo el dueño): se toman de la cabecera ──
// La columna se va moviendo en la pantalla mientras se arrastra; al soltar se guarda el orden.
let DC = null;
on(app, 'pointerdown', e => {
    if (e.button !== 0 || D) return;
    const head = e.target.closest('.tp-board .tp-col-head'), t = actual();
    if (!head || e.target.closest('button, a, input, select') || !t || !(puedeArmar(t) || moverColsNotion(t))) return;
    const col = head.closest('.tp-col');
    DC = { el: col, id: +col.dataset.col, x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, on: false, touch: e.pointerType !== 'mouse' };
    if (DC.touch) DC.timer = setTimeout(() => { if (DC && !DC.on) empezarCol(); }, 320);
});
on(window, 'pointermove', e => {
    if (!DC) return;
    DC.x = e.clientX; DC.y = e.clientY;
    const lejos = Math.hypot(DC.x - DC.x0, DC.y - DC.y0) > 6;
    if (!DC.on) {
        if (DC.touch) { if (lejos) { clearTimeout(DC.timer); DC = null; } return; }
        if (!lejos) return;
        empezarCol();
    }
    e.preventDefault(); seguirCol();
}, { passive: false });
on(window, 'pointerup', () => { if (!DC) return; clearTimeout(DC.timer); if (DC.on) soltarCol(); DC = null; });
on(window, 'pointercancel', () => { if (!DC) return; clearTimeout(DC.timer); if (DC.on) { limpiarCol(); pintarZona(); } DC = null; });
on(window, 'touchmove', e => { if (DC && DC.on) e.preventDefault(); }, { passive: false });
const colsDOM = b => [...b.children].filter(c => c.classList.contains('tp-col'));
function empezarCol() {
    const r = DC.el.getBoundingClientRect(), board = DC.el.parentElement;
    Object.assign(DC, { on: true, board, dx: DC.x0 - r.left, dy: DC.y0 - r.top, orig: colsDOM(board).map(c => +c.dataset.col) });
    DC.ghost = DC.el.cloneNode(true);
    DC.ghost.classList.add('tp-col-ghost');
    DC.ghost.style.width = r.width + 'px'; DC.ghost.style.height = Math.min(r.height, 360) + 'px';
    capas.appendChild(DC.ghost);
    board.classList.add('is-col-drag'); DC.el.classList.add('is-src-col');
    document.documentElement.classList.add('tp-dragging');
    cerrarPop(true);
    if (navigator.vibrate && DC.touch) navigator.vibrate(12);
    seguirCol();
    DC.raf = requestAnimationFrame(autoScrollCol);
}
function seguirCol() {
    DC.ghost.style.transform = `translate(${DC.x - DC.dx}px, ${DC.y - DC.dy}px) rotate(1.5deg)`;
    const b = DC.board, otras = colsDOM(b).filter(c => c !== DC.el);
    const sig = otras.find(c => { const r = c.getBoundingClientRect(); return DC.x < r.left + r.width / 2; });
    if (sig) { if (DC.el.nextElementSibling !== sig) b.insertBefore(DC.el, sig); return; }
    const fin = b.querySelector(':scope > .tp-col-new');
    if (fin) { if (fin.previousElementSibling !== DC.el) b.insertBefore(DC.el, fin); } else if (b.lastElementChild !== DC.el) b.appendChild(DC.el);
}
function autoScrollCol() {
    if (!DC || !DC.on) return;
    const r = DC.board.getBoundingClientRect();
    const antes = DC.board.scrollLeft;
    if (DC.x < r.left + 80) DC.board.scrollLeft -= 16; else if (DC.x > r.right - 80) DC.board.scrollLeft += 16;
    if (DC.board.scrollLeft !== antes) seguirCol();
    DC.raf = requestAnimationFrame(autoScrollCol);
}
function limpiarCol() {
    cancelAnimationFrame(DC.raf);
    DC.ghost.remove(); DC.el.classList.remove('is-src-col'); DC.board.classList.remove('is-col-drag');
    document.documentElement.classList.remove('tp-dragging');
    finArrastre = Date.now();
}
function soltarCol() {
    const t = actual(), nuevo = colsDOM(DC.board).map(c => +c.dataset.col), id = DC.id;
    limpiarCol();
    if (!t || nuevo.join() === DC.orig.join()) return;
    // Las columnas ocultas por un filtro se quedan donde estaban: las visibles se reparten en sus lugares.
    const vis = new Set(nuevo); let k = 0;
    t.columnas = t.columnas.map(c => (vis.has(c.id) ? colDe(t, nuevo[k++]) : c));
    tocar(t);
    if (esNotion(t)) guardarColsNotion(t, t.columnas.map(c => ({ id: c.id, oculta: !!c.oculta })));
    else llamar(() => api.put(`/${t.id}/columnas-orden`, { ids: t.columnas.map(c => c.id) })).catch(() => {});
    pintarZona();
    const pos = t.columnas.findIndex(c => c.id === id);
    anunciar(`Columna «${colDe(t, id).nombre}» movida a la posición ${pos + 1}`);
    const el = app.querySelector(`.tp-board > .tp-col[data-col="${id}"]`);
    if (el) { el.classList.add('is-flash-col'); setTimeout(() => el.classList.remove('is-flash-col'), 1200); }
}

// Soltar archivos sobre el panel de la tarjeta.
const conArchivos = e => e.dataTransfer && [...e.dataTransfer.types].includes('Files');
['dragenter', 'dragover'].forEach(ev => on(document, ev, e => {
    if (!DR || M || !conArchivos(e)) return;
    const z = DR.el.querySelector('[data-drop]'); if (!z) return;
    e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; z.classList.add('is-over');
}));
on(document, 'dragleave', e => { if (DR && !e.relatedTarget) { const z = DR.el.querySelector('[data-drop]'); if (z) z.classList.remove('is-over'); } });
on(document, 'drop', e => {
    if (!conArchivos(e)) return;
    e.preventDefault();   // nunca abrir el archivo en la pestaña
    if (!DR || M) return;
    const z = DR.el.querySelector('[data-drop]'); if (z) z.classList.remove('is-over');
    if (e.dataTransfer.files.length) subirArchivos(e.dataTransfer.files);
});

/** Va al inicio (id = 0) o a un tablero; `tarjeta` = abrir esa tarjeta al cargar. */
async function ir(id, tarjeta) {
    id = +id || 0;
    if (DR && DR.dirty && !(S.ruta.v === 'tablero' && S.ruta.id === id)) { DR.dirty = false; }
    if (S.ruta.v === 'tablero' && S.ruta.id === id && S.t && S.t.id === id) {
        if (tarjeta && S.t.tarjetas.some(x => x.id === +tarjeta)) { if (!DR || DR.cid !== +tarjeta) { cerrarTodo(); flash(+tarjeta); abrirTarjeta(+tarjeta); } }
        return;
    }
    cerrarTodo(); busqueda = ''; errorCarga = '';
    abrirTras = +tarjeta || 0;
    const r = id ? { v: 'tablero', id } : { v: 'inicio' };
    S.ruta = r;
    if (!id) { render(); scrollTo(0, 0); try { await cargarLista(); } catch (e) { if (S.ruta === r) { errorCarga = msgErr(e); render(); } } return; }
    const yaEsta = S.t && S.t.id === id;   // recién creado: ya lo tenemos
    if (!yaEsta) { S.t = null; cargando = true; render(); }
    try { const d = await api.get(`/${id}`); if (S.ruta !== r) return; S.t = null; S.t = adaptar(d); }
    catch (e) { if (S.ruta !== r) return; S.t = null; errorCarga = e && (e.status === 404 || e.status === 403) ? '' : msgErr(e); }
    cargando = false; render(); scrollTo(0, 0);
}
return {
    ir,
    /** ¿Hay cambios sin guardar en «Datos»? (para avisar al salir de la pantalla) */
    sucio: () => !!(DR && DR.dirty),
    destruir() {
        clearInterval(poll); clearTimeout(prefTm);
        if (Object.keys(prefPend).length && S.t) { const b = prefPend, tid = S.t.id; prefPend = {}; api.put(`/${tid}/preferencias`, b).catch(() => {}); }
        if (D) cancelarArrastre();
        quitar.forEach(f => f()); quitar.length = 0;
        urls.forEach(u => URL.revokeObjectURL(u)); urls.clear();
        document.documentElement.classList.remove('tp-locked', 'tp-dragging');
        raiz.innerHTML = '';
    },
};
}
